import { useHistory, Redirect, useRouteMatch, Link as Link$1, NavLink, Switch, Route, BrowserRouter } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { gql, useQuery, useLazyQuery, createHttpLink, fromPromise, ApolloLink, ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import { useMatomo, createInstance, MatomoProvider } from '@jonkoops/matomo-tracker-react';
import { Helmet } from 'react-helmet';
import '@aws-amplify/ui-react/styles.css';
import { configureAmplify } from '@eir/aws-authorization';
import { useAlert, AlertProvider, Alert } from '@eir/alert';
import { useNotification, NotificationProvider, Notifications } from '@eir/notifications';
import { createContext, useReducer, useContext, useState, useRef, useEffect, forwardRef, createElement } from 'react';
import { API, Auth } from 'aws-amplify';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon, NamedItem, Section as Section$1, GridTableCell, Tag, GridTable as GridTable$1, IconButton, EditableContent, Button as Button$3, ListItem, ValueSelector, TabContent, ButtonsWrapper as ButtonsWrapper$3, CopyText, ContextMenu } from '@eir/ui';
import { formatDrivingDistance, formatDateTime, formatDate, useQueryParam, useClickOutside, addDays, dateDiff } from '@eir/utils';
import PropTypes from 'prop-types';
import { isMacOs } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faCalendarAlt, faExclamationCircle, faHourglassHalf, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var ledgerContext = /*#__PURE__*/createContext();

var CLEAR_OVERLAY_CHILD_NODES = 'CLEAR_OVERLAY_CHILD_NODES';
var GET_LEDGER_BALANCE = 'GET_LEDGER_BALANCE';
var SET_NAVIGATION_IS_OPEN = 'SET_NAVIGATION_IS_OPEN';
var SET_OVERLAY_CHILD_NODES = 'SET_OVERLAY_CHILD_NODES';
var SET_SHOW_REFUND = 'SET_SHOW_REFUND';

var LedgerReducer = (function (state, action) {
  switch (action.type) {
    case GET_LEDGER_BALANCE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        ledgerBalance: action.payload
      });

    case SET_SHOW_REFUND:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showRefund: action.payload
      });

    default:
      return state;
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

const ledgerService = {
    abort: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `ledger/abort/${id}`, {});
        });
    },
    close: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `ledger/close/${id}`, {});
        });
    },
    reopen: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `ledger/reopen/${id}`, {});
        });
    },
    reconcile: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `ledger/reconcile/${id}`, {});
        });
    },
    refund: function (id, index, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    amount,
                },
            };
            return API.post('KrakenAPI', `ledger/refund/${id}/${index}`, myInit);
        });
    },
    transferMandate: function (sourceLedgerId, destinationLedgerId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `ledger/transfer/mandates/${sourceLedgerId}/${destinationLedgerId}`, {});
        });
    },
    refundPayment: function (id, paymentIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.post('KrakenAPI', `ledger/refund/payment/${id}/${paymentIndex}`, {});
        });
    },
    retryCollect: function (id, paymentIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.post('KrakenAPI', `magpie/collect/${id}/${paymentIndex}`, {});
        });
    },
    log: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `ledger/history/${id}`, {});
        });
    },
    get: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `ledger/${id}`, {});
        });
    },
    mandateStatus: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `ledger/mandate-status/${id}`, {});
        });
    },
};

var LedgerState = function LedgerState(props) {
  var initaialState = {
    ledgerBalance: null,
    showRefund: false
  };

  var _useReducer = useReducer(LedgerReducer, initaialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var getLedgerBalance = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ledgerId) {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ledgerService.reconcile(ledgerId);

            case 3:
              data = _context.sent;
              dispatch({
                type: GET_LEDGER_BALANCE,
                payload: data
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              dispatch({
                type: GET_LEDGER_BALANCE,
                payload: _context.t0.response.data
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function getLedgerBalance(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var setShowRefund = function setShowRefund(show) {
    return dispatch({
      type: SET_SHOW_REFUND,
      payload: show
    });
  };

  return /*#__PURE__*/jsx(ledgerContext.Provider, {
    value: {
      ledgerBalance: state.ledgerBalance,
      showRefund: state.showRefund,
      getLedgerBalance: getLedgerBalance,
      setShowRefund: setShowRefund
    },
    children: props.children
  });
};

var navigationContext = /*#__PURE__*/createContext();

var NavigationReducer = (function (state, action) {
  switch (action.type) {
    case SET_NAVIGATION_IS_OPEN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isOpen: action.payload
      });

    default:
      return state;
  }
});

var NavigationState = function NavigationState(props) {
  var initaialState = {
    isOpen: false
  };

  var _useReducer = useReducer(NavigationReducer, initaialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var setIsOpen = function setIsOpen(isOpen) {
    return dispatch({
      type: SET_NAVIGATION_IS_OPEN,
      payload: isOpen
    });
  };

  return /*#__PURE__*/jsx(navigationContext.Provider, {
    value: {
      isOpen: state.isOpen,
      setIsOpen: setIsOpen
    },
    children: props.children
  });
};

var OverlayContext = /*#__PURE__*/createContext();

var overlayReducer = function overlayReducer(state, action) {
  switch (action.type) {
    case CLEAR_OVERLAY_CHILD_NODES:
      return {
        childNodes: null
      };

    case SET_OVERLAY_CHILD_NODES:
      return {
        childNodes: action.payload
      };

    default:
      return state;
  }
};

var OverlayProvider = function OverlayProvider(_ref) {
  var children = _ref.children;
  var initialState = {
    childNodes: null
  };

  var _useReducer = useReducer(overlayReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var clearChildNodes = function clearChildNodes(nodes) {
    return dispatch({
      type: CLEAR_OVERLAY_CHILD_NODES,
      payload: nodes
    });
  };

  var setChildNodes = function setChildNodes(nodes) {
    return dispatch({
      type: SET_OVERLAY_CHILD_NODES,
      payload: nodes
    });
  };

  return /*#__PURE__*/jsx(OverlayContext.Provider, {
    value: {
      childNodes: state.childNodes,
      clearChildNodes: clearChildNodes,
      setChildNodes: setChildNodes
    },
    children: children
  });
};

var useOverlay = function useOverlay() {
  return useContext(OverlayContext);
};

var RightPanelContext = /*#__PURE__*/createContext();

var RightPanelProvider = function RightPanelProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({
    show: false,
    content: {
      header: '',
      body: null
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var showPanel = function showPanel() {
    return setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        show: true
      });
    });
  };

  var hidePanel = function hidePanel() {
    return setState({
      show: false,
      content: {
        header: '',
        body: null
      }
    });
  };

  var setContent = function setContent(header, body) {
    setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        content: {
          header: header,
          body: body
        }
      });
    });
  };

  return /*#__PURE__*/jsx(RightPanelContext.Provider, {
    value: {
      content: state.content,
      show: state.show,
      hidePanel: hidePanel,
      setContent: setContent,
      showPanel: showPanel
    },
    children: children
  });
};

var useRightPanel = function useRightPanel() {
  return useContext(RightPanelContext);
};

var _templateObject$1k;
var GlobalStyle = createGlobalStyle(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteral(["\n\n  * {\n    outline: none;\n    box-sizing: border-box;\n    margin: 0;\n  }\n\n  html, input, select, textarea {\n    font-family: Roboto;\n    font-weight: 300;\n    color: #353d53;\n  }\n\n  body {\n    background-color: #f5f5f5; \n    line-height: 1.3;\n  }\n  \n  h1, h2, h3, h4 {\n    font-weight: 500;\n  }\n\n  h1 {\n    font-size: 2rem;\n  margin-bottom: 1.5rem\n  }\n\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type=number] {\n    text-align: right;\n    -moz-appearance: textfield;\n  }\n\n"])));

var _templateObject$1j;
var GET_CUSTOMER$1 = gql(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteral(["\n  query customer($holderId: uuid!) {\n    hasura_company_records(where: { id: { _eq: $holderId } }) {\n      address\n      city\n      email\n      id\n      name\n      phone\n      post_code\n    }\n    hasura_people(where: { id: { _eq: $holderId } }) {\n      address\n      city\n      email\n      first_name\n      id\n      last_name\n      postal_code\n      social_security\n      telephone\n    }\n  }\n"])));

var useCustomer = function useCustomer(holderId) {
  return useQuery(GET_CUSTOMER$1, {
    variables: {
      holderId: holderId
    }
  });
};

var _templateObject$1i;
var GET_FAILED_PAYMENTS = gql(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteral(["\n  query failed_payments {\n    hasura_ledger_payments(\n      where: {\n        hasura_ledger: { status: { _eq: \"Open\" } }\n        status: { _eq: \"Failed\" }\n      }\n      limit: 1000\n      order_by: { hasura_ledger: { last_updated: asc } }\n    ) {\n      additional_info\n      hasura_ledger {\n        hasura_ledger_mandates(where: { is_active: { _eq: true } }) {\n          payment_provider\n        }\n        hasura_policies {\n          hasura_person {\n            email\n            first_name\n            last_name\n            telephone\n          }\n          id\n          object_name\n          policy_number\n          product_name\n        }\n        last_updated\n        quote_id\n        status\n      }\n      index\n      ledger_id\n      scheduled_collection_date\n      status\n      total\n    }\n  }\n"])));
var useFailedPayments = (function () {
  return useQuery(GET_FAILED_PAYMENTS);
});

var _templateObject$1h;
var GET_FAILED_REFUNDS = gql(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteral(["\n  query failed_refunds {\n    hasura_ledger_payments(\n      where: { status: { _eq: \"RefundFailed\" } }\n      limit: 1000\n      order_by: { hasura_ledger: { last_updated: asc } }\n    ) {\n      additional_info\n      hasura_ledger {\n        hasura_ledger_mandates(where: { is_active: { _eq: true } }) {\n          payment_provider\n        }\n        hasura_policies {\n          hasura_person {\n            email\n            first_name\n            last_name\n            telephone\n          }\n          id\n          object_name\n          policy_number\n          product_name\n        }\n        last_updated\n        quote_id\n        status\n      }\n      index\n      ledger_id\n      scheduled_collection_date\n      status\n      total\n    }\n  }\n"])));
var useFailedRefunds = (function () {
  return useQuery(GET_FAILED_REFUNDS);
});

var _templateObject$1g;
var GET_HOLDER_POLICIES = gql(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteral(["\n  query quotes($holderId: uuid!) {\n    hasura_policy_insurance_holders(\n      where: {\n        _or: [\n          { company_record_id: { _eq: $holderId } }\n          { person_record_id: { _eq: $holderId } }\n        ]\n      }\n    ) {\n      policy {\n        cover_level\n        end_date\n        id\n        object_name\n        policy_number\n        start_date\n        status\n        period_written_premium\n      }\n    }\n  }\n"])));

var useHolderPolicies = function useHolderPolicies(holderId) {
  return useQuery(GET_HOLDER_POLICIES, {
    variables: {
      holderId: holderId
    }
  });
};

var _templateObject$1f;
var GET_HOLDER_QUOTES = gql(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteral(["\n  query quotes($holderId: uuid!) {\n    hasura_quote_insurance_holders(\n      where: {\n        _or: [\n          { company_record_id: { _eq: $holderId } }\n          { person_record_id: { _eq: $holderId } }\n        ]\n      }\n    ) {\n      quote {\n        cover_level\n        created\n        id\n        object_name\n        status\n      }\n    }\n  }\n"])));

var useHolderQuotes = function useHolderQuotes(holderId) {
  return useQuery(GET_HOLDER_QUOTES, {
    variables: {
      holderId: holderId
    }
  });
};

var _templateObject$1e;
var GET_MANDATE_SOURCE = gql(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteral(["\n  query polices($userId: uuid!, $destinationLedgerId: uuid!) {\n    hasura_policies(\n      where: {\n        hasura_ledger: { id: { _neq: $destinationLedgerId } }\n        hasura_person: { id: { _eq: $userId } }\n      }\n    ) {\n      cover_level\n      hasura_ledger {\n        hasura_ledger_mandates(where: { is_active: { _eq: true } }) {\n          is_active\n          signed_and_approved\n          payment_provider\n          added_at\n        }\n        id\n      }\n      id\n      object_name\n      policy_number\n      product_name\n      status\n    }\n  }\n"])));

var useMandateSource = function useMandateSource(userId, destinationLedgerId) {
  return useQuery(GET_MANDATE_SOURCE, {
    variables: {
      userId: userId,
      destinationLedgerId: destinationLedgerId
    }
  });
};

var _templateObject$1d;
var GET_MISSING_MANDATES = gql(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteral(["\n  query missing_mandates {\n    hasura_ledgers(\n      where: {\n        _not: { hasura_ledger_mandates: { is_active: { _eq: true } } }\n        hasura_policies: { id: { _is_null: false }, status: { _eq: \"Active\" } }\n        hasura_ledger_payments: { status: { _in: [\"Failed\", \"Unprocessed\"] } }\n      }\n      limit: 100\n    ) {\n      id\n      hasura_policies {\n        id\n        policy_number\n        object_name\n        hasura_policy_insurance_holders {\n          company_record {\n            name\n            phone\n            email\n          }\n          person_holder {\n            email\n            first_name\n            last_name\n            telephone\n          }\n        }\n      }\n    }\n  }\n"])));
var useMissingMandates = (function () {
  return useQuery(GET_MISSING_MANDATES);
});

var _templateObject$1c;
var GET_PAYMENTS = gql(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteral(["\n  query payments(\n    $offset: Int\n    $limit: Int\n    $condition: hasura_ledger_payments_bool_exp!\n  ) {\n    hasura_ledger_payments(where: $condition, offset: $offset, limit: $limit) {\n      additional_info\n      hasura_ledger {\n        hasura_ledger_mandates(limit: 1, order_by: { index: desc }) {\n          is_active\n          payment_provider\n        }\n        hasura_policies {\n          id\n          policy_number\n          status\n        }\n        hasura_quote {\n          cover_level\n          hasura_person {\n            first_name\n            email\n            last_name\n            social_security\n            telephone\n            user_id\n          }\n          object_name\n          product_name\n        }\n        status\n      }\n      index\n      ledger_id\n      period_end\n      period_start\n      scheduled_collection_date\n      status\n      total\n    }\n    payment_statuses: hasura_ledger_payments(distinct_on: status) {\n      status\n    }\n    hasura_ledger_payments_aggregate(where: $condition) {\n      aggregate {\n        count(columns: ledger_id)\n      }\n    }\n    products: hasura_quotes(distinct_on: product_name) {\n      product_name\n    }\n    policy_statuses: hasura_policies(distinct_on: status) {\n      status\n    }\n    payment_providers: hasura_ledger_mandates(distinct_on: payment_provider) {\n      payment_provider\n    }\n  }\n"])));
var usePayments = (function (offset, limit, condition) {
  return useQuery(GET_PAYMENTS, {
    variables: {
      offset: offset,
      limit: limit,
      condition: condition
    },
    notifyOnNetworkStatusChange: true
  });
});

var _templateObject$1b;
var POLICY$1 = gql(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteral(["\n  query policy_detail($policyId: uuid!) {\n    hasura_policy_insurance_holders(\n      where: { policy: { id: { _eq: $policyId } } }\n    ) {\n      company_record {\n        address\n        city\n        id\n        name\n        reference\n        email\n        phone\n        post_code\n      }\n      person_holder {\n        address\n        city\n        email\n        first_name\n        id\n        last_name\n        postal_code\n        social_security\n        telephone\n        notes {\n          created\n          note\n          person_id\n          person_note_key\n        }\n      }\n      policy {\n        cover_level\n        created\n        end_date\n        hasura_ledger {\n          hasura_ledger_mandates {\n            added_at\n            attributes\n            id\n            index\n            merchant_reference\n            is_active\n            payment_provider\n            signed_and_approved\n            revoked\n          }\n        }\n        hasura_policy_answers(where: { key: { _nlike: \"DW_%\" } }) {\n          key\n          period_index\n          value\n        }\n        hasura_policy_coverage_periods(\n          where: { period_status: { _eq: \"Active\" } }\n          order_by: { period_index: asc, cover_id: asc }\n        ) {\n          cover_id\n          cover_name\n          day_premium\n          day_tax\n          period_end\n          period_index\n          period_premium\n          period_start\n          period_tax\n          timestamp\n        }\n        hasura_quote {\n          created\n        }\n        id\n        is_marked_for_termination\n        ledger_id\n        object_name\n        period_written_premium\n        policy_number\n        previous_policy_id\n        product_name\n        status\n        start_date\n      }\n    }\n  }\n"])));

var useLazyPolicy = function useLazyPolicy() {
  return useLazyQuery(POLICY$1);
};

var usePolicy = function usePolicy(policyId) {
  return useQuery(POLICY$1, {
    variables: {
      policyId: policyId
    }
  });
};

var _templateObject$1a;
var PAYMENT_INFO = gql(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteral(["\n  query payment_info($ledgerId: uuid!) {\n    hasura_policy_insurance_holders(\n      where: { policy: { hasura_ledger: { id: { _eq: $ledgerId } } } }\n    ) {\n      company_record {\n        address\n        city\n        id\n        name\n        reference\n        email\n        phone\n        post_code\n      }\n      holder_type\n      person_holder {\n        email\n        first_name\n        id\n        last_name\n        postal_code\n        social_security\n        telephone\n      }\n      policy {\n        cover_level\n        id\n        object_name\n        product_name\n      }\n    }\n    hasura_ledgers(where: { id: { _eq: $ledgerId } }) {\n      hasura_ledger_payments(order_by: { index: asc }) {\n        additional_info\n        amount_refunded\n        collected_amount\n        fee\n        index\n        ledger_id\n        pay_date\n        period_duration\n        period_end\n        period_start\n        premium\n        scheduled_collection_date\n        status\n        tax\n        total\n      }\n      quote_id\n      status\n    }\n  }\n"])));

var usePaymentInfo = function usePaymentInfo(ledgerId) {
  return useQuery(PAYMENT_INFO, {
    variables: {
      ledgerId: ledgerId
    }
  });
};

var _templateObject$19;
var QUOTE_DETAILS = gql(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteral(["\n  query quote_detail($quoteId: uuid!) {\n    hasura_quote_insurance_holders(\n      where: { quote: { id: { _eq: $quoteId } } }\n    ) {\n      company_record {\n        address\n        city\n        id\n        name\n        reference\n        email\n        phone\n        post_code\n      }\n      person_holder {\n        email\n        first_name\n        last_name\n        postal_code\n        social_security\n        telephone\n      }\n      quote {\n        cover_level\n        created\n        end_date\n        failed_filters\n        hasura_quote_answers(where: { key: { _nlike: \"DW_%\" } }) {\n          key\n          value\n        }\n        hasura_quotes_cover_premiums(order_by: { cover_id: asc }) {\n          cover_id\n          hasura_quote {\n            created\n            end_date\n            start_date\n          }\n          name\n          period_premium\n          period_tax\n        }\n        id\n        object_name\n        product_name\n        renewal_for\n        start_date\n        status\n        type\n      }\n    }\n  }\n"])));

var useLazyQuoteDetailsHooks = function useLazyQuoteDetailsHooks() {
  return useLazyQuery(QUOTE_DETAILS);
};

var useQuoteDetailsHooks = function useQuoteDetailsHooks(quoteId) {
  return useQuery(QUOTE_DETAILS, {
    variables: {
      quoteId: quoteId
    }
  });
};

var _templateObject$18;
var QUOTE_LEDGERS = gql(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteral(["\n  query quote_ledgers($quoteId: uuid!) {\n    hasura_ledgers(\n      where: {\n        quote_id: { _eq: $quoteId }\n        status: { _in: [\"Open\", \"Initialized\", \"Closed\"] }\n      }\n    ) {\n      id\n      last_updated\n      status\n    }\n  }\n"])));

var useQuoteLedgers = function useQuoteLedgers(quoteId) {
  return useQuery(QUOTE_LEDGERS, {
    variables: {
      quoteId: quoteId
    }
  });
};

var _templateObject$17;
var RECENT$1 = gql(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n  query latest_activites {\n    hasura_policies(limit: 20, order_by: { created: desc }) {\n      cover_level\n      created\n      end_date\n      hasura_policy_coverage_periods(\n        where: { period_status: { _eq: \"Active\" } }\n        distinct_on: period_start\n      ) {\n        period_start\n      }\n      hasura_policy_insurance_holders {\n        person_holder {\n          email\n          first_name\n          last_name\n          telephone\n        }\n        company_record {\n          email\n          name\n          phone\n        }\n      }\n      id\n      next_policy_id\n      object_name\n      policy_number\n      previous_policy_id\n      product_name\n      start_date\n      status\n    }\n    hasura_quotes(limit: 20, order_by: { created: desc }) {\n      created\n      end_date\n      hasura_quote_answers(where: { key: { _eq: \"reference\" } }) {\n        value\n      }\n      hasura_quote_insurance_holders {\n        company_record {\n          email\n          name\n          phone\n        }\n        person_holder {\n          email\n          first_name\n          last_name\n          telephone\n        }\n      }\n      id\n      object_name\n      product_name\n      start_date\n      status\n    }\n  }\n"])));

var useRecentActivites = function useRecentActivites() {
  return useQuery(RECENT$1);
};

var _templateObject$16;
var GET_CUSTOMER = gql(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral(["\n  query people(\n    $wherePeople: hasura_people_bool_exp\n    $whereCompanies: hasura_company_records_bool_exp\n    $limit: Int\n  ) {\n    hasura_company_records(where: $whereCompanies) {\n      address\n      city\n      email\n      id\n      name\n      phone\n      post_code\n      reference\n    }\n    hasura_people(where: $wherePeople, limit: $limit) {\n      id\n      user_id\n      first_name\n      last_name\n      social_security\n      postal_code\n      telephone\n      email\n    }\n  }\n"])));

var useSearchCustomers = function useSearchCustomers() {
  return useLazyQuery(GET_CUSTOMER);
};

var _templateObject$15;
var GET_POLICIES = gql(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral(["\n  query policy_inventory($where: hasura_policy_insurance_holders_bool_exp) {\n    hasura_policy_insurance_holders(\n      where: $where\n      order_by: { hasura_policy: { created: desc } }\n      limit: 100\n    ) {\n      company_record {\n        email\n        name\n        phone\n      }\n      person_holder {\n        email\n        first_name\n        last_name\n        telephone\n      }\n      policy {\n        end_date\n        hasura_policy_coverage_periods(\n          where: { period_status: { _eq: \"Active\" } }\n          distinct_on: period_start\n        ) {\n          period_start\n        }\n        id\n        next_policy_id\n        object_name\n        period_written_premium\n        policy_number\n        product_name\n        start_date\n        status\n      }\n    }\n    hasura_policies(distinct_on: status) {\n      status\n    }\n  }\n"])));

var useSearchPolicies = function useSearchPolicies() {
  return useLazyQuery(GET_POLICIES);
};

var _templateObject$14;
var GET_QUOTES = gql(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  query quote_inventory($where: hasura_quote_insurance_holders_bool_exp) {\n    hasura_quote_insurance_holders(\n      where: $where\n      order_by: { quote: { created: desc } }\n      limit: 100\n    ) {\n      company_record {\n        email\n        name\n        phone\n      }\n      person_holder {\n        email\n        first_name\n        last_name\n        telephone\n        social_security\n      }\n      quote {\n        cover_level\n        created\n        end_date\n        hasura_quote_answers(where: { key: { _eq: \"reference\" } }) {\n          value\n        }\n        id\n        object_name\n        product_name\n        hasura_quotes_cover_premiums {\n          day_premium\n          day_tax\n          period_premium\n          period_tax\n        }\n        status\n        start_date\n      }\n    }\n  }\n"])));

var useSearchQuotes = function useSearchQuotes() {
  return useLazyQuery(GET_QUOTES);
};

var _templateObject$13;
var UPCOMING_RENEWALS$1 = gql(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n  query policies($maxEndDate: date!) {\n    hasura_policy_insurance_holders(\n      where: {\n        policy: {\n          end_date: { _lte: $maxEndDate }\n          status: { _eq: \"Active\" }\n          next_policy_id: { _is_null: true }\n        }\n      }\n      order_by: { policy: { end_date: asc } }\n    ) {\n      company_record {\n        email\n        name\n        phone\n      }\n      person_holder {\n        email\n        first_name\n        last_name\n        telephone\n      }\n      policy {\n        cover_level\n        end_date\n        hasura_ledger {\n          hasura_ledger_mandates(where: { is_active: { _eq: true } }) {\n            payment_provider\n          }\n        }\n        hasura_policy_coverage_periods {\n          day_premium\n          day_tax\n        }\n        id\n        policy_number\n        product_name\n        object_name\n        start_date\n        is_marked_for_termination\n      }\n    }\n  }\n"])));

var useUpcomingRenewals = function useUpcomingRenewals(maxEndDate) {
  return useQuery(UPCOMING_RENEWALS$1, {
    variables: {
      maxEndDate: maxEndDate
    }
  });
};

var _templateObject$12;

var Card$1 = function Card(_ref) {
  var children = _ref.children,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      onClick = _ref.onClick,
      _ref$isCreatingNew = _ref.isCreatingNew,
      isCreatingNew = _ref$isCreatingNew === void 0 ? false : _ref$isCreatingNew;
  return /*#__PURE__*/jsx(CardContainer, {
    onClick: onClick,
    transparent: transparent,
    isCreatingNew: isCreatingNew,
    children: children
  });
};

Card$1.propTypes = {
  children: PropTypes.node.isRequired,
  isCreatingNew: PropTypes.bool,
  onClick: PropTypes.func
};
var CardContainer = styled.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  background-color: #fff;\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 0.0625rem solid rgb(222, 222, 222);\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_ref2) {
  var isCreatingNew = _ref2.isCreatingNew;
  return isCreatingNew ? 'inherit' : 'pointer';
}, function (_ref3) {
  var isCreatingNew = _ref3.isCreatingNew;
  return isCreatingNew ? '0.5' : '1';
}, function (_ref4) {
  var isCreatingNew = _ref4.isCreatingNew;
  return isCreatingNew ? '#fff' : '#fdfdfd';
}, function (_ref5) {
  var isCreatingNew = _ref5.isCreatingNew;
  return isCreatingNew ? 'none' : '0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.2)';
});

var CREATE_QUOTE = '/create-quote/:productName';
var CREATE_QUOTE_NEW = '/create-quote-new/:productName';
var CREATE_QUOTE_SELECT_PRODUCT = '/create-quote';
var CREATE_QUOTE_SELECT_PRODUCT_NEW = '/create-quote-new';
var CUSTOMERS = '/customers';
var FAILED_REFUNDS = '/failed-refunds';
var CUSTOMER = '/customers/:customerId';
var LEDGER = '/ledgers/:ledgerId';
var LEDGERS = '/ledgers';
var MISSING_MANDATES = '/missing-mandates';
var PAYMENTS = '/payments';
var POLICIES = '/policies';
var POLICY = '/policies/:policyId';
var QUOTES = '/quotes';
var QUOTE = '/quotes/:quoteId';
var RECENT = '/recent';
var TASKS = '/tasks';
var UPCOMING_RENEWALS = '/upcoming-renewals';
var UPCOMING_REFUNDS = '/upcoming-refunds';

var _templateObject$11, _templateObject2$z, _templateObject3$s, _templateObject4$k;

({
  isCreateingNew: PropTypes.bool,
  companyPolicyHolder: PropTypes.shape({
    company_record: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string.isRequired,
      phone: PropTypes.string
    }).isRequired,
    policy: PropTypes.shape({
      cover_level: PropTypes.string,
      created: PropTypes.string,
      end_date: PropTypes.string,
      id: PropTypes.string,
      object_name: PropTypes.string,
      period_written_premium: PropTypes.number,
      policy_number: PropTypes.string,
      product_name: PropTypes.string,
      start_date: PropTypes.string,
      status: PropTypes.string
    }).isRequired
  }).isRequired
});
styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n"])));
styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.span(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n  color: #7b7d8c;\n  font-weight: 500;\n"])));

var _templateObject$10, _templateObject2$y, _templateObject3$r, _templateObject4$j;

({
  companyQuoteHolder: PropTypes.shape({
    company_record: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string.isRequired,
      phone: PropTypes.string
    }).isRequired,
    quote: PropTypes.shape({
      cover_level: PropTypes.string,
      created: PropTypes.string,
      end_date: PropTypes.string,
      hasura_quote_answers: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired
      })),
      id: PropTypes.string,
      object_name: PropTypes.string,
      product_name: PropTypes.string,
      status: PropTypes.string,
      start_date: PropTypes.string
    }).isRequired
  }).isRequired,
  isCreateingNew: PropTypes.bool
});
var InfoContainer$1 = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  grid-gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled(InfoContainer$1)(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.h3(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));

const ContentContainer = styled.div `
  margin: auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 100rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 75rem) {
    width: calc(100vw - 20rem);
  }
`;

var _templateObject$$, _templateObject2$x;

var PrimaryButton = function PrimaryButton(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  var colors = {
    default: {
      fontColor: '#fff',
      backgroundColor: '#fc8e49',
      hover: {
        fontColor: '#fff',
        backgroundColor: '#fc7522',
        shadow: 'rgba(241, 83, 4, 0.3) 0 1px 3px 1px'
      }
    },
    question: {
      fontColor: '#fff',
      backgroundColor: '#3a58de',
      hover: {
        fontColor: '#fff',
        backgroundColor: '#2343d1',
        shadow: 'rgba(30, 56, 174, 0.3) 0 1px 3px 1px'
      }
    },
    success: {
      fontColor: '#fff',
      backgroundColor: '#42c67f',
      hover: {
        fontColor: '#fff',
        backgroundColor: '#34ad6c',
        shadow: 'rgba(42, 141, 88, 0.3) 0 1px 3px 1px'
      }
    },
    warning: {
      fontColor: '#fff',
      backgroundColor: '#ff6f6f',
      hover: {
        fontColor: '#fff',
        backgroundColor: '#ff4747',
        shadow: 'rgba(255, 31, 31, 0.3) 0 1px 3px 1px'
      }
    }
  };
  var sizes = {
    default: {
      fontSize: '1rem',
      padding: '0.5rem 1.2rem'
    },
    small: {
      fontSize: '0.8rem',
      padding: '0.3rem 0.625rem'
    }
  };
  return disabled ? /*#__PURE__*/jsx(DisabledButton$1, {
    color: colors[color],
    size: sizes[size],
    children: children
  }) : /*#__PURE__*/jsx(Button$2, {
    type: type,
    disabled: disabled,
    color: colors[color],
    size: sizes[size],
    onClick: onClick,
    children: children
  });
};

PrimaryButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['default', 'warning', 'success', 'question']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['default', 'large', 'small']),
  type: PropTypes.string
};
var Button$2 = styled.button(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  display: block;\n  outline: none;\n  border: 0;\n  padding: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  transition: all 0.15s ease;\n  color: ", ";\n  background-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_ref2) {
  var size = _ref2.size;
  return size.padding;
}, function (_ref3) {
  var size = _ref3.size;
  return size.fontSize;
}, function (_ref4) {
  var color = _ref4.color;
  return color.fontColor;
}, function (_ref5) {
  var color = _ref5.color;
  return color.backgroundColor;
}, function (_ref6) {
  var color = _ref6.color;
  return color.hover.fontColor;
}, function (_ref7) {
  var color = _ref7.color;
  return color.hover.backgroundColor;
}, function (_ref8) {
  var color = _ref8.color;
  return color.hover.shadow;
});
var DisabledButton$1 = styled(Button$2)(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n  pointer-events: none;\n  opacity: 0.6;\n"])));

var _templateObject$_, _templateObject2$w, _templateObject3$q, _templateObject4$i, _templateObject5$8, _templateObject6$5;

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position,
      onClick = _ref.onClick;
  var toolTipText = useRef();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      textWidth = _useState2[0],
      setTextWidth = _useState2[1];

  useEffect(function () {
    toolTipText.current && setTextWidth(toolTipText.current.clientWidth);
  }, []);

  var Text = function Text() {
    switch (position) {
      case 'bottom':
        return /*#__PURE__*/jsx(TooltipTextBottom, {
          ref: toolTipText,
          width: textWidth,
          children: title
        });

      case 'left':
        return /*#__PURE__*/jsx(TooltipTextLeft, {
          ref: toolTipText,
          children: title
        });

      case 'right':
        return /*#__PURE__*/jsx(TooltipTextRight, {
          ref: toolTipText,
          children: title
        });

      case 'top':
        return /*#__PURE__*/jsx(TooltipTextTop, {
          ref: toolTipText,
          width: textWidth,
          children: title
        });

      default:
        return /*#__PURE__*/jsx(TooltipTextTop, {
          ref: toolTipText,
          width: textWidth,
          children: title
        });
    }
  };

  return /*#__PURE__*/jsxs(TooltipContainer, {
    onClick: onClick,
    children: [children, /*#__PURE__*/jsx(Text, {})]
  });
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  position: PropTypes.string,
  title: PropTypes.string.isRequired
};
var TooltipContainer = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var TooltipText = styled.span(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  visibility: hidden;\n  opacity: 0;\n  background-color: #000;\n  font-size: 0.8rem;\n  color: #ccc;\n  padding: 0.5rem;\n  position: absolute;\n  width: 20rem;\n  max-width: 20rem;\n  border-radius: 0.5rem;\n  transition: all 0.3s;\n  // white-space: nowrap;\n  word-break: break-all;\n\n  &:after {\n    content: '';\n    position: absolute;\n    border-style: solid;\n  }\n\n  ", ":hover & {\n    transition-delay: 0.5s;\n    visibility: visible;\n    opacity: 1;\n  }\n"])), TooltipContainer);
var TooltipTextLeft = styled(TooltipText)(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n  top: -50%;\n  right: 100%;\n  margin-right: 0.5rem;\n\n  &:after {\n    top: 50%;\n    left: 100%;\n    margin-top: -0.3125rem;\n    border-width: 0.3125rem;\n    border-color: transparent transparent transparent #000;\n  }\n"])));
var TooltipTextRight = styled(TooltipText)(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n  top: -50%;\n  left: 100%;\n  margin-left: 0.5rem;\n\n  &:after {\n    top: 50%;\n    right: 100%;\n    margin-top: -0.3125rem;\n    border-width: 0.3125rem;\n    border-color: transparent #000 transparent transparent;\n  }\n"])));
var TooltipTextBottom = styled(TooltipText)(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n  top: 100%;\n  left: 50%;\n  margin-top: 0.5rem;\n  margin-left: -5rem;\n\n  &:after {\n    bottom: 100%;\n    left: 50%;\n    margin-left: -0.3125rem;\n    border-width: 0.3125rem;\n    border-color: transparent transparent #000 transparent;\n  }\n"])));
var TooltipTextTop = styled(TooltipText)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n  bottom: 100%;\n  margin-bottom: 0.5rem;\n  left: 50%;\n  // margin-left: -5rem;\n  margin-left: ", ";\n\n  &:after {\n    top: 100%;\n    left: 50%;\n    margin-left: -0.3125rem;\n    border-width: 0.3125rem;\n    border-color: #000 transparent transparent transparent;\n  }\n"])), function (_ref2) {
  var width = _ref2.width;
  return "-".concat(width / 2, "px");
});

var _templateObject$Z, _templateObject2$v;

var CopyLink = function CopyLink(_ref) {
  var url = _ref.url;
  var inputRef = useRef();

  var copyToClipboard = function copyToClipboard(e) {
    inputRef.current.select();
    document.execCommand('copy');
    e.target.focus();
  };

  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsx(LinkInput, {
      readOnly: true,
      ref: inputRef,
      value: url
    }), /*#__PURE__*/jsx(Tooltip, {
      title: "Copy url",
      children: /*#__PURE__*/jsx(PrimaryButton, {
        onClick: copyToClipboard,
        children: /*#__PURE__*/jsx(Icon, {
          name: "faLink",
          color: "#fff"
        })
      })
    })]
  });
};

CopyLink.propTypes = {
  url: PropTypes.string.isRequired
};
var Container = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var LinkInput = styled.input(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n  flex: 1;\n  border: 0.0625rem solid #dedede;\n  border-right: 0;\n  outline: 0;\n"])));

const quoteService = {
    accept: function (id, withInvoiceMandate = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = withInvoiceMandate
                ? {
                    queryStringParameters: {
                        withInvoiceMandate: 'true',
                    },
                }
                : {};
            return API.put('KrakenAPI', `quote/accept/${id}`, myInit);
        });
    },
    acceptMta: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `quote/mta/accept/${id}`, {});
        });
    },
    create: function (body) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body,
            };
            return API.post('KrakenAPI', 'quote', myInit);
        });
    },
    discard: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `quote/discard/${id}`, {});
        });
    },
    mtaDifference: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `quote/mta/calculate/difference/${id}`, {});
        });
    },
    log: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `quote/history/${id}`, {});
        });
    },
    metadata: function (product, version) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `quote/request/metadata/${product}/${version}`, {});
        });
    },
    products: function () {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', 'quote/products', {});
        });
    },
};

var _templateObject$Y;

var ItemContainer = function ItemContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Div, {
    children: children
  });
};

ItemContainer.propTypes = {
  children: PropTypes.node.isRequired
};
var Div = styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  margin-bottom: 0.4rem;\n\n  label,\n  span {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n  }\n"])));

var _templateObject$X;

var PageSection = function PageSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Section, {
    children: children
  });
};
PageSection.propTypes = {
  children: PropTypes.node.isRequired
};
var Section = styled.section(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n  border: 0.0625rem solid #dedede;\n  background-color: #fff;\n  padding: 0.5rem;\n"])));

var _templateObject$W, _templateObject2$u;

var SecondaryButton = function SecondaryButton(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  var colors = {
    default: {
      fontColor: '#fc8e49',
      hover: {
        fontColor: '#fc7522',
        shadow: 'rgba(241, 83, 4, 0.3) 0 1px 3px 1px'
      }
    },
    success: {
      fontColor: '#42c67f',
      hover: {
        fontColor: '#34ad6c',
        shadow: 'rgba(42, 141, 88, 0.3) 0 1px 3px 1px'
      }
    },
    warning: {
      fontColor: '#ff6f6f',
      hover: {
        fontColor: '#ff4747',
        shadow: 'rgba(255, 31, 31, 0.3) 0 1px 3px 1px'
      }
    },
    question: {
      fontColor: '#3a58de',
      hover: {
        fontColor: '#2343d1',
        shadow: 'rgba(30, 56, 174, 0.3) 0 1px 3px 1px'
      }
    }
  };
  var sizes = {
    default: {
      fontSize: '1rem',
      padding: '0.5rem 1.2rem'
    },
    small: {
      fontSize: '0.8rem',
      padding: '0.3rem 0.625rem'
    }
  };
  return disabled ? /*#__PURE__*/jsx(DisabledButton, {
    color: colors[color],
    size: sizes[size],
    children: children
  }) : /*#__PURE__*/jsx(Button$1, {
    type: "button",
    disabled: disabled,
    color: colors[color],
    size: sizes[size],
    onClick: onClick,
    children: children
  });
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['default', 'question', 'success', 'warning']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['default', 'large', 'small'])
};
var Button$1 = styled.button(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n  display: block;\n  outline: none;\n  border: 0.0625rem solid ", ";\n  background-color: transparent;\n  color: ", ";\n  padding: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  position: relative;\n  transition: all 0.15s ease;\n\n  &:before {\n    content: '';\n    display: block;\n    opacity: 0;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    background-color: #202124;\n    transform: scale(0);\n    transition: all 0.15s;\n  }\n\n  &:hover {\n    color: ", ";\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_ref2) {
  var color = _ref2.color;
  return color.fontColor;
}, function (_ref3) {
  var color = _ref3.color;
  return color.fontColor;
}, function (_ref4) {
  var size = _ref4.size;
  return size.padding;
}, function (_ref5) {
  var size = _ref5.size;
  return size.fontSize;
}, function (_ref6) {
  var color = _ref6.color;
  return color.hover.fontColor;
}, function (_ref7) {
  var color = _ref7.color;
  return color.hover.fontColor;
}, function (_ref8) {
  var color = _ref8.color;
  return color.hover.shadow;
});
var DisabledButton = styled(Button$1)(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  pointer-events: none;\n  opacity: 0.6;\n"])));

var _templateObject$V;

({
  cancelAction: PropTypes.func,
  quoteId: PropTypes.string
});
styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    margin-left: 0.5rem;\n  }\n"])));

var checkAuthState = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Auth.currentAuthenticatedUser();

          case 3:
            _context.next = 5;
            return Auth.currentSession();

          case 5:
            res = _context.sent;
            localStorage.setItem('authToken', res.getIdToken().getJwtToken());
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);

            try {
              Auth.signOut();
            } catch (err) {}

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function checkAuthState() {
    return _ref.apply(this, arguments);
  };
}();

var findAnswer = function findAnswer(source, key) {
  var answer = source.find(function (a) {
    return a.key === key;
  });
  return answer ? answer.value : null;
};

var formattedAnswer = function formattedAnswer(type, value) {
  switch (type) {
    case 'date':
      return formatDate(value.replaceAll('"', ''));

    case 'dateTime':
      return formatDateTime(value.replaceAll('"', ''));

    case 'drivingDistance':
      return formatDrivingDistance(value);

    case 'number':
      return Number(value).toLocaleString('sv-SE');

    case 'yesNo':
      return value === 'True' || value === 'true' || value === true ? 'Yes' : 'No';

    default:
      return value;
  }
};

var socialSecurityNumberCheck = /^(\d{10}|\d{12})$/;
var telephoneWithCountryCodeCheck = /^[+]?[0-9]{11}$/;
var telephoneWithoutCountryCodeCheck = /^[0]?[0-9]{9}$/;
var emailCheck = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const ProductSpecificAnswers = ({ productSpecificFields, source, backupSource, }) => {
    return productSpecificFields ? (jsx(Fragment, { children: productSpecificFields.map(field => (jsxs(NamedItem, { children: [jsx("span", { children: field.label }), (field.isKeyValuePair
                    ? findAnswer(source, field.key)
                    : field.key && source[field.key])
                    ? formattedAnswer(field.type, field.isKeyValuePair
                        ? findAnswer(source, field.key)
                        : field.key && source[field.key])
                    : backupSource
                        ? (field.isBackupKeyValuePair
                            ? findAnswer(backupSource, field.backupKey)
                            : field.backupKey && backupSource[field.backupKey])
                            ? formattedAnswer(field.type, field.isBackupKeyValuePair
                                ? findAnswer(backupSource, field.backupKey)
                                : field.backupKey && backupSource[field.backupKey])
                            : 'N/A'
                        : 'N/A'] }, field.key || field.backupKey))) })) : (jsx(Fragment, {}));
};

var DefinedCustomerAnswers = function DefinedCustomerAnswers(_ref) {
  var defaultCompanyValues = _ref.defaultCompanyValues,
      defaultPersonValues = _ref.defaultPersonValues,
      productSpecificFields = _ref.productSpecificFields,
      source = _ref.source,
      backupSource = _ref.backupSource;
  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Customer information"
    }), defaultCompanyValues && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Company name"
        }), defaultCompanyValues.name]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Company reference"
        }), defaultCompanyValues.reference]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Address"
        }), defaultCompanyValues.address]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Zip code"
        }), defaultCompanyValues.post_code]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "City"
        }), defaultCompanyValues.city]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "E-mail"
        }), defaultCompanyValues.email]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Telephone"
        }), defaultCompanyValues.phone]
      })]
    }), defaultPersonValues && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Social security number"
        }), defaultPersonValues.social_security]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "First name"
        }), defaultPersonValues.first_name]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Last name"
        }), defaultPersonValues.last_name]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Zip code"
        }), defaultPersonValues.postal_code]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "E-mail"
        }), defaultPersonValues.email]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Telephone"
        }), defaultPersonValues.telephone]
      })]
    }), /*#__PURE__*/jsx(ProductSpecificAnswers, {
      productSpecificFields: productSpecificFields,
      source: source,
      backupSource: backupSource
    })]
  });
};

const DefinedObjectAnswers = ({ productSpecificFields, source, backupSource, }) => {
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Object information" }) }), jsx("main", { children: jsx(ProductSpecificAnswers, { productSpecificFields: productSpecificFields, source: source, backupSource: backupSource }) })] }));
};

const DefinedPolicyAnswers = ({ defaultValues, productSpecificFields, source, backupSource, }) => {
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Policy information" }) }), jsxs("main", { children: [jsxs(NamedItem, { children: [jsx("span", { children: "Quote created" }), formatDateTime(defaultValues.created)] }), jsxs(NamedItem, { children: [jsx("span", { children: "Start date" }), defaultValues.start_date] }), jsxs(NamedItem, { children: [jsx("span", { children: "End date" }), defaultValues.end_date] }), jsxs(NamedItem, { children: [jsx("span", { children: "Coverage" }), defaultValues.cover_level] }), jsx(ProductSpecificAnswers, { productSpecificFields: productSpecificFields, source: source, backupSource: backupSource })] })] }));
};

var _templateObject$U, _templateObject2$t, _templateObject3$p, _templateObject4$h, _templateObject5$7, _templateObject6$4, _templateObject7$4;

var Loading = function Loading() {
  return /*#__PURE__*/jsxs(LoadingContainer, {
    children: [/*#__PURE__*/jsxs(ChaseSpinner, {
      children: [/*#__PURE__*/jsx(ChaseDot, {}), /*#__PURE__*/jsx(ChaseDot, {}), /*#__PURE__*/jsx(ChaseDot, {}), /*#__PURE__*/jsx(ChaseDot, {}), /*#__PURE__*/jsx(ChaseDot, {}), /*#__PURE__*/jsx(ChaseDot, {})]
    }), /*#__PURE__*/jsx(WaitText, {
      children: "Please wait, fetching data.."
    })]
  });
};
var LoadingContainer = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n"])));
var chase = keyframes(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n  100% { transform: rotate(360deg) };\n"])));
var chaseDot = keyframes(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n  80%, 100% { transform: rotate(360deg) };\n"])));
var chaseDotBefore = keyframes(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n  50% {\n    transform: scale(0.4); \n  } 100%, 0% {\n    transform: scale(1.0); \n  } \n"])));
var ChaseSpinner = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  width: 3rem;\n  height: 3rem;\n  position: relative;\n  animation: ", " 2.5s infinite linear both;\n"])), chase);
var ChaseDot = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: ", " 2s infinite ease-in-out both;\n\n  &:before {\n    content: '';\n    display: block;\n    width: 25%;\n    height: 25%;\n    background-color: #fc8e49;\n    border-radius: 100%;\n    animation: ", " 2s infinite ease-in-out both;\n  }\n\n  &:nth-child(1) {\n    animation-delay: -1.1s;\n\n    &:before {\n      animation-delay: -1.1s;\n    }\n  }\n\n  &:nth-child(2) {\n    animation-delay: -1s;\n\n    &:before {\n      animation-delay: -1s;\n    }\n  }\n\n  &:nth-child(3) {\n    animation-delay: -0.9s;\n\n    &:before {\n      animation-delay: -0.9s;\n    }\n  }\n\n  &:nth-child(4) {\n    animation-delay: -0.8s;\n\n    &:before {\n      animation-delay: -0.8s;\n    }\n  }\n\n  &:nth-child(5) {\n    animation-delay: -0.7s;\n\n    &:before {\n      animation-delay: -0.7s;\n    }\n  }\n\n  &:nth-child(6) {\n    animation-delay: -0.6s;\n\n    &:before {\n      animation-delay: -0.6s;\n    }\n  }\n"])), chaseDot, chaseDotBefore);
var WaitText = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n"])));

var _templateObject$T;

({
  color: PropTypes.oneOf(['blue', 'green', 'orange', 'red']).isRequired,
  size: PropTypes.oneOf(['large', 'standard', 'small']).isRequired,
  text: PropTypes.string.isRequired
});
styled.span(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1;\n  padding: 0.125rem 0.5rem;\n  background-color: ", ";\n  border-radius: 12px;\n"])), function (_ref2) {
  var color = _ref2.color;
  return color.backgroundColor;
});

var _templateObject$S, _templateObject2$s, _templateObject3$o;

({
  cancelAction: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  updateAction: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
});
styled.input(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  font-family: Poppins;\n  font-size: 1rem;\n  width: 100%;\n"])));
styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n\n  button {\n    margin-left: 0.5rem;\n  }\n"])));

var _templateObject$R, _templateObject2$r, _templateObject3$n;

var GridTable = function GridTable(_ref) {
  var children = _ref.children,
      headerItems = _ref.headerItems,
      _ref$columnGap = _ref.columnGap,
      columnGap = _ref$columnGap === void 0 ? '0.5rem' : _ref$columnGap;
  return /*#__PURE__*/jsxs(GridTableContainer, {
    noOfColumns: headerItems.length,
    columnGap: columnGap,
    children: [headerItems.map(function (headerItem) {
      return /*#__PURE__*/jsx(HeaderItem, {
        children: headerItem
      }, headerItem);
    }), /*#__PURE__*/jsx(HeaderBorder, {
      span: headerItems.length
    }), children]
  });
};

GridTable.propTypes = {
  children: PropTypes.node,
  headerItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnGap: PropTypes.string
};
var GridTableContainer = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(", ", auto);\n  column-gap: ", ";\n  row-gap: 0.75rem;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 0.5rem;\n  font-size: 0.875rem;\n"])), function (_ref2) {
  var noOfColumns = _ref2.noOfColumns;
  return noOfColumns;
}, function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var HeaderItem = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));
var HeaderBorder = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  grid-column: 1 / span ", ";\n  border-bottom: 0.125rem solid #dedede;\n"])), function (_ref4) {
  var span = _ref4.span;
  return span;
});

var _templateObject$Q;

({
  text: PropTypes.string.isRequired
});
styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n  text-decoration: ", ";\n  cursor: pointer;\n"])), function (_ref2) {
  var isHovering = _ref2.isHovering;
  return isHovering ? '#fc8e49' : 'inherit';
}, function (_ref3) {
  var isHovering = _ref3.isHovering;
  return isHovering ? 'underline' : 'none';
});

var _templateObject$P;

({
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  width: PropTypes.string
});
styled.input(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  text-align: right;\n  width: ", ";\n"])), function (_ref2) {
  var width = _ref2.width;
  return width ? width : 'inherit';
});

var _templateObject$O;

var OptionsMenuButton = function OptionsMenuButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/jsx(Button, {
    onClick: onClick,
    children: children
  });
};

OptionsMenuButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
};
var Button = styled.button(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  display: block;\n  outline: none;\n  border: 0;\n  background-color: transparent;\n  color: #7b7d8c;\n  padding: 0.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  margin: 0;\n  margin-bottom: 0.3rem;\n  position: relative;\n\n  &:before {\n    content: '';\n    display: block;\n    opacity: 0;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    background-color: #202124;\n    transform: scale(0);\n    transition: all 0.15s;\n  }\n\n  &:hover {\n    color: #ff6f6f;\n    text-decoration: underline;\n\n    &:before {\n      opacity: 0.06;\n      transform: scale(1);\n    }\n  }\n"])));

var OptionsMenuItem = function OptionsMenuItem(_ref) {
  var item = _ref.item,
      toggleMenu = _ref.toggleMenu;

  var handleMenuClick = function handleMenuClick() {
    item.action();
    toggleMenu(false);
  };

  return /*#__PURE__*/jsx("li", {
    children: /*#__PURE__*/jsx(OptionsMenuButton, {
      onClick: handleMenuClick,
      children: item.text
    })
  });
};

OptionsMenuItem.propTypes = {
  item: PropTypes.object.isRequired,
  toggleMenu: PropTypes.func.isRequired
};

var _templateObject$N;

var OptionsMenu = function OptionsMenu(_ref) {
  var menuItems = _ref.menuItems;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var menu = useRef();
  useEffect(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  var handleOutsideClick = function handleOutsideClick(e) {
    var _menu$current;

    if ((_menu$current = menu.current) !== null && _menu$current !== void 0 && _menu$current.contains(e.target)) {
      return;
    }

    setIsOpen(false);
  };

  return /*#__PURE__*/jsxs(MenuContainer, {
    ref: menu,
    children: [/*#__PURE__*/jsx("div", {
      open: isOpen,
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      children: /*#__PURE__*/jsx(Icon, {
        iconName: "faEllipsisH"
      })
    }), isOpen && /*#__PURE__*/jsx("ul", {
      children: menuItems.map(function (item, index) {
        return /*#__PURE__*/jsx(OptionsMenuItem, {
          item: item,
          toggleMenu: setIsOpen
        }, index);
      })
    })]
  });
};

OptionsMenu.propTypes = {
  menuItems: PropTypes.array
};
var MenuContainer = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  position: relative;\n\n  div {\n    cursor: pointer;\n    opacity: ", ";\n    padding: 0 0.5rem;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ul {\n    position: absolute;\n    right: 0;\n    display: flex;\n    flex-flow: column;\n    list-style: none;\n    background-color: #fff;\n    border: 0.125rem solid #fc8e49;\n    padding: 0.5rem;\n    white-space: nowrap;\n    z-index: 5000;\n    box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.3);\n  }\n"])), function (props) {
  return props.open ? '0.7' : '1';
});

var _templateObject$M;

var Overlay = function Overlay() {
  var _useOverlay = useOverlay(),
      childNodes = _useOverlay.childNodes;

  return childNodes ? /*#__PURE__*/jsx(OverlayBackground$1, {
    children: childNodes
  }) : null;
};
var OverlayBackground$1 = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.65);\n  backdrop-filter: saturate(100%) blur(4px);\n  justify-content: center;\n  align-items: center;\n  z-index: 99;\n"])));

var _templateObject$L, _templateObject2$q, _templateObject3$m;

var Search = function Search(_ref) {
  var label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      onSubmit = _ref.onSubmit;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var handleChange = function handleChange(e) {
    return setSearchQuery(e.target.value);
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit(searchQuery);
  };

  return /*#__PURE__*/jsxs(ItemContainer, {
    children: [/*#__PURE__*/jsx("label", {
      children: label
    }), /*#__PURE__*/jsx("form", {
      onSubmit: handleSubmit,
      children: /*#__PURE__*/jsxs(InputContainer, {
        children: [/*#__PURE__*/jsx(SearchField, {
          value: searchQuery,
          autoFocus: autoFocus,
          onChange: handleChange
        }), /*#__PURE__*/jsx(SearchButton, {
          type: "submit",
          children: /*#__PURE__*/jsx(Icon, {
            faName: "faSearch"
          })
        })]
      })
    })]
  });
};

Search.propTypes = {
  autoFocus: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string
};
var InputContainer = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: 1rem;\n"])));
var SearchField = styled.input(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  background-color: #fff;\n  padding: 0.1875rem 0.1875rem;\n  border: 0;\n  border-bottom: 0.125rem solid #fc8e49;\n  font-size: 1.2rem;\n  width: 20rem;\n"])));
var SearchButton = styled.button(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  padding: 0 1rem;\n  outline: none;\n  border: 0;\n  border-bottom: 0.125rem solid #fc8e49;\n  display: inline-block;\n  background-color: #fff;\n  font-size: 2rem;\n  color: #fc8e49;\n  cursor: pointer;\n"])));

var _templateObject$K;

var OverlayBackground = function OverlayBackground(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Background, {
    children: children
  });
};

OverlayBackground.propTypes = {
  children: PropTypes.node.isRequired
};
var Background = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.65);\n  backdrop-filter: saturate(100%) blur(4px);\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n"])));

var _templateObject$J, _templateObject2$p, _templateObject3$l, _templateObject4$g;

({
  isCreateingNew: PropTypes.bool,
  personPolicyHolder: PropTypes.shape({
    person_holder: PropTypes.shape({
      email: PropTypes.string,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      telephon: PropTypes.string
    }).isRequired,
    policy: PropTypes.shape({
      cover_level: PropTypes.string,
      created: PropTypes.string,
      end_date: PropTypes.string,
      id: PropTypes.string,
      object_name: PropTypes.string,
      period_written_premium: PropTypes.number,
      policy_number: PropTypes.string,
      product_name: PropTypes.string,
      start_date: PropTypes.string,
      status: PropTypes.string
    }).isRequired
  }).isRequired
});
styled.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n"])));
styled.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n\n  span {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n  }\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.span(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  color: #7b7d8c;\n  font-weight: 500;\n"])));

var _templateObject$I, _templateObject2$o, _templateObject3$k, _templateObject4$f;

({
  personQuoteHolder: PropTypes.shape({
    person_holder: PropTypes.shape({
      email: PropTypes.string,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      telephone: PropTypes.string
    }).isRequired,
    quote: PropTypes.shape({
      cover_level: PropTypes.string,
      created: PropTypes.string,
      end_date: PropTypes.string,
      hasura_quote_answers: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired
      })),
      id: PropTypes.string,
      object_name: PropTypes.string,
      product_name: PropTypes.string,
      status: PropTypes.string,
      start_date: PropTypes.string
    }).isRequired
  }).isRequired,
  isCreateingNew: PropTypes.bool
});
var InfoContainer = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  grid-gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled(InfoContainer)(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n\n  span {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n  }\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.h3(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));

var _templateObject$H, _templateObject2$n, _templateObject3$j, _templateObject4$e;

({
  isCreateingNew: PropTypes.bool,
  policy: PropTypes.shape({
    cover_level: PropTypes.string,
    created: PropTypes.string,
    end_date: PropTypes.string,
    hasura_person: PropTypes.shape({
      email: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      telephon: PropTypes.string
    }),
    id: PropTypes.string,
    object_name: PropTypes.string,
    period_written_premium: PropTypes.number,
    policy_number: PropTypes.string,
    product_name: PropTypes.string,
    start_date: PropTypes.string,
    status: PropTypes.string
  }).isRequired
});
styled.div(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  gap: 0.5rem;\n"])));
styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n\n  span {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n  }\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.span(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  color: #7b7d8c;\n  font-weight: 500;\n"])));

var _templateObject$G, _templateObject2$m, _templateObject3$i, _templateObject4$d;

({
  isCreateingNew: PropTypes.bool,
  quote: PropTypes.object.isRequired
});
styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  grid-gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(20, 1fr);\n  grid-gap: 0.5rem;\n"])));
styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  grid-column: ", ";\n\n  span {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n  }\n"])), function (props) {
  return "".concat(props.from, " / ").concat(props.to);
});
styled.h3(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));

var _templateObject$F;

var SubNavigation$1 = function SubNavigation(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Nav, {
    children: /*#__PURE__*/jsx("ul", {
      children: children
    })
  });
};

SubNavigation$1.propTypes = {
  children: PropTypes.node.isRequired
};
var Nav = styled.nav(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  ul {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  li {\n    margin-right: 1rem;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  a {\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: #fc8e49;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"])));

// type TableRowProps = {
//   content: {
//     coveragePeriods: {}[];
//     email: string;
//     endDate: string;
//     id: string;
//     insuranceHolder: string;
//     insuredObject: string;
//     nextPolicyId: string;
//     policy: string;
//     product: string;
//     startDate: string;
//     status: string;
//     telephone: string;
//   };
//   onClick: (policyId: string) => void;
// };
const TableRow$4 = ({ content, onClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const policyStatus = () => {
        if (content.status === 'Active' && new Date(content.endDate) < new Date()) {
            return 'Lapsed';
        }
        if (content.status === 'Terminated' &&
            new Date(content.endDate) > new Date()) {
            return 'To be terminated';
        }
        return content.status;
    };
    const getTagColor = (status) => {
        switch (status) {
            case 'Active':
                return 'green';
            case 'Lapsed':
            case 'To be terminated':
                return 'orange';
            case 'Terminated':
            case 'Undone':
                return 'red';
            default:
                return 'blue';
        }
    };
    const handleMouseEnter = () => setIsMouseOver(true);
    const handleMouseLeave = () => setIsMouseOver(false);
    const handleClick = () => onClick && onClick(content.id);
    return (jsxs(Fragment, { children: [jsx(TableCell$6, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.policy })), jsx(TableCell$6, Object.assign({ onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: jsx(TagWrapper$4, { children: jsxs(TagsContainer$3, { children: [jsx(Tag, { text: policyStatus(), color: getTagColor(policyStatus()), size: 'small' }), content.coveragePeriods.length > 1 && (jsx(Tag, { text: 'MTA', color: getTagColor('mta'), size: 'small' })), content.nextPolicyId && (jsx(Tag, { text: 'Renewed', color: getTagColor('renewed'), size: 'small' }))] }) }) })), jsx(HideOverflow$8, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuredObject }, { children: content.insuredObject })), jsx(TableCell$6, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.product })), jsx(TableCell$6, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.startDate })), jsx(TableCell$6, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.endDate })), jsx(HideOverflow$8, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuranceHolder }, { children: content.insuranceHolder })), jsx(TableCell$6, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.telephone })), jsx(HideOverflow$8, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.email }, { children: content.email }))] }));
};
const TagsContainer$3 = styled.div `
  display: flex;
  gap: 0.25rem;
  align-self: center;
`;
const TagWrapper$4 = styled.div `
  display: flex;
  height: 100%;
`;
const TableCell$6 = styled(GridTableCell) `
  color: ${({ isHovering }) => (isHovering ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isHovering }) => (isHovering ? 'underline' : 'none')};
  cursor: pointer;
`;
const HideOverflow$8 = styled(TableCell$6) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const PoliciesView = () => {
    const [getPolicies, { called, loading, data }] = useSearchPolicies();
    const history = useHistory();
    const query = useQueryParam();
    const [searchQuery, setSearchQuery] = useState('');
    const [tableData, setTableData] = useState([]);
    const [redirect, setRedirect] = useState(false);
    useEffect(() => {
        if (data) {
            setTableData(data.hasura_policy_insurance_holders.map((insuranceHolder) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                return ({
                    coveragePeriods: (_a = insuranceHolder.policy) === null || _a === void 0 ? void 0 : _a.hasura_policy_coverage_periods,
                    email: insuranceHolder.person_holder
                        ? insuranceHolder.person_holder.email
                        : (_c = (_b = insuranceHolder.company_record) === null || _b === void 0 ? void 0 : _b.email) !== null && _c !== void 0 ? _c : '',
                    endDate: (_d = insuranceHolder.policy) === null || _d === void 0 ? void 0 : _d.end_date,
                    id: (_e = insuranceHolder.policy) === null || _e === void 0 ? void 0 : _e.id,
                    insuranceHolder: insuranceHolder.person_holder
                        ? `${insuranceHolder.person_holder.first_name} ${insuranceHolder.person_holder.last_name}`
                        : (_g = (_f = insuranceHolder.company_record) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : '',
                    insuredObject: (_h = insuranceHolder.policy) === null || _h === void 0 ? void 0 : _h.object_name,
                    nextPolicyId: (_j = insuranceHolder.policy) === null || _j === void 0 ? void 0 : _j.next_policy_id,
                    policy: (_k = insuranceHolder.policy) === null || _k === void 0 ? void 0 : _k.policy_number,
                    product: (_l = insuranceHolder.policy) === null || _l === void 0 ? void 0 : _l.product_name,
                    startDate: (_m = insuranceHolder.policy) === null || _m === void 0 ? void 0 : _m.start_date,
                    status: (_o = insuranceHolder.policy) === null || _o === void 0 ? void 0 : _o.status,
                    telephone: insuranceHolder.person_holder
                        ? insuranceHolder.person_holder.telephone
                        : (_q = (_p = insuranceHolder.company_record) === null || _p === void 0 ? void 0 : _p.phone) !== null && _q !== void 0 ? _q : '',
                });
            }));
        }
    }, [data]);
    useEffect(() => {
        var _a;
        const q = (_a = query.get('q')) !== null && _a !== void 0 ? _a : '';
        setSearchQuery(q === null || q === void 0 ? void 0 : q.trim());
    }, []);
    useEffect(() => {
        const params = new URLSearchParams();
        searchQuery ? params.append('q', searchQuery) : params.delete('q');
        history.push(`${POLICIES}?${params.toString()}`);
    }, [searchQuery, history]);
    useEffect(() => {
        if (searchQuery.trim().length > 0) {
            doSearch();
        }
    }, [searchQuery]);
    const doSearch = () => {
        const trimmedSearchQuery = searchQuery.trim();
        if (trimmedSearchQuery.length > 0) {
            const filters = [];
            filters.push({
                policy: { object_name: { _ilike: `%${trimmedSearchQuery}%` } },
            });
            filters.push({
                policy: { policy_number: { _eq: trimmedSearchQuery } },
            });
            filters.push({
                company_record: {
                    reference: { _eq: trimmedSearchQuery.replace('-', '') },
                },
            });
            filters.push({
                company_record: {
                    name: { _ilike: `%${trimmedSearchQuery}%` },
                },
            });
            filters.push({
                person_holder: {
                    social_security: {
                        _ilike: `%${trimmedSearchQuery.replace('-', '')}`,
                    },
                },
            });
            if (emailCheck.test(trimmedSearchQuery)) {
                filters.push({
                    company_record: {
                        email: { _ilike: `%${trimmedSearchQuery}%` },
                    },
                });
                filters.push({
                    person_holder: {
                        email: { _ilike: `%${trimmedSearchQuery}%` },
                    },
                });
            }
            if (trimmedSearchQuery.match(telephoneWithoutCountryCodeCheck)) {
                filters.push({
                    company_record: {
                        phone: { _like: `%${trimmedSearchQuery.slice(1)}%` },
                    },
                });
                filters.push({
                    person_holder: {
                        telephone: { _like: `%${trimmedSearchQuery.slice(1)}%` },
                    },
                });
            }
            if (trimmedSearchQuery.match(telephoneWithCountryCodeCheck)) {
                filters.push({
                    company_record: {
                        phone: { _like: `%${trimmedSearchQuery.slice(3)}%` },
                    },
                });
                filters.push({
                    person_holder: {
                        telephone: { _like: `%${trimmedSearchQuery.slice(3)}%` },
                    },
                });
            }
            getPolicies({
                variables: {
                    where: {
                        _or: filters,
                    },
                },
            });
        }
    };
    const handleSubmit = (query) => {
        setRedirect(true);
        setSearchQuery(query);
    };
    const handlePolicyClick = (policyId) => history.push(`${POLICIES}/${policyId}`);
    if (!called)
        return (jsxs(ContentContainer, { children: [jsx("h1", { children: "Policies" }), jsx(Search, { label: 'Find policy', value: searchQuery, onSubmit: handleSubmit, autoFocus: true })] }));
    return redirect &&
        data &&
        data.hasura_policy_insurance_holders.length === 1 ? (jsx(Redirect, { push: true, to: `${POLICIES}/${data.hasura_policy_insurance_holders[0].policy.id}` })) : (jsxs(ContentContainer, { children: [jsx("h1", { children: "Policies" }), jsx(Search, { label: 'Find policy', value: searchQuery, onSubmit: handleSubmit, autoFocus: true }), data && data.hasura_policy_insurance_holders.length === 0 ? (jsx("div", { children: "No policies found." })) : (jsx(GridTable$1, { columns: [
                    {
                        header: 'Policy',
                        name: 'policy',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Status',
                        name: 'status',
                        isSortable: false,
                        type: 'string',
                    },
                    {
                        header: 'Insured object',
                        name: 'insuredObject',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Product',
                        name: 'product',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Start date',
                        name: 'startDate',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'End date',
                        name: 'endDate',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Policy holder',
                        name: 'insuranceHolder',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Telephone',
                        name: 'telephone',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'E-mail',
                        name: 'email',
                        isSortable: true,
                        type: 'string',
                    },
                ], data: tableData, Row: TableRow$4, tableRowCustomProps: {
                    onClick: handlePolicyClick,
                }, sort: { columnName: 'startDate', direction: 'desc' }, isLoading: called && loading, noOfLoadingRows: 3 }))] }));
};

var _templateObject$E;
var SearchContainer$1 = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  display: flex;\n  width: 25rem;\n  gap: 0.5rem;\n"])));

var SearchCustomer = function SearchCustomer(_ref) {
  var setCustomer = _ref.setCustomer;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var _useSearchCustomers = useSearchCustomers(),
      _useSearchCustomers2 = _slicedToArray(_useSearchCustomers, 2),
      getCustomer = _useSearchCustomers2[0],
      data = _useSearchCustomers2[1].data;

  var handleSearchQueryChange = function handleSearchQueryChange(e) {
    return setSearchQuery(e.target.value);
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    getCustomer({
      variables: {
        wherePeople: {
          social_security: {
            _eq: searchQuery.trim()
          }
        },
        whereCompanies: {
          reference: {
            _eq: searchQuery.trim()
          }
        }
      }
    });
    setSearchQuery('');
  };

  if (data) {
    if (data.hasura_people.length > 0) {
      var customer = data.hasura_people[0];
      customer.type = 'person';
      setCustomer(customer);
    }

    if (data.hasura_company_records.length > 0) {
      var _customer = data.hasura_company_records[0];
      _customer.type = 'company';
      setCustomer(_customer);
    }
  }

  return /*#__PURE__*/jsx("form", {
    onSubmit: handleSubmit,
    children: /*#__PURE__*/jsxs(ItemContainer, {
      children: [/*#__PURE__*/jsx("label", {
        children: "Search for customer"
      }), /*#__PURE__*/jsxs(SearchContainer$1, {
        children: [/*#__PURE__*/jsx("input", {
          value: searchQuery,
          onChange: handleSearchQueryChange
        }), /*#__PURE__*/jsx(PrimaryButton, {
          type: "submit",
          size: "small",
          children: "Find customer"
        })]
      })]
    })
  });
};

SearchCustomer.propTypes = {
  setCustomer: PropTypes.func.isRequired
};

var _templateObject$D;
var ButtonContainer$3 = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    margin-left: 0.5rem;\n  }\n"])));

var CreateQuote = function CreateQuote(_ref) {
  var product = _ref.product;
  var history = useHistory();
  var quoteId = useQueryParam().get('quoteId');
  var policyId = useQueryParam().get('policyId');

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification,
      removeNotificationWithDelay = _useNotification.removeNotificationWithDelay;

  var _useLazyQuoteDetailsH = useLazyQuoteDetailsHooks(),
      _useLazyQuoteDetailsH2 = _slicedToArray(_useLazyQuoteDetailsH, 2),
      getQuoteById = _useLazyQuoteDetailsH2[0],
      _useLazyQuoteDetailsH3 = _useLazyQuoteDetailsH2[1],
      called = _useLazyQuoteDetailsH3.called,
      data = _useLazyQuoteDetailsH3.data;

  var _useLazyPolicy = useLazyPolicy(),
      _useLazyPolicy2 = _slicedToArray(_useLazyPolicy, 2),
      getPolicyById = _useLazyPolicy2[0],
      _useLazyPolicy2$ = _useLazyPolicy2[1],
      getPolicyCalled = _useLazyPolicy2$.called,
      policyData = _useLazyPolicy2$.data;

  var _useState = useState(product.inputFields.reduce(function (a, b) {
    var _b$defaultValue;

    if (b.type === 'date') {
      if (b.defaultValue === 'today') {
        return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, new Date()));
      }

      if (b.defaultValue && b.defaultValue.slice(0, 7) === 'addDays') {
        var daysToAdd = Number(b.defaultValue.match(/\(([^)]+)\)/)[1]);
        var d = new Date();
        d.setDate(d.getDate() + daysToAdd);
        return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, function () {
          return d;
        }()));
      }

      if (b.defaultValue === 'dateAdd') {
        var _d = b.defaultValueOriginatesFrom ? a[b.defaultValueOriginatesFrom] : new Date();

        var year = _d.getFullYear();

        var month = _d.getMonth();

        var day = _d.getDate();

        var defaultDateValue = new Date(year + b.defaultValueArguments[0], month + b.defaultValueArguments[1], day + b.defaultValueArguments[2]);
        return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, function () {
          return defaultDateValue;
        }()));
      }

      return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, function () {
        return b.defaultValue ? new Date(b.defaultValue) : null;
      }()));
    }

    if (b.type === 'object') {
      var values = b.properties.reduce(function (a, b) {
        return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, b.value || null));
      }, {});
      return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, values));
    }

    return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, (_b$defaultValue = b.defaultValue) !== null && _b$defaultValue !== void 0 ? _b$defaultValue : ''));
  }, {})),
      _useState2 = _slicedToArray(_useState, 2),
      inputValues = _useState2[0],
      setInputValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPosting = _useState4[0],
      setIsPosting = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      customer = _useState6[0],
      setCustomer = _useState6[1];

  useEffect(function () {
    if (!called && quoteId) {
      getQuoteById({
        variables: {
          quoteId: quoteId
        }
      });
    }
  }, [quoteId]);
  useEffect(function () {
    if (!getPolicyCalled && policyId) {
      getPolicyById({
        variables: {
          policyId: policyId
        }
      });
    }
  }, [policyId]);
  useEffect(function () {
    if (data) {
      setInputValues(product.inputFields.reduce(function (a, b) {
        var _data$hasura_quote_in, _ref2, _data$hasura_quote_in2, _data$hasura_quote_in3;

        return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, b.type === 'date' ? new Date((_data$hasura_quote_in = data.hasura_quote_insurance_holders[0].quote.hasura_quote_answers.find(function (answer) {
          return answer.key === b.name;
        })) === null || _data$hasura_quote_in === void 0 ? void 0 : _data$hasura_quote_in.value) : (_ref2 = (_data$hasura_quote_in2 = (_data$hasura_quote_in3 = data.hasura_quote_insurance_holders[0].quote.hasura_quote_answers.find(function (answer) {
          return answer.key === b.name;
        })) === null || _data$hasura_quote_in3 === void 0 ? void 0 : _data$hasura_quote_in3.value) !== null && _data$hasura_quote_in2 !== void 0 ? _data$hasura_quote_in2 : b.defaultValue) !== null && _ref2 !== void 0 ? _ref2 : ''));
      }, {}));
    }
  }, [data]);
  useEffect(function () {
    if (policyData) {
      setInputValues(product.inputFields.reduce(function (a, b) {
        var _ref4, _policyData$hasura_po, _policyData$hasura_po2, _ref5, _policyData$hasura_po3, _policyData$hasura_po4;

        return _objectSpread2(_objectSpread2({}, a), b.type === 'object' ? _defineProperty({}, b.name, b.properties.reduce(function (a, b) {
          return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.name, b.value || null));
        }, {})) : _defineProperty({}, b.name, b.type === 'date' ? new Date((_ref4 = (_policyData$hasura_po = (_policyData$hasura_po2 = policyData.hasura_policy_insurance_holders[0].policy.hasura_policy_answers.find(function (answer) {
          return answer.period_index === 0 && answer.key === b.name;
        })) === null || _policyData$hasura_po2 === void 0 ? void 0 : _policyData$hasura_po2.value) !== null && _policyData$hasura_po !== void 0 ? _policyData$hasura_po : b.defaultDateValue) !== null && _ref4 !== void 0 ? _ref4 : null) : (_ref5 = (_policyData$hasura_po3 = (_policyData$hasura_po4 = policyData.hasura_policy_insurance_holders[0].policy.hasura_policy_answers.find(function (answer) {
          return answer.period_index === 0 && answer.key === b.name;
        })) === null || _policyData$hasura_po4 === void 0 ? void 0 : _policyData$hasura_po4.value) !== null && _policyData$hasura_po3 !== void 0 ? _policyData$hasura_po3 : b.defaultValue) !== null && _ref5 !== void 0 ? _ref5 : ''));
      }, {}));
    }
  }, [policyData]);
  console.log(inputValues);
  useEffect(function () {
    if (customer) {
      if (customer.type === 'person') {
        setInputValues(function (inputValues) {
          var _customer$email, _customer$telephone;

          return _objectSpread2(_objectSpread2({}, inputValues), {}, {
            email: (_customer$email = customer.email) !== null && _customer$email !== void 0 ? _customer$email : '',
            firstName: customer.first_name,
            lastName: customer.last_name,
            socialSecurity: customer.social_security,
            telephoneNumber: (_customer$telephone = customer.telephone) !== null && _customer$telephone !== void 0 ? _customer$telephone : ''
          });
        });
      }

      if (customer.type === 'company') {
        setInputValues(function (inputValues) {
          var _customer$email2;

          return _objectSpread2(_objectSpread2({}, inputValues), {}, {
            companyReference: customer.reference,
            companyName: customer.name,
            companyStreet: customer.address,
            postCode: customer.post_code,
            city: customer.city,
            email: (_customer$email2 = customer.email) !== null && _customer$email2 !== void 0 ? _customer$email2 : '',
            telephoneNumber: customer.phone
          });
        });
      }
    }
  }, [customer]);

  var handleChange = function handleChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    setInputValues(function (inputValues) {
      return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, name, value));
    });
  };

  var handleDateChange = function handleDateChange(date, fieldName) {
    setInputValues(function (inputValue) {
      return _objectSpread2(_objectSpread2({}, inputValue), {}, _defineProperty({}, fieldName, date));
    });
    product.inputFields.filter(function (field) {
      return field.defaultValueOriginatesFrom === fieldName;
    }).forEach(function (field) {
      if (field.defaultValue === 'dateAdd') {
        var d = field.defaultValueOriginatesFrom ? date : new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var defaultDateValue = new Date(year + field.defaultValueArguments[0], month + field.defaultValueArguments[1], day + field.defaultValueArguments[2]);
        setInputValues(function (inputValues) {
          return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, field.name, defaultDateValue));
        });
      }
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var body, bodyCopy, trimValues, quote;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setIsPosting(true);
              _context.prev = 2;
              body = _objectSpread2({}, inputValues);
              bodyCopy = structuredClone(inputValues);
              product.inputFields.filter(function (field) {
                return field.type === 'date';
              }).forEach(function (field) {
                body[field.name] = body[field.name].toLocaleDateString('sv-SE');
              });
              product.inputFields.filter(function (field) {
                return field.type === 'object';
              }).forEach(function (field) {
                field.properties.forEach(function (property) {
                  if (!body[field.name]) {
                    body[field.name] = {};
                  }

                  if (property.getValueFrom) {
                    body[field.name][property.name] = property.type === 'number' ? Number(body[property.getValueFrom]) : body[property.getValueFrom];
                  } else {
                    body[field.name][property.name] = bodyCopy[field.name][property.name];
                  }
                });
              });
              product.inputFields.filter(function (field) {
                return field.getValueFrom;
              }).forEach(function (field) {
                body[field.name] = body[field.getValueFrom];
              });

              trimValues = function trimValues(body) {
                return Object.fromEntries(Object.entries(body).map(function (_ref8) {
                  var _ref9 = _slicedToArray(_ref8, 2),
                      key = _ref9[0],
                      value = _ref9[1];

                  return [key, typeof value === 'string' ? value.trim() : value];
                }));
              };

              _context.next = 11;
              return quoteService.create(trimValues(body));

            case 11:
              quote = _context.sent;
              history.push("".concat(QUOTES, "/").concat(quote.contents.id));
              removeNotificationWithDelay(addNotification('New quote has been created.', 'success'));
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              removeNotificationWithDelay(addNotification("Something went wrong when trying to create a new quote: ".concat(_context.t0.response.data.message), 'alert'));

            case 19:
              _context.prev = 19;
              setIsPosting(false);
              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16, 19, 22]]);
    }));

    return function handleSubmit(_x) {
      return _ref7.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx(SearchCustomer, {
      setCustomer: setCustomer
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: handleSubmit,
      children: [product.inputFields.map(function (field) {
        return field.visible && /*#__PURE__*/jsxs(ItemContainer, {
          children: [/*#__PURE__*/jsx("label", {
            children: field.label
          }), field.type === 'date' && /*#__PURE__*/jsx(DatePicker, {
            className: "default",
            locale: "sv",
            dateFormat: "yyyy-MM-dd",
            name: field.name,
            selected: inputValues[field.name],
            disabled: isPosting,
            onChange: function onChange(date) {
              return handleDateChange(date, field.name);
            }
          }), field.type === 'email' && /*#__PURE__*/jsx("input", {
            name: field.name,
            value: inputValues[field.name],
            type: "email",
            disabled: isPosting,
            onChange: handleChange
          }), field.type === 'text' && /*#__PURE__*/jsx("input", {
            name: field.name,
            value: inputValues[field.name],
            type: "text",
            disabled: isPosting,
            onChange: handleChange
          }), field.type === 'list' && /*#__PURE__*/jsx("select", {
            name: field.name,
            value: inputValues[field.name],
            disabled: isPosting,
            onChange: handleChange,
            children: field.options.map(function (option) {
              return /*#__PURE__*/jsx("option", {
                value: option.value,
                children: option.text
              }, option.value);
            })
          }), field.type === 'number' && /*#__PURE__*/jsx("input", {
            name: field.name,
            value: inputValues[field.name],
            type: "text",
            disabled: isPosting,
            onChange: handleChange
          })]
        }, field.name);
      }), /*#__PURE__*/jsx(ButtonContainer$3, {
        children: /*#__PURE__*/jsx(PrimaryButton, {
          type: "submit",
          children: "Create quote"
        })
      })]
    })]
  });
};

CreateQuote.propTypes = {};

var createOSAQuoteService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
    var myInit;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            myInit = {
              body: body
            };
            _context.next = 3;
            return API.post('KrakenAPI', 'osa/quote', myInit);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createOSAQuoteService(_x) {
    return _ref.apply(this, arguments);
  };
}();

var CreateQuoteNew = function CreateQuoteNew(_ref) {
  var product = _ref.product;
  var history = useHistory();

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification,
      removeNotificationWithDelay = _useNotification.removeNotificationWithDelay;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      metaData = _useState2[0],
      setMetaData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValues = _useState4[0],
      setInputValues = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var VERSION = 'latest';
  var DAY_VALUE = 'DayValue';
  var ONE_OF = 'OneOf';

  var getMetaData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(product) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return quoteService.metadata(product, VERSION);

            case 4:
              response = _context.sent;
              setMetaData(response);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              removeNotificationWithDelay(addNotification("Something went wrong when trying to load form: ".concat(_context.t0.response.data.message), 'alert'));

            case 11:
              _context.prev = 11;
              setIsLoading(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));

    return function getMetaData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getMetaData(product);
  }, [product]);
  useEffect(function () {
    if (metaData) {
      Object.values(metaData).forEach(function (field, index) {
        var _field$fieldSchema;

        if ((field === null || field === void 0 ? void 0 : (_field$fieldSchema = field.fieldSchema) === null || _field$fieldSchema === void 0 ? void 0 : _field$fieldSchema.tag) === DAY_VALUE) {
          setInputValues(function (inputValues) {
            return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, field.friendlyName, {
              friendlyName: field.friendlyName,
              humanReadableName: field.humanReadableItem.readableField,
              dataType: field.fieldSchema.tag,
              value: new Date(field.fieldSchema.contents),
              section: '',
              index: index
            }));
          });
          return;
        }

        if (field.friendlyName !== undefined && field.friendlyName !== 'scheduleLayout') {
          setInputValues(function (inputValues) {
            return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, field.friendlyName, {
              friendlyName: field.friendlyName,
              humanReadableName: field.humanReadableItem.readableField,
              dataType: field.fieldSchema.tag,
              value: field.fieldSchema.contents.length === 1 // TODO: Is this the right way to set the value
              ? field.fieldSchema.contents[0] : field.fieldSchema.tag === ONE_OF // TODO: remove this when backend fixed paymentMethod defaultValue
              ? // TODO: remove this when backend fixed paymentMethod defaultValue
              // TODO: to stop value being overwritten - remove when fixed by backend team
              field.fieldSchema.contents[0] : field.fieldSchema.contents,
              section: '',
              index: index,
              options: field.fieldSchema.tag === ONE_OF ? field.fieldSchema.contents : ''
            }));
          });
        }
      });
      metaData.productFields.forEach(function (productField, index) {
        if (productField.friendlyName !== 'coverLevel') {
          // TODO: to stop value being overwritten - remove when fixed by backend team
          setInputValues(function (inputValues) {
            return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, productField.friendlyName, {
              friendlyName: productField.friendlyName,
              humanReadableName: productField.humanReadableItem.readableField,
              dataType: productField.fieldSchema.tag,
              value: productField.defaultValue || '',
              section: '',
              index: Object.keys(inputValues).length + index,
              options: productField.fieldSchema.tag === ONE_OF ? productField.fieldSchema.contents : ''
            }));
          });
        }
      });
    }
  }, [metaData]); // const [customer, setCustomer] = useState(null); TODO: Used for searching and getting customer information and populating the form

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var body, quote;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              body = Object.values(inputValues).reduce(function (a, b) {
                return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, b.friendlyName, b.dataType === DAY_VALUE ? formatDate(b.value) : b.value));
              }, {});
              _context2.prev = 2;
              _context2.next = 5;
              return createOSAQuoteService(body);

            case 5:
              quote = _context2.sent;
              history.push("".concat(QUOTES, "/").concat(quote.id));
              removeNotificationWithDelay(addNotification('New quote has been created.', 'success'));
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              removeNotificationWithDelay(addNotification("Something went wrong when trying to create a new quote: ".concat(_context2.t0.response.data.message), 'alert'));

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));

    return function handleSubmit(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    setInputValues(function (inputValues) {
      return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, name, _objectSpread2(_objectSpread2({}, inputValues[name]), {}, {
        value: value
      })));
    });
  };

  var handleDateChange = function handleDateChange(date, fieldName) {
    setInputValues(function (inputValues) {
      return _objectSpread2(_objectSpread2({}, inputValues), {}, _defineProperty({}, fieldName, _objectSpread2(_objectSpread2({}, inputValues[fieldName]), {}, {
        value: date
      })));
    });

    if (metaData.policyDefaultDuration === 365 && fieldName === 'startDate') {
      // TODO: Add more conditions if required (monthly etc)
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();
      var defaultEndDateValue = new Date(year + 1, month, day - 1);
      setInputValues(function (inputValues) {
        return _objectSpread2(_objectSpread2({}, inputValues), {}, {
          endDate: _objectSpread2(_objectSpread2({}, inputValues.endDate), {}, {
            value: defaultEndDateValue
          })
        });
      });
    }
  };

  return isLoading ? /*#__PURE__*/jsx(PageSection, {
    children: /*#__PURE__*/jsx("p", {
      children: "Loading..."
    })
  }) : /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h4", {
      children: product
    }), inputValues ? /*#__PURE__*/jsxs("form", {
      onSubmit: handleSubmit,
      children: [Object.values(inputValues).map(function (field, index) {
        var _field$options;

        console.log('FIELD', field);
        return field.friendlyName && /*#__PURE__*/jsxs(ItemContainer, {
          children: [/*#__PURE__*/jsx("label", {
            children: (field === null || field === void 0 ? void 0 : field.friendlyName) !== 'product' && (field === null || field === void 0 ? void 0 : field.friendlyName) !== 'reference' && (field === null || field === void 0 ? void 0 : field.friendlyName) !== 'productVersion' && field.humanReadableName
          }), field.dataType !== ONE_OF && field.dataType !== DAY_VALUE && field.friendlyName !== 'product' && field.friendlyName !== 'reference' && field.friendlyName !== 'productVersion' && /*#__PURE__*/jsx("input", {
            type: "text",
            name: field.friendlyName,
            value: field.value,
            onChange: handleChange
          }), field.dataType === ONE_OF && field.options.length <= 10 && /*#__PURE__*/jsxs("select", {
            name: field.friendlyName,
            value: field.value !== null ? field.value : field.contents.length === 1 ? 'selected' : false,
            onChange: handleChange,
            children: [field.value === '' && /*#__PURE__*/jsx("option", {
              value: "",
              children: "Select value"
            }), ((_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.length) > 0 && field.options.sort().map(function (option) {
              return /*#__PURE__*/jsx("option", {
                value: option,
                children: option
              }, option);
            })]
          }), field.dataType === ONE_OF && field.options.length > 10 && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx("input", {
              name: field.friendlyName,
              list: "data",
              value: field.value,
              onChange: handleChange,
              placeholder: "Select value"
            }), /*#__PURE__*/jsx("datalist", {
              defaultValue: "Select one of the following",
              id: "data",
              name: field.friendlyName,
              required: true,
              children: field.options.sort().map(function (item) {
                return /*#__PURE__*/jsx("option", {
                  children: item
                }, item);
              })
            })]
          }), field.dataType === DAY_VALUE && /*#__PURE__*/jsx(DatePicker, {
            className: "default",
            locale: "sv",
            dateFormat: "yyyy-MM-dd",
            name: field.friendlyName,
            selected: field.value,
            onChange: function onChange(date) {
              return handleDateChange(date, field.friendlyName);
            }
          })]
        }, index);
      }), /*#__PURE__*/jsx(ButtonContainer$3, {
        children: /*#__PURE__*/jsx(PrimaryButton, {
          type: "submit",
          children: "Create quote"
        })
      })]
    }) : /*#__PURE__*/jsx("p", {
      children: "Product information currently unavailable"
    })]
  });
};

CreateQuoteNew.propTypes = {};

var SelectProduct = function SelectProduct(_ref) {
  var products = _ref.products;
  var history = useHistory();

  var handleProductClick = function handleProductClick(productName) {
    return history.push("".concat(CREATE_QUOTE_SELECT_PRODUCT, "/").concat(productName));
  };

  return products.map(function (product) {
    return /*#__PURE__*/jsx(Card$1, {
      onClick: function onClick() {
        return handleProductClick(product.name);
      },
      children: /*#__PURE__*/jsx("h3", {
        children: product.name
      })
    }, product.name);
  });
};

SelectProduct.propTypes = {
  product: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  }))
};

var SelectProductNew = function SelectProductNew(_ref) {
  var products = _ref.products;
  var history = useHistory();

  var handleProductClick = function handleProductClick(productName) {
    return history.push("".concat(CREATE_QUOTE_SELECT_PRODUCT_NEW, "/").concat(productName));
  };

  return products.map(function (product) {
    return /*#__PURE__*/jsx(Card$1, {
      onClick: function onClick() {
        return handleProductClick(product);
      },
      children: /*#__PURE__*/jsx("h3", {
        children: product
      })
    }, product);
  });
};

SelectProductNew.propTypes = {
  product: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  }))
};

var CreateQuoteView = function CreateQuoteView() {
  var match = useRouteMatch(CREATE_QUOTE);
  var history = useHistory();
  var products = global.definitions.products.filter(function (product) {
    return product.possibleToCreateQuote;
  });
  if (!match && (products === null || products === void 0 ? void 0 : products.length) === 1) history.push("".concat(CREATE_QUOTE_SELECT_PRODUCT, "/").concat(products[0].name));
  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Create quote"
    }), /*#__PURE__*/jsx("h2", {
      children: match ? match.params.productName : 'Select product'
    }), match ? /*#__PURE__*/jsx(CreateQuote, {
      product: products.find(function (product) {
        return product.name === match.params.productName;
      })
    }) : products && /*#__PURE__*/jsx(SelectProduct, {
      products: products
    })]
  });
};

var CreateQuoteViewNew = function CreateQuoteViewNew() {
  var match = useRouteMatch(CREATE_QUOTE_NEW);
  var history = useHistory();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      products = _useState2[0],
      setProducts = _useState2[1];

  var getProducts = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return quoteService.products();

            case 3:
              response = _context.sent;
              setProducts(response);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function getProducts() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getProducts();
  }, []);
  useEffect(function () {
    if (!match && (products === null || products === void 0 ? void 0 : products.length) === 1) history.push("".concat(CREATE_QUOTE_SELECT_PRODUCT_NEW, "/").concat(products[0]));
  }, [products]); // if (!match && products?.length === 1)
  //   history.push(`${CREATE_QUOTE_SELECT_PRODUCT_NEW}/${products[0]}`);

  return products && /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Create quote"
    }), match ? /*#__PURE__*/jsx(CreateQuoteNew, {
      product: products.find(function (product) {
        return product === match.params.productName;
      })
    }) : products && /*#__PURE__*/jsx(SelectProductNew, {
      products: products
    })]
  });
};

var _templateObject$C, _templateObject2$l, _templateObject3$h, _templateObject4$c;

var CustomerPolicies = function CustomerPolicies(_ref) {
  var holderId = _ref.holderId;

  var _useHolderPolicies = useHolderPolicies(holderId),
      data = _useHolderPolicies.data;

  var history = useHistory();

  var handleClick = function handleClick(policyId) {
    return history.push("".concat(POLICIES, "/").concat(policyId));
  };

  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Policies"
    }), /*#__PURE__*/jsxs(Table$7, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx(Th$5, {
            children: "Policy number"
          }), /*#__PURE__*/jsx(Th$5, {
            children: "Object"
          }), /*#__PURE__*/jsx(Th$5, {
            children: "Status"
          }), /*#__PURE__*/jsx(Th$5, {
            children: "Cover"
          }), /*#__PURE__*/jsx(Th$5, {
            children: "Start date"
          }), /*#__PURE__*/jsx(Th$5, {
            children: "End date"
          }), /*#__PURE__*/jsx(ThRightAlign$4, {
            children: "Premium"
          })]
        })
      }), data && /*#__PURE__*/jsx("tbody", {
        children: data.hasura_policy_insurance_holders.map(function (insuranceHolder) {
          return /*#__PURE__*/jsxs("tr", {
            onClick: function onClick() {
              handleClick(insuranceHolder.policy.id);
            },
            children: [/*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.policy_number
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.object_name.toUpperCase()
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.status
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.cover_level
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.start_date
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.policy.end_date
            }), /*#__PURE__*/jsx(TdRightAlign$1, {
              children: insuranceHolder.policy.period_written_premium.toLocaleString('sv-SE')
            })]
          }, insuranceHolder.policy.id);
        })
      })]
    })]
  });
};

CustomerPolicies.propTypes = {
  holderId: PropTypes.string.isRequired
};
var Table$7 = styled.table(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  width: 100%;\n\n  tbody {\n    color: #fc8e49;\n\n    tr {\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n\n    td {\n      border-bottom: 0.0625rem dotted #dedede;\n    }\n  }\n"])));
var TdRightAlign$1 = styled.td(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var Th$5 = styled.th(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n"])));
var ThRightAlign$4 = styled(Th$5)(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n  text-align: right;\n"])));

var _templateObject$B;

var CustomerQuotes = function CustomerQuotes(_ref) {
  var holderId = _ref.holderId;

  var _useHolderQuotes = useHolderQuotes(holderId),
      data = _useHolderQuotes.data;

  var history = useHistory();

  var handleClick = function handleClick(quoteId) {
    return history.push("".concat(QUOTES, "/").concat(quoteId));
  };

  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Quotes"
    }), /*#__PURE__*/jsxs(Table$6, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx("th", {
            children: "Created"
          }), /*#__PURE__*/jsx("th", {
            children: "Object"
          }), /*#__PURE__*/jsx("th", {
            children: "Cover"
          }), /*#__PURE__*/jsx("th", {
            children: "Status"
          })]
        })
      }), data && /*#__PURE__*/jsx("tbody", {
        children: data.hasura_quote_insurance_holders.map(function (insuranceHolder) {
          return /*#__PURE__*/jsxs("tr", {
            onClick: function onClick() {
              handleClick(insuranceHolder.quote.id);
            },
            children: [/*#__PURE__*/jsx("td", {
              children: formatDateTime(insuranceHolder.quote.created)
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.quote.object_name.toUpperCase()
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.quote.cover_level
            }), /*#__PURE__*/jsx("td", {
              children: insuranceHolder.quote.status
            })]
          }, insuranceHolder.quote.id);
        })
      })]
    })]
  });
};

CustomerQuotes.propTypes = {
  holderId: PropTypes.string.isRequired
};
var Table$6 = styled.table(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  width: 100%;\n\n  th {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #7b7d8c;\n    text-align: left;\n  }\n\n  tbody {\n    color: #fc8e49;\n\n    tr {\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n\n      &:last-child {\n        td {\n          border: 0;\n        }\n      }\n    }\n\n    td {\n      border-bottom: 0.0625rem dotted #dedede;\n    }\n  }\n"])));

const RecordHistoryItem = ({ title, history, hideHistory, }) => {
    const handleCloseClick = () => hideHistory();
    const handleEsc = () => hideHistory();
    useEffect(() => {
        document.addEventListener('keydown', handleEsc, false);
        return () => document.removeEventListener('keydown', handleEsc, false);
    }, []);
    return (jsxs(HistoryWrapper, { children: [jsxs("header", { children: [title, jsx(IconButton, Object.assign({ options: { size: 'small' }, onClick: handleCloseClick }, { children: jsx(Icon, { iconName: 'faTimes' }) }))] }), jsx("main", { children: history.map((record, index) => (jsxs(NamedItem, { children: [jsx("span", { children: formatDateTime(record.time) }), record.entry] }, index))) })] }));
};
const HistoryWrapper = styled(Section$1) `
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0.5rem 1rem;
  z-index: 10;
  width: 20rem;
  border: 0.0625rem solid #e6e6e6;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const RecordHistory = ({ title, history }) => {
    const [isShowingHistory, setIsShowingHistory] = useState(false);
    const ref = useRef(null);
    const showHistory = () => setIsShowingHistory(true);
    const hideHistory = () => setIsShowingHistory(false);
    useClickOutside(ref, hideHistory);
    return (jsxs(Wrapper, Object.assign({ ref: ref }, { children: [jsx(IconButton, Object.assign({ options: { size: 'medium' }, onClick: showHistory }, { children: jsx(Icon, { iconName: 'faClockRotateLeft' }) })), isShowingHistory && (jsx(RecordHistoryItem, { title: title, history: history, hideHistory: hideHistory }))] })));
};
const Wrapper = styled.div `
  position: relative;
`;

const PersonRecord = ({ person, updateCustomer, history, }) => {
    const handleUpdateClick = (field) => (newValue) => {
        updateCustomer(field, person.id, newValue);
    };
    const personItems = [
        {
            label: 'SSN',
            name: 'socialSecurity',
            value: person.social_security,
            field: 'personSocialSecurity',
        },
        {
            label: 'First name',
            name: 'firstName',
            value: person.first_name,
            field: 'personFirstName',
        },
        {
            label: 'Last name',
            name: 'lastName',
            value: person.last_name,
            field: 'personLastName',
        },
        {
            label: 'E-mail',
            name: 'email',
            value: person.email,
            field: 'personEmail',
        },
        {
            label: 'Telephone',
            name: 'telephone',
            value: person.telephone,
            field: 'personTelephone',
        },
        {
            label: 'Address',
            name: 'address',
            value: person.address,
            field: 'personAddress',
        },
        {
            label: 'Zip code',
            name: 'postCode',
            value: person.postal_code,
            field: 'personPostCode',
        },
        {
            label: 'City',
            name: 'city',
            value: person.city,
            field: 'personCity',
        },
    ];
    return (jsx(ContentWrapper$3, { children: personItems.map((item) => {
            var _a, _b, _c;
            return (jsxs(NamedItem, { children: [jsx("span", { children: item.label }), jsxs(ItemContentWrapper$1, { children: [jsx(EditableContent, { value: item.value, type: 'text', onUpdate: handleUpdateClick(item.field) }), history &&
                                ((_a = history[item.name]) === null || _a === void 0 ? void 0 : _a.history) &&
                                ((_c = (_b = history[item.name]) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.length) > 1 && (jsx(RecordHistory, { title: item.label, history: history[item.name].history }))] })] }, item.name));
        }) }));
};
const ContentWrapper$3 = styled.div `
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
const ItemContentWrapper$1 = styled.div `
  display: flex;
  gap: 0;
`;

const companyService = {
    get: function (recordId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `company/${recordId}`, {});
        });
    },
    updateAddress: function (recordId, newAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newAddress,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
    updateName: function (recordId, newName) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newName,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
    updatePostCode: function (recordId, newPostCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newPostCode,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
    updateCity: function (recordId, newCity) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newCity,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
    updatePhone: function (recordId, newPhone) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newPhone,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
    updateEmail: function (recordId, newEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    newEmail,
                },
            };
            return API.put('KrakenAPI', `company/${recordId}`, myInit);
        });
    },
};

const personService = {
    get: function (id) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `person/${id}`, {});
        });
    },
    updateAddress: function (id, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    address,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateCity: function (id, city) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    city,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateZipCode: function (id, zipCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    zipCode,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateEmail: function (id, email) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    email,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateTelephone: function (id, telephone) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    telephone,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateSocialSecurity: function (id, socialSecurity) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    socialSecurity,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateFirstName: function (id, firstName) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    firstName,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
    updateLastName: function (id, lastName) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    lastName,
                },
            };
            return API.put('KrakenAPI', `people/${id}/id`, myInit);
        });
    },
};

const CompanyRecord = ({ company, updateCustomer, history, }) => {
    const handleUpdateClick = (field) => (newValue) => {
        updateCustomer(field, company.id, newValue);
    };
    const companyItems = [
        {
            label: 'Name',
            name: 'name',
            value: company.name,
            field: 'personSocialSecurity',
        },
        {
            label: 'E-mail',
            name: 'email',
            value: company.email,
            field: 'companyEmail',
        },
        {
            label: 'Telephone',
            name: 'phone',
            value: company.phone,
            field: 'companyPhone',
        },
        {
            label: 'Address',
            name: 'address',
            value: company.address,
            field: 'companyAddress',
        },
        {
            label: 'Zip code',
            name: 'postCode',
            value: company.post_code,
            field: 'companyPostCode',
        },
        {
            label: 'City',
            name: 'city',
            value: company.city,
            field: 'companyCity',
        },
    ];
    return (jsxs(ContentWrapper$2, { children: [jsxs(NamedItem, { children: [jsx("span", { children: "Reference" }), company.reference] }), companyItems.map(item => {
                var _a, _b, _c;
                return (jsxs(NamedItem, { children: [jsx("span", { children: item.label }), jsxs(ItemContentWrapper, { children: [jsx(EditableContent, { value: item.value, type: 'text', onUpdate: handleUpdateClick(item.field) }), history &&
                                    ((_a = history[item.name]) === null || _a === void 0 ? void 0 : _a.history) &&
                                    ((_c = (_b = history[item.name]) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.length) > 1 && (jsx(RecordHistory, { title: item.label, history: history[item.name].history }))] })] }, item.name));
            })] }));
};
const ContentWrapper$2 = styled.div `
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
const ItemContentWrapper = styled.div `
  display: flex;
  gap: 0rem;
`;

const CustomerInformation = ({ company, person, refetch, }) => {
    const { setAlert } = useAlert();
    const [recordHistory, setRecordHistory] = useState(null);
    useEffect(() => {
        const getHistory = () => __awaiter(void 0, void 0, void 0, function* () { return person && setRecordHistory(yield personService.get(person.id)); });
        person && getHistory();
    }, [person]);
    useEffect(() => {
        const getHistory = () => __awaiter(void 0, void 0, void 0, function* () { return company && setRecordHistory(yield companyService.get(company.id)); });
        company && getHistory();
    }, [company]);
    const sharedEmailOptions = {
        questionHeader: 'Update e-mail address?',
        questionMessage: function (newValue) {
            return `Do you want do update the e-mail address to "${newValue}"?`;
        },
        questionButton: 'Update e-mail address',
        successHeader: 'E-mail address was updated',
        successMessage: 'The e-mail address was successfully updated.',
        errorMessage: 'Could not update the e-mail address:',
    };
    const sharedPhoneOptions = {
        questionHeader: 'Update telephone number?',
        questionMessage: function (newValue) {
            return `Do you want do update the telephone number to "${newValue}"?`;
        },
        questionButton: 'Update telephone number',
        successHeader: 'Telephone number was updated',
        successMessage: 'The telephone number was successfully updated.',
        errorMessage: 'Could not update the telephone number:',
    };
    const updateOptions = {
        companyAddress: {
            questionHeader: 'Update address?',
            questionMessage: function (newValue) {
                return `Do you want do update the address to "${newValue}"?`;
            },
            questionButton: 'Update address',
            successHeader: 'Address was updated',
            successMessage: 'The address was successfully updated.',
            errorMessage: 'Could not update the address:',
            updateService: companyService.updateAddress,
        },
        companyCity: {
            questionHeader: 'Update city?',
            questionMessage: function (newValue) {
                return `Do you want do update the city to "${newValue}"?`;
            },
            questionButton: 'Update city',
            successHeader: 'City was updated',
            successMessage: 'The city was successfully updated.',
            errorMessage: 'Could not update the city:',
            updateService: companyService.updateCity,
        },
        companyEmail: Object.assign(Object.assign({}, sharedEmailOptions), { updateService: companyService.updateEmail }),
        companyName: {
            questionHeader: 'Update name?',
            questionMessage: function (newValue) {
                return `Do you want do update the name to "${newValue}"?`;
            },
            questionButton: 'Update name',
            successHeader: 'Name was updated',
            successMessage: 'The name was successfully updated.',
            errorMessage: '`Could not update the name:',
            updateService: companyService.updateName,
        },
        companyPhone: Object.assign(Object.assign({}, sharedPhoneOptions), { updateService: companyService.updatePhone }),
        companyPostCode: {
            questionHeader: 'Update zip code?',
            questionMessage: function (newValue) {
                return `Do you want do update the zip code to "${newValue}"?`;
            },
            questionButton: 'Update zip code',
            successHeader: 'Zip code was updated',
            successMessage: 'The zip code was successfully updated.',
            errorMessage: 'Could not update the zip code:',
            updateService: companyService.updatePostCode,
        },
        personAddress: {
            questionHeader: 'Update address?',
            questionMessage: function (newValue) {
                return `Do you want do update the address to "${newValue}"?`;
            },
            questionButton: 'Update address',
            successHeader: 'Address was updated',
            successMessage: 'The address was successfully updated.',
            errorMessage: 'Could not update the address:',
            updateService: personService.updateAddress,
        },
        personCity: {
            questionHeader: 'Update city?',
            questionMessage: function (newValue) {
                return `Do you want do update the city to "${newValue}"?`;
            },
            questionButton: 'Update city',
            successHeader: 'City was updated',
            successMessage: 'The city was successfully updated.',
            errorMessage: 'Could not update the city:',
            updateService: personService.updateCity,
        },
        personEmail: Object.assign(Object.assign({}, sharedEmailOptions), { updateService: personService.updateEmail }),
        personFirstName: {
            questionHeader: 'Update first name?',
            questionMessage: function (newValue) {
                return `Do you want do update the first name to "${newValue}"?`;
            },
            questionButton: 'Update first name',
            successHeader: 'First name was updated',
            successMessage: 'The first name was successfully updated.',
            errorMessage: '`Could not update the first name:',
            updateService: personService.updateFirstName,
        },
        personLastName: {
            questionHeader: 'Update last name?',
            questionMessage: function (newValue) {
                return `Do you want do update the last name to "${newValue}"?`;
            },
            questionButton: 'Update last name',
            successHeader: 'Last name was updated',
            successMessage: 'The last name was successfully updated.',
            errorMessage: 'Could not update the last name:',
            updateService: personService.updateLastName,
        },
        personTelephone: Object.assign(Object.assign({}, sharedPhoneOptions), { updateService: personService.updateTelephone }),
        personSocialSecurity: {
            questionHeader: 'Update social security number?',
            questionMessage: function (newValue) {
                return `Do you want do update the social security number to "${newValue}"?`;
            },
            questionButton: 'Update social security number',
            successHeader: 'Social security number was updated',
            successMessage: 'The social security number was successfully updated.',
            errorMessage: 'Could not update the social security number:',
            updateService: personService.updateSocialSecurity,
        },
        personPostCode: {
            questionHeader: 'Update zip code?',
            questionMessage: function (newValue) {
                return `Do you want do update the zip cope to "${newValue}"?`;
            },
            questionButton: 'Update zip code',
            successHeader: 'Zip code was updated',
            successMessage: 'The zip code was successfully updated.',
            errorMessage: 'Could not update the zip code:',
            updateService: personService.updateZipCode,
        },
    };
    const updateCustomer = (field, id, newValue) => {
        const { questionHeader, questionMessage, questionButton, successHeader, successMessage, errorMessage, updateService, } = updateOptions[field];
        const doUpdateCustomer = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                yield updateService(id, newValue);
                setAlert({
                    body: {
                        header: successHeader,
                        message: successMessage,
                    },
                    buttons: {
                        ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                refetch();
                                setAlert(null);
                            },
                        },
                    },
                    type: 'success',
                });
            }
            catch (error) {
                const axiosError = error;
                setAlert({
                    body: {
                        header: 'Something went wrong',
                        message: `${errorMessage}: ${(_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data}`,
                    },
                    buttons: {
                        ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                setAlert(null);
                            },
                        },
                    },
                    type: 'warning',
                });
            }
        });
        setAlert({
            body: {
                header: questionHeader,
                message: questionMessage(newValue),
            },
            buttons: {
                cancel: {
                    type: 'secondary',
                    text: 'Cancel',
                    action() {
                        setAlert(null);
                    },
                },
                ok: {
                    type: 'primary',
                    text: questionButton,
                    action() {
                        doUpdateCustomer();
                    },
                },
            },
            type: 'question',
        });
    };
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Customer information" }) }), jsxs("main", { children: [company && (jsx(CompanyRecord, { company: company, updateCustomer: updateCustomer, history: recordHistory })), person && (jsx(PersonRecord, { person: person, updateCustomer: updateCustomer, history: recordHistory }))] })] }));
};

const TaskStateItem = ({ value }) => {
    return (jsxs(ItemWrapper, { children: [value === 'Cancelled' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faTimesCircle', color: '#dedede' }), jsx("span", { children: "Cancelled" })] })), value === 'Completed' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCheckCircle', color: '#3c763d' }), jsx("span", { children: "Done" })] })), value === 'InProgress' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircleHalfStroke', color: '#9d7806' }), jsx("span", { children: "In progress" })] })), value === 'New' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircle' }), jsx("span", { children: "Todo" })] }))] }));
};
const ItemWrapper = styled.div `
  display: flex;
  gap: 0.5rem;
`;

const PostponeUntil = forwardRef(({ value, onClick }, ref) => {
    return (jsx(Button$3, Object.assign({ theme: value && new Date(value) <= new Date() ? 'red' : 'grey', size: 'small', onClick: onClick }, { children: jsxs(ButtonContentWrapper$2, { children: [!value ? (jsx(Icon, { iconName: 'faCalendarPlus' })) : new Date(value) < new Date() ? (jsx(Icon, { iconName: 'faCalendarXmark' })) : (jsx(Icon, { iconName: 'faCalendarDay' })), jsx("span", { children: value &&
                        new Date(value).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'short',
                        }) })] }) })));
});
const ButtonContentWrapper$2 = styled.div `
  display: flex;
  gap: 0.5rem;
`;

const EditTaskDescription = ({ task, updateDescription, hideEdit, }) => {
    const [description, setDescription] = useState(task.description);
    const [isPosting, setIsPosting] = useState(false);
    const textareaRef = useRef(null);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.removeProperty('height');
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [description]);
    const doUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsPosting(true);
        yield updateDescription(task.id, description.trim());
        setIsPosting(false);
        hideEdit();
    });
    useEffect(() => {
        const handleEditDescription = (event) => __awaiter(void 0, void 0, void 0, function* () {
            const { repeat, metaKey, ctrlKey, key } = event;
            if (repeat)
                return;
            if (document.activeElement === textareaRef.current &&
                (metaKey || ctrlKey) &&
                key === 'Enter') {
                doUpdate();
            }
        });
        document.addEventListener('keydown', handleEditDescription, false);
        return () => {
            document.removeEventListener('keydown', handleEditDescription, false);
        };
    }, [description]);
    const handleCancelEditClick = () => hideEdit();
    const handleUpdateClick = () => __awaiter(void 0, void 0, void 0, function* () {
        doUpdate();
    });
    const handleChange = (event) => setDescription(event.target.value);
    return (jsxs(EditWrapper, { children: [jsx(Textarea$2, { disabled: isPosting, ref: textareaRef, onChange: handleChange, value: description, autoFocus: true }), jsxs(ButtonsWrapper$2, { children: [jsx(Button$3, Object.assign({ disabled: isPosting, variant: 'secondary', size: 'small', onClick: handleCancelEditClick }, { children: "Cancel" })), jsxs(Button$3, Object.assign({ disabled: isPosting, size: 'small', onClick: handleUpdateClick }, { children: ["Update description ", jsx(Kbd$2, { children: isMacOs ? '⌘' : 'Ctrl' }), ' ', jsx(Kbd$2, { children: "Enter" })] }))] })] }));
};
const Textarea$2 = styled.textarea `
  font-size: 0.8rem;
  border: none;
  background-color: transparent;
  resize: none;
  height: 1.188rem;
  padding: 0;
`;
const ButtonsWrapper$2 = styled.div `
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
`;
const EditWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const Kbd$2 = styled.kbd `
  border-radius: 0.25rem;
  padding: 0.0625rem 0.25rem;
  line-height: 1;
  background-color: rgba(50, 50, 50, 0.1);
`;

const TaskItem = ({ task, showEntityLinks = false, actions, }) => {
    var _a;
    const [showUpdateState, setShowUpdateState] = useState(false);
    const [isEditingDescription, setIsEditingDescription] = useState(false);
    const handleShowUpdateStateClick = (event) => {
        event.stopPropagation();
        setShowUpdateState(true);
    };
    const hideUpdateState = () => {
        setShowUpdateState(false);
    };
    const updateTaskState = (newState) => {
        if (task.state.tag === newState) {
            return;
        }
        actions.updateTaskState(task.id, newState);
    };
    const handleDateChange = (date) => actions.postponeTask(task.id, date);
    const handleEditClick = () => setIsEditingDescription(true);
    const hideEdit = () => setIsEditingDescription(false);
    return (jsx(ListItem, { children: jsxs(TaskWrapper, { children: [jsxs(ActionsWrapper$2, { children: [jsxs(ActionButtonWrapper$1, { children: [jsx(Button$3, Object.assign({ theme: 'grey', size: 'small', onClick: handleShowUpdateStateClick }, { children: jsxs(ButtonContentWrapper$1, { children: [task.state.tag === 'Cancelled' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faTimesCircle', color: '#dedede' }), jsx(ActionButtonText$1, { children: "Cancelled" })] })), task.state.tag === 'Completed' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCheckCircle', color: '#3c763d' }), jsx(ActionButtonText$1, { children: "Done" })] })), task.state.tag === 'InProgress' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircleHalfStroke', color: '#9d7806' }), jsx(ActionButtonText$1, { children: "In progress" })] })), task.state.tag === 'New' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircle' }), jsx(ActionButtonText$1, { children: "Todo" })] }))] }) })), showUpdateState && (jsx(ValueSelector, { data: [
                                        { value: 'New' },
                                        { value: 'InProgress' },
                                        { value: 'Completed' },
                                        { value: 'Cancelled' },
                                    ], ListItemTemplate: TaskStateItem, onSelect: updateTaskState, hideSelector: hideUpdateState, filterSettings: { showFilter: false } }))] }), jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', minDate: new Date(), selected: task.postponedUntil ? new Date(task.postponedUntil) : null, onChange: handleDateChange, customInput: createElement(PostponeUntil) })] }), jsx(Description, { children: isEditingDescription ? (jsx(EditTaskDescription, { task: task, updateDescription: actions.updateDescription, hideEdit: hideEdit })) : (jsx("p", { children: task.description })) }), !isEditingDescription && (jsx(EditButtonWrapper, { children: jsxs(Button$3, Object.assign({ theme: 'blue', size: 'small', onClick: handleEditClick }, { children: [jsx(Icon, { iconName: 'faPencil' }), " Edit description"] })) })), !showEntityLinks &&
                    task.associatedEntities.map(entity => (jsxs(LinkWrapper, { children: [entity.tag === 'AssociatedPolicy' && (jsx(StyledLink$1, Object.assign({ to: `policies/${entity.contents}` }, { children: "Goto policy" }))), (entity.tag === 'AssociatedCompany' ||
                                entity.tag === 'AssociatedPerson') && (jsx(StyledLink$1, Object.assign({ to: `customers/${entity.contents}` }, { children: "Goto customer" })))] }))), jsxs(Activities$1, { children: [jsxs(Activity$1, { children: [jsx("div", { children: jsx(Icon, { iconName: 'faCirclePlus' }) }), jsxs("div", { children: [jsx(Strong$1, { children: (_a = task.createdBy) !== null && _a !== void 0 ? _a : 'system' }), " created the task -", ' ', formatDateTime(task.createdAt)] })] }), task.state.tag === 'Cancelled' && (jsxs(Activity$1, { children: [jsx("div", { children: jsx(Icon, { iconName: 'faTimesCircle', color: '#dedede' }) }), jsxs("div", { children: [jsx(Strong$1, { children: task.state.cancelledBy }), " changed the status to", ' ', jsx(Strong$1, { children: "Cancelled" })] })] })), task.state.tag === 'Completed' && (jsxs(Activity$1, { children: [jsx("div", { children: jsx(Icon, { iconName: 'faCheckCircle', color: '#3c763d' }) }), jsxs("div", { children: [jsx(Strong$1, { children: task.state.completedBy }), " changed the status to", ' ', jsx(Strong$1, { children: "Done" }), " - ", formatDateTime(task.state.completedAt)] })] }))] })] }) }));
};
const TaskWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const Description = styled.div `
  font-size: 1rem;
`;
const Activities$1 = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0 0.5rem;
  padding-top: 0.5rem;
  margin: 0 -0.5rem;
  border-top: 1px solid #ebebeb;
`;
const Activity$1 = styled.li `
  display: flex;
  gap: 0.5rem;
`;
const ActionsWrapper$2 = styled.div `
  display: flex;
  column-gap: 0.5rem;
  row-gap: 0.25rem;
  flex-wrap: nowrap;
  margin: -0.5rem;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom: 1px solid #ebebeb;
`;
const Strong$1 = styled.span `
  font-weight: 500;
`;
const ButtonContentWrapper$1 = styled.div `
  display: flex;
  gap: 0.5rem;
`;
const ActionButtonWrapper$1 = styled.div `
  position: relative;
`;
const ActionButtonText$1 = styled.span `
  white-space: nowrap;
`;
const LinkWrapper = styled.div `
  display: flex;
  gap: 0.5rem;
`;
const StyledLink$1 = styled(Link$1) `
  color: #1e38b3;
`;
const EditButtonWrapper = styled.div `
  margin: -0.5rem 0;
`;

const taskService = (() => {
    const create = (associatedEntities, description, postponedUntil) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                associatedEntities,
                description,
                postponedUntil,
            },
        };
        return API.post('KrakenAPI', 'task/create', myInit);
    });
    const getActive = () => __awaiter(void 0, void 0, void 0, function* () { return API.get('KrakenAPI', 'task/active', {}); });
    const getActiveAndUpcoming = () => __awaiter(void 0, void 0, void 0, function* () { return API.get('KrakenAPI', 'task/activeAndUpcoming', {}); });
    const getByAssociatedEntity = (associatedEntity, includeTerminated = true) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            queryStringParameters: Object.assign(Object.assign({}, associatedEntity), { includeTerminated }),
        };
        return API.get('KrakenAPI', 'task/byAssociatedEntity', myInit);
    });
    const assignTo = (taskId, assignTo) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                assignTo,
            },
        };
        return API.put('KrakenAPI', `task/${taskId}/assignedTo`, myInit);
    });
    const updateDescription = (taskId, description) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                description,
            },
        };
        return API.put('KrakenAPI', `task/${taskId}/description`, myInit);
    });
    const postpone = (taskId, postponedUntil) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                postponedUntil,
            },
        };
        return API.put('KrakenAPI', `task/${taskId}/postponedUntil`, myInit);
    });
    const updateState = (taskId, state) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: Object.assign({}, state),
        };
        return API.put('KrakenAPI', `task/${taskId}/state`, myInit);
    });
    return {
        assignTo,
        create,
        getActive,
        getActiveAndUpcoming,
        getByAssociatedEntity,
        postpone,
        updateDescription,
        updateState,
    };
})();

const AddTask = ({ associatedEntity, onAddTask }) => {
    const [newTask, setNewTask] = useState({
        description: '',
        postponedUntil: null,
        taskState: 'New',
    });
    const [showUpdateState, setShowUpdateState] = useState(false);
    const textareaRef = useRef(null);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.removeProperty('height');
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [newTask.description]);
    useEffect(() => {
        const handleAddTask = (event) => {
            const { repeat, metaKey, ctrlKey, key } = event;
            if (repeat)
                return;
            if (document.activeElement === textareaRef.current &&
                newTask.description.trim().length > 0 &&
                (metaKey || ctrlKey) &&
                key === 'Enter') {
                onAddTask([associatedEntity], newTask.description, newTask.postponedUntil, newTask.taskState);
                setNewTask({ description: '', postponedUntil: null, taskState: 'New' });
            }
        };
        document.addEventListener('keydown', handleAddTask, false);
        return () => {
            document.removeEventListener('keydown', handleAddTask, false);
        };
    }, [newTask.description]);
    const handleChange = (event) => setNewTask(state => (Object.assign(Object.assign({}, state), { description: event.target.value })));
    const handleShowUpdateStateClick = (event) => {
        event.stopPropagation();
        setShowUpdateState(true);
    };
    const hideUpdateState = () => {
        setShowUpdateState(false);
    };
    const handleAddTaskClick = () => {
        onAddTask([associatedEntity], newTask.description, newTask.postponedUntil, newTask.taskState);
        setNewTask({ description: '', postponedUntil: null, taskState: 'New' });
    };
    const handleDateChange = (date) => setNewTask(state => (Object.assign(Object.assign({}, state), { postponedUntil: date })));
    const handleCancelClick = () => setNewTask({
        description: '',
        postponedUntil: null,
        taskState: 'New',
    });
    const updateTaskState = (newState) => setNewTask(state => (Object.assign(Object.assign({}, state), { taskState: newState })));
    return (jsx(ListItem, { children: jsxs(AddContainer$1, { children: [newTask.description.length > 0 && (jsxs(ActionsWrapper$1, { children: [jsxs(ActionButtonWrapper, { children: [jsx(Button$3, Object.assign({ theme: 'grey', size: 'small', onClick: handleShowUpdateStateClick }, { children: jsxs(ButtonContentWrapper, { children: [newTask.taskState === 'Cancelled' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faTimesCircle', color: '#dedede' }), jsx(ActionButtonText, { children: "Cancelled" })] })), newTask.taskState === 'Completed' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCheckCircle', color: '#3c763d' }), jsx(ActionButtonText, { children: "Done" })] })), newTask.taskState === 'InProgress' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircleHalfStroke', color: '#9d7806' }), jsx(ActionButtonText, { children: "In progress" })] })), newTask.taskState === 'New' && (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faCircle' }), jsx(ActionButtonText, { children: "Todo" })] }))] }) })), showUpdateState && (jsx(ValueSelector, { data: [
                                        { value: 'New' },
                                        { value: 'InProgress' },
                                        { value: 'Completed' },
                                        { value: 'Cancelled' },
                                    ], ListItemTemplate: TaskStateItem, onSelect: updateTaskState, hideSelector: hideUpdateState, filterSettings: { showFilter: false } }))] }), jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', minDate: new Date(), selected: newTask.postponedUntil ? new Date(newTask.postponedUntil) : null, onChange: handleDateChange, customInput: createElement(PostponeUntil) })] })), jsx(Textarea$1, { ref: textareaRef, placeholder: 'Type to add task..', onChange: handleChange, value: newTask.description }), jsxs(ButtonsWrapper$1, Object.assign({ isTyping: newTask.description.length > 0 }, { children: [jsx(Button$3
                        // disabled={isPosting}
                        , Object.assign({ 
                            // disabled={isPosting}
                            variant: 'secondary', size: 'small', onClick: handleCancelClick }, { children: "Cancel" })), jsxs(Button$3
                        // disabled={isPosting}
                        , Object.assign({ 
                            // disabled={isPosting}
                            size: 'small', onClick: handleAddTaskClick }, { children: ["Add task ", jsx(Kbd$1, { children: isMacOs ? '⌘' : 'Ctrl' }), " ", jsx(Kbd$1, { children: "Enter" })] }))] }))] }) }));
};
const AddContainer$1 = styled.div `
  display: flex;
  flex-direction: column;
`;
const Textarea$1 = styled.textarea `
  font-size: 0.8rem;
  border: none;
  background-color: transparent;
  resize: none;
  height: 1.188rem;
`;
const ButtonsWrapper$1 = styled.div `
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
  max-height: ${({ isTyping }) => (isTyping ? '2rem' : 0)};
  opacity: ${({ isTyping }) => (isTyping ? 1 : 0)};
  transition: all 0.3s;
`;
const Kbd$1 = styled.kbd `
  border-radius: 0.25rem;
  padding: 0.0625rem 0.25rem;
  line-height: 1;
  background-color: rgba(50, 50, 50, 0.1);
`;
const ActionsWrapper$1 = styled.div `
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;
  margin: -0.5rem;
  margin-bottom: 0.25rem;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom: 1px solid #ebebeb;
`;
const ActionButtonWrapper = styled.div `
  position: relative;
`;
const ButtonContentWrapper = styled.div `
  display: flex;
  gap: 0.5rem;
`;
const ActionButtonText = styled.span `
  white-space: nowrap;
`;

const Tasks = ({ associatedEntity = null }) => {
    const { addNotification, removeNotificationWithDelay } = useNotification();
    const [tasks, setTasks] = useState([]);
    const [tabs, setTabs] = useState([]);
    const actions = (() => {
        const getTasks = () => __awaiter(void 0, void 0, void 0, function* () {
            setTasks(yield (associatedEntity
                ? taskService.getByAssociatedEntity({
                    [associatedEntity.tag.charAt(0).toLowerCase() +
                        associatedEntity.tag.slice(1)]: associatedEntity.contents,
                }, true)
                : taskService.getActiveAndUpcoming()));
        });
        const createTask = (associatedEntities, description, postponedUntil, state) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const newTask = yield taskService.create(associatedEntities, description, postponedUntil);
                removeNotificationWithDelay(addNotification('A new task was created.', 'success'));
                state === 'New' ? getTasks() : updateTaskState(newTask.id, state);
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Something went wrong when trying to add Task: ${(_a = error.response) === null || _a === void 0 ? void 0 : _a.data.error}`, 'alert'));
            }
        });
        const postponeTask = (taskId, postponeUntil) => __awaiter(void 0, void 0, void 0, function* () {
            var _b;
            try {
                yield taskService.postpone(taskId, postponeUntil);
                removeNotificationWithDelay(addNotification('Deadline for task was set.', 'success'));
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Something went wrong when trying to set task deadline: ${(_b = error.response) === null || _b === void 0 ? void 0 : _b.data.error}`, 'alert'));
            }
            finally {
                getTasks();
            }
        });
        const updateTaskState = (taskId, newState) => __awaiter(void 0, void 0, void 0, function* () {
            var _c;
            try {
                const user = yield Auth.currentUserInfo();
                const availableStatesToSet = {
                    Cancelled: {
                        tag: 'SetStateToCancelled',
                        cancelledBy: user.attributes.email,
                    },
                    Completed: {
                        tag: 'SetStateToCompleted',
                        completedBy: user.attributes.email,
                    },
                    InProgress: { tag: 'SetStateToInProgress' },
                    New: { tag: 'SetStateToNew' },
                };
                yield taskService.updateState(taskId, availableStatesToSet[newState]);
                removeNotificationWithDelay(addNotification('State for task was updated', 'success'));
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Something went wrong when trying to set new task state: ${(_c = error.response) === null || _c === void 0 ? void 0 : _c.data.error}`, 'alert'));
            }
            finally {
                getTasks();
            }
        });
        const updateDescription = (taskId, description) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield taskService.updateDescription(taskId, description);
                removeNotificationWithDelay(addNotification('Task description updated', 'success'));
            }
            catch (error) {
            }
            finally {
                getTasks();
            }
        });
        return {
            createTask,
            getTasks,
            postponeTask,
            updateDescription,
            updateTaskState,
        };
    })();
    useEffect(() => {
        const possibleTabs = [
            {
                tag: 'InProgress',
                label: 'In progress',
                iconName: 'faCircleHalfStroke',
                iconColor: '#9d7806',
            },
            {
                tag: 'New',
                label: 'To do',
                iconName: 'faCircle',
                iconColor: 'inherit',
            },
            {
                tag: 'Completed',
                label: 'Done',
                iconName: 'faCheckCircle',
                iconColor: '#3c763d',
            },
            {
                tag: 'Cancelled',
                label: 'Canceled',
                iconName: 'faTimesCircle',
                iconColor: '#dedede',
            },
        ];
        setTabs(possibleTabs.reduce((a, b) => {
            if (tasks.filter(task => task.state.tag === b.tag).length > 0) {
                return [
                    ...a,
                    {
                        item: {
                            content: (jsxs(TabCaptionWrapper, { children: [jsx(Icon, { iconName: b.iconName, color: b.iconColor }), ' ', jsxs(TabCaption, { children: [b.label, " \u00B7", ' ', tasks.filter(task => task.state.tag === b.tag).length] })] })),
                        },
                        component: (jsx(TaskList, { children: tasks
                                .filter(task => task.state.tag === b.tag)
                                .map(task => (jsx(TaskItem, { task: task, showEntityLinks: associatedEntity ? true : false, actions: actions }, task.id))) })),
                    },
                ];
            }
            else {
                return a;
            }
        }, []));
    }, [tasks]);
    useEffect(() => {
        actions.getTasks();
    }, []);
    return (jsxs(Fragment, { children: [associatedEntity && (jsx(AddTaskWrapper, { children: jsx(AddTask, { associatedEntity: associatedEntity, onAddTask: actions.createTask }) })), tabs.length > 0 ? (jsx(TabContent, { contents: tabs, size: associatedEntity ? 'small' : 'medium' })) : ('No tasks')] }));
};
const TaskList = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
`;
const TabCaptionWrapper = styled.div `
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;
const TabCaption = styled.span `
  text-align: center;
`;
const AddTaskWrapper = styled.ul `
  list-style: none;
  padding: 0;
  margin-bottom: 0.5rem;
`;

const noteService = (() => {
    const create = (associatedEntities, content) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                associatedEntities,
                content,
            },
        };
        yield API.post('KrakenAPI', 'note/create', myInit);
    });
    const getByAssociatedEntity = (associatedEntity) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            queryStringParameters: {
                [associatedEntity.tag.charAt(0).toLocaleLowerCase() +
                    associatedEntity.tag.slice(1)]: associatedEntity.contents,
            },
        };
        return yield API.get('KrakenAPI', 'note/byAssociatedEntity', myInit);
    });
    const updateDescription = (noteId, content) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: {
                content,
            },
        };
        yield API.put('KrakenAPI', `note/${noteId}/description`, myInit);
    });
    const remove = (noteId, associatedEntity) => __awaiter(void 0, void 0, void 0, function* () {
        const myInit = {
            body: Object.assign({}, associatedEntity),
        };
        return yield API.del('KrakenAPI', `note/${noteId}/associatedEntity`, myInit);
    });
    return {
        create,
        getByAssociatedEntity,
        updateDescription,
        remove,
    };
})();

const AddNote = ({ actions }) => {
    const [note, setNote] = useState('');
    const textareaRef = useRef(null);
    const doAdd = () => {
        actions.add(note.trim());
        setNote('');
    };
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.removeProperty('height');
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [note]);
    useEffect(() => {
        const handleAddNote = (event) => __awaiter(void 0, void 0, void 0, function* () {
            const { repeat, metaKey, ctrlKey, key } = event;
            if (repeat)
                return;
            if (document.activeElement === textareaRef.current &&
                note.trim().length > 0 &&
                (metaKey || ctrlKey) &&
                key === 'Enter') {
                doAdd();
            }
        });
        document.addEventListener('keydown', handleAddNote, false);
        return () => {
            document.removeEventListener('keydown', handleAddNote, false);
        };
    }, [note]);
    const handleChange = (event) => setNote(event.target.value);
    const handleCancelClick = () => setNote('');
    const handleAddNoteClick = () => __awaiter(void 0, void 0, void 0, function* () {
        doAdd();
    });
    return (jsx(ListItem, { children: jsxs(AddContainer, { children: [jsx(Textarea, { ref: textareaRef, placeholder: 'Type to add note..', onChange: handleChange, value: note }), jsxs(ButtonsWrapper, Object.assign({ isTyping: note.length > 0 }, { children: [jsx(Button$3
                        // disabled={isPosting}
                        , Object.assign({ 
                            // disabled={isPosting}
                            variant: 'secondary', size: 'small', onClick: handleCancelClick }, { children: "Cancel" })), jsxs(Button$3
                        // disabled={isPosting}
                        , Object.assign({ 
                            // disabled={isPosting}
                            size: 'small', onClick: handleAddNoteClick }, { children: ["Add note ", jsx(Kbd, { children: isMacOs ? '⌘' : 'Ctrl' }), " ", jsx(Kbd, { children: "Enter" })] }))] }))] }) }));
};
const NoteItem = ({ note, actions }) => {
    var _a;
    const [content, setContent] = useState(note.content);
    const textareaRef = useRef(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isPosting, setIsPosting] = useState(false);
    const resetEdit = () => {
        setIsEditing(false);
        setContent(note.content);
    };
    const doUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsPosting(true);
        yield actions.update(note.id, content.trim());
        setIsPosting(false);
        resetEdit();
    });
    useEffect(() => {
        var _a;
        const textarea = textareaRef.current;
        if (isEditing && textarea) {
            textarea.focus();
            textarea.setSelectionRange(textarea.value.length, textarea.value.length);
            textarea.style.removeProperty('height');
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
        isEditing && ((_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus());
    }, [isEditing]);
    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.removeProperty('height');
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    }, [content]);
    useEffect(() => {
        const handleEditNote = (event) => __awaiter(void 0, void 0, void 0, function* () {
            const { repeat, metaKey, ctrlKey, key } = event;
            if (repeat)
                return;
            if (document.activeElement === textareaRef.current &&
                (metaKey || ctrlKey) &&
                key === 'Enter') {
                doUpdate();
            }
        });
        document.addEventListener('keydown', handleEditNote, false);
        return () => {
            document.removeEventListener('keydown', handleEditNote, false);
        };
    }, [content]);
    const handleEditClick = () => setIsEditing(true);
    const handleChange = (event) => setContent(event.target.value);
    const handleRemoveNoteClick = () => actions.remove(note);
    const handleCancelEditClick = () => resetEdit();
    const handleUpdateClick = () => __awaiter(void 0, void 0, void 0, function* () { return doUpdate(); });
    return (jsxs(ListItem, { children: [!isEditing && (jsxs(TopList, { children: [jsx(IconButton, Object.assign({ options: { size: 'small' }, onClick: handleEditClick }, { children: jsx(Icon, { iconName: 'faPencil' }) })), jsx(IconButton, Object.assign({ options: { size: 'small' }, onClick: handleRemoveNoteClick }, { children: jsx(Icon, { iconName: 'faTrashAlt' }) }))] })), jsxs(NoteWrapper, { children: [isEditing ? (jsxs(AddContainer, { children: [jsx(Textarea, { ref: textareaRef, value: content, onChange: handleChange }), jsxs(ButtonsWrapper, Object.assign({ isTyping: isEditing }, { children: [jsx(Button$3, Object.assign({ variant: 'secondary', size: 'small', onClick: handleCancelEditClick }, { children: "Cancel" })), jsxs(Button$3, Object.assign({ size: 'small', onClick: handleUpdateClick }, { children: ["Update note ", jsx(Kbd, { children: isMacOs ? '⌘' : 'Ctrl' }), " ", jsx(Kbd, { children: "Enter" })] }))] }))] })) : (jsx(P, { children: note.content })), jsxs(Activities, { children: [jsxs(Activity, { children: [jsx("div", { children: jsx(Icon, { iconName: 'faCirclePlus' }) }), jsxs("div", { children: [jsx(Strong, { children: (_a = note.createdBy) !== null && _a !== void 0 ? _a : 'system' }), " created the note -", ' ', formatDateTime(note.createdAt)] })] }), new Date(note.lastUpdatedAt).getTime() > 0 && (jsxs(Activity, { children: [jsx("div", { children: jsx(Icon, { iconName: 'faPencil' }) }), jsxs("div", { children: ["Note last updated - ", formatDateTime(note.lastUpdatedAt)] })] }))] })] })] }));
};
const Notes = ({ associatedEntity, caption = 'Notes' }) => {
    const { setAlert } = useAlert();
    const { addNotification, removeNotificationWithDelay } = useNotification();
    const [notes, setNotes] = useState([]);
    const actions = (() => {
        const getAll = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                const notes = yield noteService.getByAssociatedEntity(associatedEntity);
                setNotes(notes);
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Failed to fetch notes: ${(_a = error.response) === null || _a === void 0 ? void 0 : _a.data.status}
          } - ${(_b = error.response) === null || _b === void 0 ? void 0 : _b.data.error}`, 'alert'));
            }
        });
        const add = (content) => __awaiter(void 0, void 0, void 0, function* () {
            var _c, _d;
            try {
                yield noteService.create([associatedEntity], content);
                getAll();
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Failed to create note: ${(_c = error.response) === null || _c === void 0 ? void 0 : _c.data.status}
          } - ${(_d = error.response) === null || _d === void 0 ? void 0 : _d.data.error}`, 'alert'));
            }
        });
        const remove = note => {
            const doRemove = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                try {
                    yield noteService.remove(note.id, associatedEntity);
                    setAlert({
                        body: {
                            header: 'Note removed',
                            message: 'The note has successfully been removed',
                        },
                        buttons: {
                            Ok: {
                                type: 'primary',
                                text: 'OK',
                                action() {
                                    getAll();
                                    setAlert(null);
                                },
                            },
                        },
                        type: 'success',
                    });
                }
                catch (error) {
                    setAlert({
                        body: {
                            header: 'Something went wrong',
                            message: `The note could not be removed: ${(_a = error.response) === null || _a === void 0 ? void 0 : _a.data.status} - ${(_b = error.response) === null || _b === void 0 ? void 0 : _b.data.error} `,
                        },
                        buttons: {
                            Ok: {
                                type: 'primary',
                                text: 'OK',
                                action() {
                                    setAlert(null);
                                },
                            },
                        },
                        type: 'warning',
                    });
                }
            });
            setAlert({
                body: {
                    header: 'Remove note?',
                    message: `Do you want to remove the note: ${note.content}? The action cannot be undone.`,
                },
                buttons: {
                    Cancel: {
                        type: 'secondary',
                        text: 'Cancel',
                        action() {
                            setAlert(null);
                        },
                    },
                    Ok: {
                        type: 'primary',
                        text: 'Remove note',
                        action: doRemove,
                    },
                },
                type: 'question',
            });
        };
        const update = (noteId, content) => __awaiter(void 0, void 0, void 0, function* () {
            var _e, _f;
            try {
                yield noteService.updateDescription(noteId, content);
                getAll();
            }
            catch (error) {
                removeNotificationWithDelay(addNotification(`Failed to update note: ${(_e = error.response) === null || _e === void 0 ? void 0 : _e.data.status}
          } - ${(_f = error.response) === null || _f === void 0 ? void 0 : _f.data.error}`, 'alert'));
            }
        });
        return {
            add,
            getAll,
            update,
            remove,
        };
    })();
    useEffect(() => {
        actions.getAll();
    }, []);
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: caption }) }), jsxs(Main$4, { children: [jsx(AddNoteWrapper, { children: jsx(AddNote, { actions: actions }) }), jsx(NoteList, { children: notes
                            .sort((a, b) => new Date(b.createdAt) > new Date(a.createdAt) ? 1 : -1)
                            .map(note => (jsx(NoteItem, { note: note, actions: actions }, note.id))) })] })] }));
};
const AddNoteWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  li {
    list-style: none;
  }
`;
const NoteList = styled.ul `
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-height: 1.375rem;
  max-height: 30rem;
  padding: 0;
  overflow-y: auto;
`;
const Main$4 = styled.main `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const AddContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const Textarea = styled.textarea `
  font-size: 0.8rem;
  border: none;
  background-color: transparent;
  resize: none;
  height: 1.188rem;
  padding: 0;
`;
const ButtonsWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
  max-height: ${({ isTyping }) => (isTyping ? '2rem' : 0)};
  opacity: ${({ isTyping }) => (isTyping ? 1 : 0)};
  transition: all 0.3s;
`;
const Kbd = styled.kbd `
  border-radius: 0.25rem;
  padding: 0.0625rem 0.25rem;
  line-height: 1;
  background-color: rgba(50, 50, 50, 0.1);
`;
const P = styled.p `
  font-size: 1rem;
  white-space: pre-wrap;
  margin-bottom: 0;
  word-break: break-word;
`;
const TopList = styled.div `
  display: flex;
  gap: 0.125rem;
  justify-content: flex-end;
`;
const NoteWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const Activities = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #7b7d8c;
  padding: 0 0.5rem;
  padding-top: 0.5rem;
  margin: 0 -0.5rem;
  border-top: 1px solid #ebebeb;
`;
const Activity = styled.li `
  display: flex;
  gap: 0.5rem;
`;
const Strong = styled.span `
  font-weight: 500;
`;

var _templateObject$A, _templateObject2$k, _templateObject3$g;

var CustomerView = function CustomerView() {
  var _hasura_people$0$id, _hasura_people$, _hasura_people$2, _hasura_people$0$id2, _hasura_people$3, _hasura_people$4, _hasura_people$0$id3, _hasura_people$5, _hasura_people$0$id4, _hasura_people$6;

  var match = useRouteMatch(CUSTOMER);

  var _useCustomer = useCustomer(match.params.customerId),
      loading = _useCustomer.loading,
      data = _useCustomer.data,
      refetch = _useCustomer.refetch;

  if (loading) return /*#__PURE__*/jsx(Loading, {});
  var hasura_company_records = data.hasura_company_records,
      hasura_people = data.hasura_people;
  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsxs("h1", {
      children: ["Customer", /*#__PURE__*/jsx("br", {}), hasura_company_records[0] && hasura_company_records[0].name, hasura_people[0] && "".concat(hasura_people[0].first_name, " ").concat(hasura_people[0].last_name)]
    }), /*#__PURE__*/jsxs(Grid$4, {
      children: [/*#__PURE__*/jsx(CustomerInfoContainer, {
        children: /*#__PURE__*/jsx(CustomerInformation, {
          company: hasura_company_records[0],
          person: hasura_people[0],
          refetch: refetch
        })
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(CustomerPolicies, {
          holderId: (_hasura_people$0$id = (_hasura_people$ = hasura_people[0]) === null || _hasura_people$ === void 0 ? void 0 : _hasura_people$.id) !== null && _hasura_people$0$id !== void 0 ? _hasura_people$0$id : hasura_company_records[0].id
        })
      }), /*#__PURE__*/jsxs(AsideWrapper$1, {
        children: [/*#__PURE__*/jsxs(Section$1, {
          children: [/*#__PURE__*/jsx("header", {
            children: /*#__PURE__*/jsx("h3", {
              children: "Tasks"
            })
          }), /*#__PURE__*/jsx("main", {
            children: /*#__PURE__*/jsx(Tasks, {
              associatedEntity: {
                tag: (_hasura_people$2 = hasura_people[0]) !== null && _hasura_people$2 !== void 0 && _hasura_people$2.id ? 'AssociatedPerson' : 'AssociatedCompany',
                contents: (_hasura_people$0$id2 = (_hasura_people$3 = hasura_people[0]) === null || _hasura_people$3 === void 0 ? void 0 : _hasura_people$3.id) !== null && _hasura_people$0$id2 !== void 0 ? _hasura_people$0$id2 : hasura_company_records[0].id
              },
              tabSize: "small"
            })
          })]
        }), /*#__PURE__*/jsx(Notes, {
          associatedEntity: {
            tag: (_hasura_people$4 = hasura_people[0]) !== null && _hasura_people$4 !== void 0 && _hasura_people$4.id ? 'AssociatedPerson' : 'AssociatedCompany',
            contents: (_hasura_people$0$id3 = (_hasura_people$5 = hasura_people[0]) === null || _hasura_people$5 === void 0 ? void 0 : _hasura_people$5.id) !== null && _hasura_people$0$id3 !== void 0 ? _hasura_people$0$id3 : hasura_company_records[0].id
          },
          caption: "Notes on customer"
        }), /*#__PURE__*/jsx(CustomerQuotes, {
          holderId: (_hasura_people$0$id4 = (_hasura_people$6 = hasura_people[0]) === null || _hasura_people$6 === void 0 ? void 0 : _hasura_people$6.id) !== null && _hasura_people$0$id4 !== void 0 ? _hasura_people$0$id4 : hasura_company_records[0].id
        })]
      })]
    })]
  });
};
var Grid$4 = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  gap: 0.5rem;\n"])));
var CustomerInfoContainer = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n  grid-column: 1 / span 2;\n"])));
var AsideWrapper$1 = styled.aside(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: column;\n"])));

const TableRow$3 = ({ content, onClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const handleMouseEnter = () => setIsMouseOver(true);
    const handleMouseLeave = () => setIsMouseOver(false);
    const handleClick = () => onClick && onClick(content.id);
    return (jsxs(Fragment, { children: [jsx(TableCell$5, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.reference })), jsx(HideOverflow$7, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.name }, { children: content.name })), jsx(HideOverflow$7, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.email }, { children: content.email })), jsx(TableCell$5, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.telephone }))] }));
};
const TableCell$5 = styled(GridTableCell) `
  color: ${({ isHovering }) => (isHovering ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isHovering }) => (isHovering ? 'underline' : 'none')};
  cursor: pointer;
`;
const HideOverflow$7 = styled(TableCell$5) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// type TableData = {
//   email: string;
//   id: string;
//   name: string;
//   reference: string;
//   telephone: string;
// };
const CustomersView = () => {
    const [getCustomers, { called, loading, data }] = useSearchCustomers();
    const history = useHistory();
    const query = useQueryParam();
    const [searchQuery, setSearchQuery] = useState('');
    const [tableData, setTableData] = useState([]);
    const [redirect, setRedirect] = useState(false);
    useEffect(() => {
        var _a;
        const q = (_a = query.get('q')) !== null && _a !== void 0 ? _a : '';
        setSearchQuery(q === null || q === void 0 ? void 0 : q.trim());
    }, []);
    useEffect(() => {
        if (data) {
            setTableData([
                ...data.hasura_people.map((customer) => ({
                    id: customer.id,
                    email: customer.email,
                    name: `${customer.last_name}, ${customer.first_name}`,
                    reference: customer.social_security,
                    telephone: customer.telephone,
                })),
                ...data.hasura_company_records.map((customer) => ({
                    id: customer.id,
                    email: customer.email,
                    name: customer.name,
                    reference: customer.reference,
                    telephone: customer.phone,
                })),
            ]);
        }
    }, [data]);
    useEffect(() => {
        const params = new URLSearchParams();
        searchQuery ? params.append('q', searchQuery) : params.delete('q');
        history.push(`${CUSTOMERS}?${params.toString()}`);
    }, [searchQuery, history]);
    useEffect(() => {
        if (searchQuery.trim().length > 0) {
            doSearch();
        }
    }, [searchQuery]);
    const doSearch = () => {
        const trimmedSearchQuery = searchQuery.trim();
        if (trimmedSearchQuery.length > 0) {
            const filters = [];
            let peopleFilters = [];
            let companyFilters = [];
            companyFilters.push({
                name: { _ilike: `%${trimmedSearchQuery}%` },
            });
            companyFilters.push({
                reference: { _eq: trimmedSearchQuery.replace('-', '') },
            });
            if (trimmedSearchQuery.replace('-', '').match(socialSecurityNumberCheck)) {
                peopleFilters.push({
                    social_security: { _eq: trimmedSearchQuery.replace('-', '') },
                });
            }
            if (emailCheck.test(trimmedSearchQuery)) {
                filters.push({ email: { _ilike: trimmedSearchQuery } });
            }
            if (trimmedSearchQuery.match(telephoneWithoutCountryCodeCheck)) {
                companyFilters.push({
                    phone: { _like: `%${trimmedSearchQuery.slice(1)}` },
                });
                peopleFilters.push({
                    telephone: { _like: `%${trimmedSearchQuery.slice(1)}` },
                });
            }
            if (trimmedSearchQuery.match(telephoneWithCountryCodeCheck)) {
                companyFilters.push({
                    phone: { _like: `%${trimmedSearchQuery.slice(3)}` },
                });
                peopleFilters.push({
                    telephone: { _like: `%${trimmedSearchQuery.slice(3)}` },
                });
            }
            peopleFilters = [...peopleFilters, ...filters];
            companyFilters = [...companyFilters, ...filters];
            getCustomers({
                variables: {
                    wherePeople: {
                        _or: peopleFilters,
                    },
                    whereCompanies: {
                        _or: companyFilters,
                    },
                },
            });
        }
    };
    const handleSubmit = (query) => {
        setRedirect(true);
        setSearchQuery(query);
    };
    const handleCustomerClick = (customerId) => history.push(`${CUSTOMERS}/${customerId}`);
    if (!called)
        return (jsxs(ContentContainer, { children: [jsx("h1", { children: "Customers" }), jsx(Search, { label: 'Find customer', onSubmit: handleSubmit, value: searchQuery, autoFocus: true })] }));
    return redirect &&
        data &&
        [...data.hasura_company_records, ...data.hasura_people].length === 1 ? (data.hasura_company_records.length === 1 ? (jsx(Redirect, { push: true, to: `${CUSTOMERS}/${data.hasura_company_records[0].id}` })) : (jsx(Redirect, { push: true, to: `${CUSTOMERS}/${data.hasura_people[0].id}` }))) : (jsxs(ContentContainer, { children: [jsx("h1", { children: "Customers" }), jsx(Search, { label: 'Find customer', onSubmit: handleSubmit, value: searchQuery, autoFocus: true }), data &&
                [...data.hasura_company_records, ...data.hasura_people].length === 0 ? (jsx("div", { children: "No customers found." })) : (jsx(GridTable$1, { columns: [
                    {
                        header: 'Identification no',
                        name: 'reference',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Name',
                        name: 'name',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'E-mail',
                        name: 'email',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Telephone',
                        name: 'telephone',
                        isSortable: true,
                        type: 'string',
                    },
                ], data: tableData, Row: TableRow$3, tableRowCustomProps: {
                    onClick: handleCustomerClick,
                }, sort: { columnName: 'name', direction: 'asc' }, isLoading: loading, noOfLoadingRows: 3 }))] }));
};

var _templateObject$z, _templateObject2$j, _templateObject3$f, _templateObject4$b, _templateObject5$6, _templateObject6$3, _templateObject7$3;

var providerRef = function providerRef(additional_info) {
  var _parsed$params$data$o, _parsed, _parsed$params, _parsed$params$data;

  if (additional_info == null) return {
    text: ''
  };
  var parsed;

  try {
    parsed = JSON.parse(additional_info);
  } catch (err) {
    return {
      text: '',
      title: err.message
    };
  }

  if (typeof parsed === 'string') return {
    text: '',
    title: parsed
  };
  return {
    text: (_parsed$params$data$o = (_parsed = parsed) === null || _parsed === void 0 ? void 0 : (_parsed$params = _parsed.params) === null || _parsed$params === void 0 ? void 0 : (_parsed$params$data = _parsed$params.data) === null || _parsed$params$data === void 0 ? void 0 : _parsed$params$data.orderid) !== null && _parsed$params$data$o !== void 0 ? _parsed$params$data$o : ''
  };
}; // Shared list body for the "Failed payments" and "Failed Refunds" views. The two
// differ only in which payments they load (`status` filter, done by the caller's
// hook), the heading, and the CSV file name.


var FailedPaymentsList = function FailedPaymentsList(_ref) {
  var payments = _ref.payments,
      heading = _ref.heading,
      csvBaseName = _ref.csvBaseName;

  var downloadCSV = function downloadCSV(ledgerPayments) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "".concat(csvBaseName, ".csv");
    if (!ledgerPayments || !ledgerPayments.length) return;

    var escapeCsv = function escapeCsv(v) {
      var s = String(v !== null && v !== void 0 ? v : '');
      return /[;"\n\r]/.test(s) ? "\"".concat(s.replace(/"/g, '""'), "\"") : s;
    };

    var isTrustlyPaymentMethod = function isTrustlyPaymentMethod(productName) {
      var _global, _global$definitions, _global$definitions$p, _product$purchaseMeth;

      var product = (_global = global) === null || _global === void 0 ? void 0 : (_global$definitions = _global.definitions) === null || _global$definitions === void 0 ? void 0 : (_global$definitions$p = _global$definitions.products) === null || _global$definitions$p === void 0 ? void 0 : _global$definitions$p.find(function (_ref2) {
        var name = _ref2.name;
        return name === productName;
      });
      return product === null || product === void 0 ? void 0 : (_product$purchaseMeth = product.purchaseMethods) === null || _product$purchaseMeth === void 0 ? void 0 : _product$purchaseMeth.some(function (method) {
        return method.providerUrlParam === 'trustly';
      });
    };

    var rows = ledgerPayments.filter(function (payment) {
      var _payment$hasura_ledge;

      return ((_payment$hasura_ledge = payment.hasura_ledger) === null || _payment$hasura_ledge === void 0 ? void 0 : _payment$hasura_ledge.hasura_policies[0]) && payment.hasura_ledger.hasura_policies[0].hasura_person !== null;
    }).map(function (payment) {
      var _payment$hasura_ledge2, _payment$hasura_ledge3, _payment$ledger_id, _payment$hasura_ledge4, _payment$hasura_ledge5, _person$first_name, _person$email, _policy$object_name, _mandates$0$payment_p, _mandates$;

      var policy = (_payment$hasura_ledge2 = (_payment$hasura_ledge3 = payment.hasura_ledger) === null || _payment$hasura_ledge3 === void 0 ? void 0 : _payment$hasura_ledge3.hasura_policies[0]) !== null && _payment$hasura_ledge2 !== void 0 ? _payment$hasura_ledge2 : null;
      var person = policy === null || policy === void 0 ? void 0 : policy.hasura_person;
      var ledgerId = (_payment$ledger_id = payment.ledger_id) !== null && _payment$ledger_id !== void 0 ? _payment$ledger_id : '';
      var mandates = (_payment$hasura_ledge4 = (_payment$hasura_ledge5 = payment.hasura_ledger) === null || _payment$hasura_ledge5 === void 0 ? void 0 : _payment$hasura_ledge5.hasura_ledger_mandates) !== null && _payment$hasura_ledge4 !== void 0 ? _payment$hasura_ledge4 : [];
      return {
        first_name: (_person$first_name = person === null || person === void 0 ? void 0 : person.first_name) !== null && _person$first_name !== void 0 ? _person$first_name : '',
        email: (_person$email = person === null || person === void 0 ? void 0 : person.email) !== null && _person$email !== void 0 ? _person$email : '',
        object_name: (_policy$object_name = policy === null || policy === void 0 ? void 0 : policy.object_name) !== null && _policy$object_name !== void 0 ? _policy$object_name : '',
        payment_provider: (_mandates$0$payment_p = (_mandates$ = mandates[0]) === null || _mandates$ === void 0 ? void 0 : _mandates$.payment_provider) !== null && _mandates$0$payment_p !== void 0 ? _mandates$0$payment_p : '',
        policy_letter: policy !== null && policy !== void 0 && policy.id && process.env.REACT_APP_PUBLIC_URL ? "".concat(process.env.REACT_APP_PUBLIC_URL, "p/").concat(policy.id) : '',
        paymentMethod: isTrustlyPaymentMethod(policy === null || policy === void 0 ? void 0 : policy.product_name) ? "".concat(process.env.REACT_APP_PUBLIC_URL, "reattach/trustly/").concat(ledgerId) : ''
      };
    });
    var headers = Object.keys(rows[0]);
    var csvContent = [headers.join(';')].concat(_toConsumableArray(rows.map(function (row) {
      return headers.map(function (header) {
        return escapeCsv(row[header]);
      }).join(';');
    }))).join('\n');
    var csvWithBom = "\uFEFF" + csvContent;
    var blob = new Blob([csvWithBom], {
      type: 'text/csv;charset=utf-8;'
    });
    var link = document.createElement('a');
    var url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  var hasPerson = payments === null || payments === void 0 ? void 0 : payments.some(function (payment) {
    var _payment$hasura_ledge6, _payment$hasura_ledge7;

    return (_payment$hasura_ledge6 = payment.hasura_ledger) === null || _payment$hasura_ledge6 === void 0 ? void 0 : (_payment$hasura_ledge7 = _payment$hasura_ledge6.hasura_policies) === null || _payment$hasura_ledge7 === void 0 ? void 0 : _payment$hasura_ledge7.some(function (policy) {
      return (policy === null || policy === void 0 ? void 0 : policy.hasura_person) !== null;
    });
  });
  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: heading
    }), hasPerson && /*#__PURE__*/jsx(ButtonWrapper$2, {
      children: /*#__PURE__*/jsx(Button$3, {
        theme: "orange",
        variant: "secondary",
        size: "small",
        onClick: function onClick() {
          return downloadCSV(payments, "".concat(csvBaseName, "-").concat(new Date().toISOString().replace(/[:.]/g, '-'), ".csv"));
        },
        children: "Download as CSV"
      })
    }), /*#__PURE__*/jsx(PageSection, {
      children: /*#__PURE__*/jsxs(Table$5, {
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx(Th$4, {
              children: "Ledger id"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Policy"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Insured object"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Customer"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Payment provider"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Scheduled collection date"
            }), /*#__PURE__*/jsx(Th$4, {
              children: "Index"
            }), /*#__PURE__*/jsx(ThRightAlign$3, {
              children: "Amount"
            }), /*#__PURE__*/jsx(ThRightAlign$3, {
              children: "Provider ref"
            }), /*#__PURE__*/jsx(Th$4, {})]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: payments.map(function (_ref3) {
            var _hasura_ledger$hasura, _hasura_ledger$hasura2, _hasura_ledger$hasura3;

            var index = _ref3.index,
                ledger_id = _ref3.ledger_id,
                hasura_ledger = _ref3.hasura_ledger,
                scheduled_collection_date = _ref3.scheduled_collection_date,
                total = _ref3.total,
                additional_info = _ref3.additional_info;
            return /*#__PURE__*/jsxs("tr", {
              children: [/*#__PURE__*/jsx(HideOverflow$6, {
                $maxWidth: "14rem",
                children: /*#__PURE__*/jsx("a", {
                  href: "".concat(LEDGERS, "/").concat(ledger_id),
                  children: /*#__PURE__*/jsx(Tooltip, {
                    title: "Go to ledger",
                    position: "top",
                    children: ledger_id
                  })
                })
              }), /*#__PURE__*/jsx("td", {
                children: hasura_ledger.hasura_policies[0] && /*#__PURE__*/jsx("a", {
                  href: "".concat(POLICIES, "/").concat(hasura_ledger.hasura_policies[0].id),
                  children: /*#__PURE__*/jsx(Tooltip, {
                    title: "Go to policy",
                    position: "top",
                    children: hasura_ledger.hasura_policies[0].policy_number
                  })
                })
              }), /*#__PURE__*/jsx(HideOverflow$6, {
                children: hasura_ledger.hasura_policies[0] && hasura_ledger.hasura_policies[0].object_name
              }), /*#__PURE__*/jsx(HideOverflow$6, {
                children: hasura_ledger.hasura_policies[0] && /*#__PURE__*/jsxs(Fragment, {
                  children: [hasura_ledger.hasura_policies[0].hasura_person.first_name, ' ', hasura_ledger.hasura_policies[0].hasura_person.last_name]
                })
              }), /*#__PURE__*/jsx("td", {
                children: (_hasura_ledger$hasura = (_hasura_ledger$hasura2 = hasura_ledger.hasura_ledger_mandates) === null || _hasura_ledger$hasura2 === void 0 ? void 0 : (_hasura_ledger$hasura3 = _hasura_ledger$hasura2[0]) === null || _hasura_ledger$hasura3 === void 0 ? void 0 : _hasura_ledger$hasura3.payment_provider) !== null && _hasura_ledger$hasura !== void 0 ? _hasura_ledger$hasura : ''
              }), /*#__PURE__*/jsx("td", {
                children: scheduled_collection_date
              }), /*#__PURE__*/jsx("td", {
                children: index
              }), /*#__PURE__*/jsx(TdRightAlign, {
                children: total.toLocaleString('sv-SE')
              }), /*#__PURE__*/jsx(TdMono, {
                children: providerRef(additional_info).text
              }), /*#__PURE__*/jsx("td", {
                children: /*#__PURE__*/jsx(Tooltip, {
                  title: additional_info,
                  position: "left",
                  children: /*#__PURE__*/jsx("div", {
                    children: /*#__PURE__*/jsx(Icon, {
                      iconName: "faInfoCircle"
                    })
                  })
                })
              })]
            }, "".concat(ledger_id, "_").concat(index));
          })
        })]
      })
    })]
  });
};
var Table$5 = styled.table(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  width: 100%;\n  table-layout: auto;\n\n  th,\n  td {\n    padding: 0.25rem 0.75rem 0.25rem 0;\n  }\n\n  tbody {\n    td {\n      border-bottom: 0.0625rem dotted #dedede;\n\n      a {\n        color: #fc8e49;\n\n        &:hover {\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"])));
var HideOverflow$6 = styled.td(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: ", ";\n"])), function (_ref4) {
  var $maxWidth = _ref4.$maxWidth;
  return $maxWidth || '0';
});
var TdRightAlign = styled.td(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var Th$4 = styled.th(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n"])));
var ThRightAlign$3 = styled(Th$4)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var TdMono = styled(TdRightAlign)(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;\n  padding-left: 1rem;\n"])));
var ButtonWrapper$2 = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));

var FailedRefundsView = function FailedRefundsView() {
  var _data$hasura_ledger_p;

  var _useFailedRefunds = useFailedRefunds(),
      loading = _useFailedRefunds.loading,
      data = _useFailedRefunds.data;

  if (loading) return /*#__PURE__*/jsx(Loading, {});
  return /*#__PURE__*/jsx(FailedPaymentsList, {
    payments: (_data$hasura_ledger_p = data === null || data === void 0 ? void 0 : data.hasura_ledger_payments) !== null && _data$hasura_ledger_p !== void 0 ? _data$hasura_ledger_p : [],
    heading: "Failed Refunds",
    csvBaseName: "failed-refunds"
  });
};

var _templateObject$y;

var LedgerBalance = function LedgerBalance(_ref) {
  var ledgerId = _ref.ledgerId;
  var ledgerContext$1 = useContext(ledgerContext);
  var ledgerBalance = ledgerContext$1.ledgerBalance,
      getLedgerBalance = ledgerContext$1.getLedgerBalance;
  useEffect(function () {
    getLedgerBalance(ledgerId);
  }, []);
  return ledgerBalance && /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Balance"
    }), ledgerBalance.status === 404 ? /*#__PURE__*/jsx("div", {
      children: ledgerBalance.message
    }) : /*#__PURE__*/jsxs(Grid$3, {
      children: [/*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Coverage"
        }), ledgerBalance.activeCoverageSum.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), ' ', "kr"]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Collected"
        }), ledgerBalance.collectedPaymentsSum.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), ' ', "kr"]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Refunded"
        }), ledgerBalance.refundedPaymentsSum.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), ' ', "kr"]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Difference"
        }), ledgerBalance.difference.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), ' ', "kr"]
      })]
    })]
  });
};

LedgerBalance.propTypes = {
  ledgerId: PropTypes.string.isRequired
};
var Grid$3 = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 1rem;\n\n  @media (min-width: 84rem) {\n    flex-direction: column;\n    gap: 0;\n  }\n"])));

var _templateObject$x, _templateObject2$i, _templateObject3$e;

var MandateFromLedgerItem = function MandateFromLedgerItem(_ref) {
  var policy = _ref.policy,
      selected = _ref.selected,
      setSelected = _ref.setSelected;
  var isSelected = policy.id === (selected === null || selected === void 0 ? void 0 : selected.id);

  var handleClick = function handleClick() {
    return setSelected(policy);
  };

  return /*#__PURE__*/jsxs(LedgerItem, {
    onClick: handleClick,
    children: [/*#__PURE__*/jsx(StateContainer, {
      isSelected: isSelected,
      children: isSelected ? /*#__PURE__*/jsx(Icon, {
        iconName: "faCheck"
      }) : /*#__PURE__*/jsx(Icon, {
        iconName: "faCircle"
      })
    }), /*#__PURE__*/jsxs(LedgerContainer, {
      isSelected: isSelected,
      children: [/*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Policy number"
        }), policy.policy_number]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Cover"
        }), policy.cover_level]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Payment provider"
        }), policy.hasura_ledger.hasura_ledger_mandates[0].payment_provider]
      }), /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsx("label", {
          children: "Added at"
        }), formatDateTime(policy.hasura_ledger.hasura_ledger_mandates[0].added_at)]
      })]
    })]
  });
};

MandateFromLedgerItem.propTypes = {
  policy: PropTypes.shape({
    cover_level: PropTypes.string.isRequired,
    hasura_ledger: PropTypes.shape({
      hasura_ledger_mandates: PropTypes.arrayOf(PropTypes.shape({
        added_at: PropTypes.string,
        payment_provider: PropTypes.string
      }))
    }),
    id: PropTypes.string.isRequired,
    policy_number: PropTypes.string.isRequired
  }).isRequired,
  selected: PropTypes.shape({
    id: PropTypes.string
  }),
  setSelected: PropTypes.func.isRequired
};
var StateContainer = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  padding: 0 0.5rem;\n  justify-content: center;\n  color: ", ";\n  background-color: ", ";\n  transition: 0.2s ease-in;\n"])), function (_ref2) {
  var isSelected = _ref2.isSelected;
  return isSelected ? '#42c67f' : '#fc8e49';
}, function (_ref3) {
  var isSelected = _ref3.isSelected;
  return isSelected ? '#e0f6ea' : '#fee6d7';
});
var LedgerItem = styled.li(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  border-bottom: 0.0625rem dotted #dedede;\n  cursor: pointer;\n\n  &:first-child {\n    border-top: 0.0625rem dotted #dedede;\n  }\n\n  &:hover ", " {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), StateContainer, function (_ref4) {
  var isSelected = _ref4.isSelected;
  return isSelected ? '#42c67f' : '#fff';
}, function (_ref5) {
  var isSelected = _ref5.isSelected;
  return isSelected ? '#e0f6ea' : '#fc8e49';
});
var LedgerContainer = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0.3rem;\n  background-color: ", ";\n  width: 100%;\n"])), function (_ref6) {
  var isSelected = _ref6.isSelected;
  return isSelected ? '#effaf4' : '#fafafa';
});

var _templateObject$w, _templateObject2$h;

var TransferMandate = function TransferMandate(_ref) {
  var ledgerId = _ref.ledgerId,
      userId = _ref.userId;

  var _useMandateSource = useMandateSource(userId, ledgerId),
      loading = _useMandateSource.loading,
      data = _useMandateSource.data;

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification,
      removeNotificationWithDelay = _useNotification.removeNotificationWithDelay;

  var _useRightPanel = useRightPanel(),
      hidePanel = _useRightPanel.hidePanel;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPosting = _useState4[0],
      setIsPosting = _useState4[1];

  useEffect(function () {
    if (data) {
      data.hasura_policies.length === 1 && setSelected(data.hasura_policies[0]);
    }
  }, [data]);
  if (loading) return 'Loading..';

  var handleTransferMandateClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsPosting(true);
              _context.prev = 1;
              _context.next = 4;
              return ledgerService.transferMandate(selected.hasura_ledger.id, ledgerId);

            case 4:
              hidePanel();
              removeNotificationWithDelay(addNotification('The mandate was succesfully transfered.', 'success'));
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              removeNotificationWithDelay(addNotification("Could not transfer mandate: ".concat(_context.t0.response.data.status, ": ").concat(_context.t0.response.data.message), 'alert'));

            case 11:
              _context.prev = 11;
              setIsPosting(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));

    return function handleTransferMandateClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return data.hasura_policies.length > 0 ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(ItemContainer, {
      children: [/*#__PURE__*/jsx("label", {
        children: "Select mandate source"
      }), /*#__PURE__*/jsx(PossibleSourceLedgers, {
        children: data.hasura_policies.map(function (policy) {
          return policy.hasura_ledger.hasura_ledger_mandates.length > 0 && /*#__PURE__*/jsx(MandateFromLedgerItem, {
            policy: policy,
            selected: selected,
            setSelected: setSelected
          }, policy.id);
        })
      })]
    }), /*#__PURE__*/jsxs(ButtonContainer$2, {
      children: [/*#__PURE__*/jsx(SecondaryButton, {
        disabled: isPosting,
        size: "small",
        onClick: hidePanel,
        children: "Cancel"
      }), /*#__PURE__*/jsx(PrimaryButton, {
        disabled: !selected || isPosting,
        size: "small",
        onClick: handleTransferMandateClick,
        children: "Transfer mandate"
      })]
    })]
  }) : /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      children: "There are no mandates to transfer."
    }), /*#__PURE__*/jsx(ButtonContainer$2, {
      children: /*#__PURE__*/jsx(PrimaryButton, {
        size: "small",
        onClick: hidePanel,
        children: "Close"
      })
    })]
  });
};

TransferMandate.propTypes = {
  ledgerId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired
};
var PossibleSourceLedgers = styled.ul(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
var ButtonContainer$2 = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    margin-left: 0.5rem;\n  }\n"])));

var _templateObject$v;

var LedgerOptionsMenu = function LedgerOptionsMenu(_ref) {
  var ledgerStatus = _ref.ledgerStatus,
      policyExists = _ref.policyExists,
      userId = _ref.userId;

  var _useAlert = useAlert(),
      clearAlert = _useAlert.clearAlert,
      setAlert = _useAlert.setAlert;

  var _useRightPanel = useRightPanel(),
      setContent = _useRightPanel.setContent,
      showPanel = _useRightPanel.showPanel;

  var match = useRouteMatch(LEDGER);
  var viewActions = global.definitions.views.find(function (view) {
    return view.name === 'ledger';
  }).actions.filter(function (action) {
    return action.show;
  });
  var menuItems = [];

  var showTransferMandatePanel = function showTransferMandatePanel() {
    setContent('Transfer mandate', /*#__PURE__*/jsx(TransferMandate, {
      ledgerId: match.params.ledgerId,
      userId: userId
    }));
    showPanel();
  };

  var abortLedger = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ledgerService.abort(match.params.ledgerId);

            case 3:
              setAlert({
                body: {
                  header: 'Ledger aborted',
                  message: "The ledger was successfully aborted."
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                      window.location.reload();
                    }
                  }
                },
                type: 'success'
              });
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              setAlert({
                body: {
                  header: 'Something went wrong',
                  message: "Could not abort the ledger: ".concat(_context.t0.response.data.status, ": ").concat(_context.t0.response.data.message)
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                    }
                  }
                },
                type: 'warning'
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));

    return function abortLedger() {
      return _ref2.apply(this, arguments);
    };
  }();

  var closeLedger = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return ledgerService.close(match.params.ledgerId);

            case 3:
              setAlert({
                body: {
                  header: 'Ledger closed',
                  message: "The ledger was successfully closed."
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                      window.location.reload();
                    }
                  }
                },
                type: 'success'
              });
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              setAlert({
                body: {
                  header: 'Something went wrong',
                  message: "Could not close the ledger: ".concat(_context2.t0.response.data.status, ": ").concat(_context2.t0.response.data.message)
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                    }
                  }
                },
                type: 'warning'
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));

    return function closeLedger() {
      return _ref3.apply(this, arguments);
    };
  }();

  var reopenLedger = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return ledgerService.reopen(match.params.ledgerId);

            case 3:
              setAlert({
                body: {
                  header: 'Ledger reopened',
                  message: "The ledger was successfully reopened."
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                      window.location.reload();
                    }
                  }
                },
                type: 'success'
              });
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              setAlert({
                body: {
                  header: 'Something went wrong',
                  message: "Could not reopen the ledger: ".concat(_context3.t0.response.data.status, ": ").concat(_context3.t0.response.data.message)
                },
                buttons: {
                  Ok: {
                    text: 'OK',
                    type: 'primary',
                    action: function action() {
                      clearAlert();
                    }
                  }
                },
                type: 'warning'
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6]]);
    }));

    return function reopenLedger() {
      return _ref4.apply(this, arguments);
    };
  }();

  if (viewActions.length > 0) {
    if (ledgerStatus === 'Open' || ledgerStatus === 'Initialized') {
      viewActions.find(function (action) {
        return action.name === 'abortLedger';
      }) && !policyExists && menuItems.push({
        text: 'Abort ledger',
        action: function action() {
          setAlert({
            body: {
              header: 'Abort ledger?',
              message: 'Do you want to abort the ledger?'
            },
            buttons: {
              Cancel: {
                text: 'Cancel',
                type: 'secondary',
                action: function action() {
                  clearAlert();
                }
              },
              Ok: {
                text: 'Abort ledger',
                type: 'primary',
                action: abortLedger
              }
            },
            type: 'question'
          });
        }
      });
      viewActions.find(function (action) {
        return action.name === 'closeLedger';
      }) && menuItems.push({
        text: 'Close ledger',
        action: function action() {
          setAlert({
            body: {
              header: 'Close ledger?',
              message: 'Do you want to close the ledger?'
            },
            buttons: {
              Cancel: {
                text: 'Cancel',
                type: 'secondary',
                action: function action() {
                  clearAlert();
                }
              },
              Ok: {
                text: 'Close ledger',
                type: 'primary',
                action: closeLedger
              }
            },
            type: 'question'
          });
        }
      });
    }

    if (ledgerStatus === 'Closed') {
      viewActions.find(function (action) {
        return action.name === 'reopenLedger';
      }) && menuItems.push({
        text: 'Reopen ledger',
        action: function action() {
          setAlert({
            body: {
              header: 'Reopen ledger?',
              message: 'Do you want to reopen the ledger?'
            },
            buttons: {
              Cancel: {
                text: 'Cancel',
                type: 'secondary',
                action: function action() {
                  clearAlert();
                }
              },
              Ok: {
                text: 'Reopen ledger',
                type: 'primary',
                action: reopenLedger
              }
            },
            type: 'question'
          });
        }
      });
    }

    if (policyExists && viewActions.find(function (action) {
      return action.name === 'transferMandate';
    })) {
      menuItems.push({
        text: 'Transfer mandate',
        action: showTransferMandatePanel
      });
    }
  }

  return menuItems.length > 0 && /*#__PURE__*/jsx(OptionsMenuListItem, {
    children: /*#__PURE__*/jsx(OptionsMenu, {
      menuItems: menuItems
    })
  });
};

LedgerOptionsMenu.propTypes = {
  ledgerStatus: PropTypes.string.isRequired,
  policyExists: PropTypes.bool.isRequired,
  userId: PropTypes.string
};
var OptionsMenuListItem = styled.li(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  margin-right: 0;\n  margin-left: auto;\n"])));

// What a refund would actually send: collected minus any prior partial refunds.
var refundableAmount = function refundableAmount(_ref) {
  var amount_refunded = _ref.amount_refunded,
      collected_amount = _ref.collected_amount;
  return collected_amount != null ? collected_amount - (amount_refunded !== null && amount_refunded !== void 0 ? amount_refunded : 0) : null;
};

var _templateObject$u, _templateObject2$g, _templateObject3$d, _templateObject4$a, _templateObject5$5, _templateObject6$2, _templateObject7$2;
var colors = {
  default: {
    backgroundColor: 'inherit',
    color: 'inherit'
  },
  alert: {
    backgroundColor: '#f8d7da',
    color: '#721c24'
  }
};

var LedgerPaymentItem = function LedgerPaymentItem(_ref) {
  var _ref$payment = _ref.payment,
      additional_info = _ref$payment.additional_info,
      amount_refunded = _ref$payment.amount_refunded,
      collected_amount = _ref$payment.collected_amount,
      fee = _ref$payment.fee,
      index = _ref$payment.index,
      ledger_id = _ref$payment.ledger_id,
      pay_date = _ref$payment.pay_date,
      period_duration = _ref$payment.period_duration,
      period_end = _ref$payment.period_end,
      period_start = _ref$payment.period_start,
      premium = _ref$payment.premium,
      scheduled_collection_date = _ref$payment.scheduled_collection_date,
      status = _ref$payment.status,
      tax = _ref$payment.tax,
      total = _ref$payment.total,
      refetchPayments = _ref.refetchPayments;

  var _useAlert = useAlert(),
      clearAlert = _useAlert.clearAlert,
      setAlert = _useAlert.setAlert;

  var ledgerContext$1 = useContext(ledgerContext);
  var getLedgerBalance = ledgerContext$1.getLedgerBalance;

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification,
      removeNotificationWithDelay = _useNotification.removeNotificationWithDelay;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCommittingAction = _useState4[0],
      setIsCommittingAction = _useState4[1]; // A refund has been dispatched for this slot's adjustment. The backend keeps
  // the slot as UpcomingRefundDueToAdjustment until the bank confirms — and
  // rejects a second refund meanwhile — so hide the button once one is fired.


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      refundInitiated = _useState6[0],
      setRefundInitiated = _useState6[1];

  var amount = function amount() {
    var _collected_amount$toL, _amount_refunded$toLo;

    switch (status) {
      case 'Collected':
      case 'Refunding':
      case 'RefundFailed':
        return (_collected_amount$toL = collected_amount === null || collected_amount === void 0 ? void 0 : collected_amount.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })) !== null && _collected_amount$toL !== void 0 ? _collected_amount$toL : '-';

      case 'Refunded':
      case 'PartiallyRefunded':
        return (_amount_refunded$toLo = amount_refunded === null || amount_refunded === void 0 ? void 0 : amount_refunded.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })) !== null && _amount_refunded$toLo !== void 0 ? _amount_refunded$toLo : '-';

      default:
        return '-';
    }
  };

  var providerRef = function providerRef() {
    var _parsed$params$data$o, _parsed, _parsed$params, _parsed$params$data;

    if (additional_info == null) return {
      text: ''
    };
    var parsed;

    try {
      parsed = JSON.parse(additional_info);
    } catch (err) {
      return {
        text: 'error',
        title: err.message
      };
    }

    if (typeof parsed === 'string') return {
      text: ''
    };
    return {
      text: (_parsed$params$data$o = (_parsed = parsed) === null || _parsed === void 0 ? void 0 : (_parsed$params = _parsed.params) === null || _parsed$params === void 0 ? void 0 : (_parsed$params$data = _parsed$params.data) === null || _parsed$params$data === void 0 ? void 0 : _parsed$params$data.orderid) !== null && _parsed$params$data$o !== void 0 ? _parsed$params$data$o : '-'
    };
  };

  var prettyAdditionalInfo = function prettyAdditionalInfo() {
    try {
      var _parsed$error, _parsed$Left;

      var parsed = JSON.parse(additional_info); // Six legacy lin charge-failures (from 2020) wrapped the error in a `Left`.

      var error = (_parsed$error = parsed === null || parsed === void 0 ? void 0 : parsed.error) !== null && _parsed$error !== void 0 ? _parsed$error : parsed === null || parsed === void 0 ? void 0 : (_parsed$Left = parsed.Left) === null || _parsed$Left === void 0 ? void 0 : _parsed$Left.error;

      if (error && typeof error.body === 'string') {
        try {
          error.body = JSON.parse(error.body);
        } catch (_unused) {// body isn't JSON-encoded; leave the original string
        }
      }

      return JSON.stringify(parsed, undefined, 2);
    } catch (_unused2) {
      return additional_info;
    }
  };

  var handleToggleShowAdditionalInfoClick = function handleToggleShowAdditionalInfoClick() {
    return setShowInfo(!showInfo);
  };

  var handleRetryCollectionClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsCommittingAction(true);
              _context.prev = 1;
              _context.next = 4;
              return ledgerService.retryCollect(ledger_id, index);

            case 4:
              setTimeout(function () {
                removeNotificationWithDelay(addNotification('Retry of collection of payment has been initialized.', 'success'));
                refetchPayments();
                setIsCommittingAction(false);
              }, 1000);
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0.response);
              removeNotificationWithDelay(addNotification("Something went wrong when trying to initialize retry of payment collection: ".concat(_context.t0.response.data.status, " ").concat(_context.t0.response.data.message), 'alert'));
              setIsCommittingAction(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function handleRetryCollectionClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRefundPaymentClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var refundPayment;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              refundPayment = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var _err$response$data$me, _err$response, _err$response$data, alreadyInFlight;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // Optimistically hide the button: a refund is now in flight for this slot.
                          setRefundInitiated(true);
                          clearAlert();
                          _context2.prev = 2;
                          _context2.next = 5;
                          return ledgerService.refundPayment(ledger_id, index);

                        case 5:
                          setAlert({
                            body: {
                              header: 'Refund of payment initilized',
                              message: "Payment refund of ".concat(total.toLocaleString('sv-SE', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }), " has successfully been initilized.")
                            },
                            buttons: {
                              Ok: {
                                text: 'OK',
                                type: 'primary',
                                action: function action() {
                                  refetchPayments();
                                  getLedgerBalance(ledger_id);
                                  clearAlert();
                                }
                              }
                            },
                            type: 'success'
                          });
                          _context2.next = 12;
                          break;

                        case 8:
                          _context2.prev = 8;
                          _context2.t0 = _context2["catch"](2);
                          alreadyInFlight = /already been dispatched/i.test((_err$response$data$me = (_err$response = _context2.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) !== null && _err$response$data$me !== void 0 ? _err$response$data$me : '');

                          if (alreadyInFlight) {
                            // A refund is already awaiting the bank (e.g. re-clicked after a page
                            // reload cleared the local flag). Keep the button hidden, say so plainly.
                            setAlert({
                              body: {
                                header: 'Refund already in progress',
                                message: 'A refund for this payment has already been dispatched and is awaiting the bank’s confirmation.'
                              },
                              buttons: {
                                Ok: {
                                  text: 'OK',
                                  type: 'primary',
                                  action: function action() {
                                    refetchPayments();
                                    getLedgerBalance(ledger_id);
                                    clearAlert();
                                  }
                                }
                              },
                              type: 'success'
                            });
                          } else {
                            // The refund never dispatched — let the operator try again.
                            setRefundInitiated(false);
                            setAlert({
                              body: {
                                header: 'Something went wrong',
                                message: "Could not initilize payment refund of ".concat(total.toLocaleString('sv-SE', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }), ": ").concat(_context2.t0.response.data.status, " ").concat(_context2.t0.response.data.message)
                              },
                              buttons: {
                                Ok: {
                                  text: 'OK',
                                  type: 'primary',
                                  action: function action() {
                                    clearAlert();
                                  }
                                }
                              },
                              type: 'warning'
                            });
                          }

                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[2, 8]]);
                }));

                return function refundPayment() {
                  return _ref4.apply(this, arguments);
                };
              }();

              setAlert({
                body: {
                  header: 'Refund payment?',
                  message: "Do you want refund payment of ".concat(total.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }), "?")
                },
                buttons: {
                  Cancel: {
                    type: 'secondary',
                    text: 'No',
                    action: function action() {
                      clearAlert();
                    }
                  },
                  Ok: {
                    type: 'primary',
                    text: 'Make refund',
                    action: refundPayment
                  }
                },
                type: 'question'
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleRefundPaymentClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  var refundableAmount$1 = refundableAmount({
    amount_refunded: amount_refunded,
    collected_amount: collected_amount
  });

  var handleRetryRefundClick = function handleRetryRefundClick() {
    var retryRefund = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return ledgerService.refund(ledger_id, index, refundableAmount$1.toFixed(2));

              case 3:
                setAlert({
                  body: {
                    header: 'Refund retried',
                    message: "A new refund of ".concat(refundableAmount$1.toLocaleString('sv-SE', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }), " kr has been sent to the payment provider.")
                  },
                  buttons: {
                    Ok: {
                      text: 'OK',
                      type: 'primary',
                      action: function action() {
                        refetchPayments();
                        getLedgerBalance(ledger_id);
                        clearAlert();
                      }
                    }
                  },
                  type: 'success'
                });
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                setAlert({
                  body: {
                    header: 'Refund failed',
                    message: "The refund could not be completed: ".concat(_context4.t0.response.data.status, " ").concat(_context4.t0.response.data.message)
                  },
                  buttons: {
                    Ok: {
                      text: 'OK',
                      type: 'primary',
                      action: function action() {
                        clearAlert();
                      }
                    }
                  },
                  type: 'warning'
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }));

      return function retryRefund() {
        return _ref5.apply(this, arguments);
      };
    }();

    setAlert({
      body: {
        header: 'Retry refund?',
        message: "Do you want to retry the refund of ".concat(refundableAmount$1.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), " kr?")
      },
      buttons: {
        Cancel: {
          type: 'secondary',
          text: 'No',
          action: function action() {
            clearAlert();
          }
        },
        Ok: {
          type: 'primary',
          text: 'Retry refund',
          action: retryRefund
        }
      },
      type: 'question'
    });
  };

  var ref = providerRef(); // A string-shaped additional_info is one of our own messages, not provider data.

  var internal = additional_info === null || additional_info === void 0 ? void 0 : additional_info.trimStart().startsWith('"');
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Tr, {
      theme: status === 'Failed' || status === 'RefundFailed' ? 'alert' : 'default',
      children: [/*#__PURE__*/jsx(Td$1, {
        children: index
      }), /*#__PURE__*/jsx(Td$1, {
        children: status
      }), /*#__PURE__*/jsx(Td$1, {
        children: scheduled_collection_date
      }), /*#__PURE__*/jsx(Td$1, {
        children: pay_date ? pay_date : '-'
      }), /*#__PURE__*/jsx(RightAlignedTd$1, {
        children: amount()
      }), /*#__PURE__*/jsx(Td$1, {
        children: period_start
      }), /*#__PURE__*/jsx(Td$1, {
        children: period_end
      }), /*#__PURE__*/jsxs(Td$1, {
        children: [period_duration, " days"]
      }), /*#__PURE__*/jsx(RightAlignedTd$1, {
        children: premium.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }), /*#__PURE__*/jsx(RightAlignedTd$1, {
        children: tax.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }), /*#__PURE__*/jsx(RightAlignedTd$1, {
        children: fee.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }), /*#__PURE__*/jsx(RightAlignedTd$1, {
        children: total.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }), /*#__PURE__*/jsx(ProviderRefTd, {
        title: ref.title,
        hasTitle: !!ref.title,
        children: ref.text
      }), /*#__PURE__*/jsx(Td$1, {
        children: status === 'Failed' && /*#__PURE__*/jsxs(ShowInfo, {
          onClick: handleToggleShowAdditionalInfoClick,
          children: [showInfo ? 'Hide' : 'Show', " info"]
        })
      }), /*#__PURE__*/jsxs(Td$1, {
        children: [status === 'Failed' && /*#__PURE__*/jsx(Button$3, {
          size: "small",
          disabled: isCommittingAction,
          onClick: handleRetryCollectionClick,
          children: "Retry"
        }), status === 'UpcomingRefundDueToAdjustment' && (refundInitiated ? /*#__PURE__*/jsx(RefundPending, {
          children: "Refund pending"
        }) : /*#__PURE__*/jsx(Button$3, {
          size: "small",
          onClick: handleRefundPaymentClick,
          children: "Refund"
        })), status === 'RefundFailed' && refundableAmount$1 != null && /*#__PURE__*/jsx(Button$3, {
          size: "small",
          onClick: handleRetryRefundClick,
          children: "Retry refund"
        })]
      })]
    }), status === 'Failed' && /*#__PURE__*/jsx("tr", {
      children: /*#__PURE__*/jsx(AdditionalInfo$1, {
        show: showInfo,
        colSpan: "14",
        children: /*#__PURE__*/jsxs("div", {
          theme: "default",
          children: [internal && /*#__PURE__*/jsx("em", {
            children: "Internal check \u2014 no charge sent to the provider, so no order id."
          }), /*#__PURE__*/jsx("pre", {
            children: prettyAdditionalInfo()
          })]
        })
      })
    })]
  });
};

LedgerPaymentItem.propTypes = {
  payment: PropTypes.shape({
    additional_info: PropTypes.string,
    amount_refunded: PropTypes.number,
    collected_amount: PropTypes.number,
    fee: PropTypes.number,
    index: PropTypes.number,
    ledger_id: PropTypes.string,
    pay_date: PropTypes.string,
    period_duration: PropTypes.number,
    period_end: PropTypes.string,
    period_start: PropTypes.string,
    premium: PropTypes.number,
    status: PropTypes.string,
    tax: PropTypes.number,
    total: PropTypes.number
  }).isRequired,
  refetchPayments: PropTypes.func.isRequired
};
var Td$1 = styled.td(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  padding: 0.2rem 0.5rem;\n  border-bottom: 0.0625rem dotted #dedede;\n\n  &:last-child {\n    span {\n      cursor: pointer;\n    }\n  }\n"])));
var RightAlignedTd$1 = styled(Td$1)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var ProviderRefTd = styled(Td$1)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  border-left: 0.0625rem solid #dedede;\n  padding-left: 0.85rem;\n  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;\n  color: #6b6d7c;\n  cursor: ", ";\n"])), function (_ref6) {
  var hasTitle = _ref6.hasTitle;
  return hasTitle ? 'help' : 'inherit';
});
var Tr = styled.tr(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  td {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return colors[theme].backgroundColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return colors[theme].color;
});
var AdditionalInfo$1 = styled.td(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n  padding: 0;\n  background-color: #fafafa;\n\n  div {\n    padding: ", ";\n    overflow-x: auto;\n    max-height: ", ";\n    transition: all 0.2s;\n\n    pre {\n      overflow-x: auto;\n    }\n  }\n"])), function (_ref9) {
  var show = _ref9.show;
  return show ? '0.5rem 0.2rem' : 0;
}, function (_ref10) {
  var show = _ref10.show;
  return show ? '20rem' : 0;
});
var ShowInfo = styled.span(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  cursor: pointer;\n"])));
var RefundPending = styled.span(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  color: #7b7d8c;\n  font-style: italic;\n"])));

var _templateObject$t, _templateObject2$f, _templateObject3$c;

var LedgerPaymentItemForRefund = function LedgerPaymentItemForRefund(_ref) {
  var _ref$payment = _ref.payment,
      amount_refunded = _ref$payment.amount_refunded,
      collected_amount = _ref$payment.collected_amount,
      fee = _ref$payment.fee,
      index = _ref$payment.index,
      ledger_id = _ref$payment.ledger_id,
      pay_date = _ref$payment.pay_date,
      period_duration = _ref$payment.period_duration,
      period_end = _ref$payment.period_end,
      period_start = _ref$payment.period_start,
      premium = _ref$payment.premium,
      status = _ref$payment.status,
      tax = _ref$payment.tax,
      total = _ref$payment.total,
      refetchPayments = _ref.refetchPayments;
  var ledgerContext$1 = useContext(ledgerContext);
  var getLedgerBalance = ledgerContext$1.getLedgerBalance;

  var _useAlert = useAlert(),
      clearAlert = _useAlert.clearAlert,
      setAlert = _useAlert.setAlert;

  var refundableAmount$1 = refundableAmount({
    amount_refunded: amount_refunded,
    collected_amount: collected_amount
  });

  var amount = function amount() {
    var _collected_amount$toL, _amount_refunded$toLo;

    switch (status) {
      case 'Collected':
      case 'Refunding':
      case 'RefundFailed':
        return (_collected_amount$toL = collected_amount === null || collected_amount === void 0 ? void 0 : collected_amount.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })) !== null && _collected_amount$toL !== void 0 ? _collected_amount$toL : '-';

      case 'Refunded':
      case 'PartiallyRefunded':
        return (_amount_refunded$toLo = amount_refunded === null || amount_refunded === void 0 ? void 0 : amount_refunded.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })) !== null && _amount_refunded$toLo !== void 0 ? _amount_refunded$toLo : '-';

      default:
        return '-';
    }
  };

  var handleRefundPaymentClick = function handleRefundPaymentClick() {
    var refundPayment = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var roundedAmount;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                roundedAmount = refundableAmount$1.toFixed(2);
                _context.next = 4;
                return ledgerService.refund(ledger_id, index, roundedAmount);

              case 4:
                setAlert({
                  body: {
                    header: 'Refund completed',
                    message: "The collected amount of ".concat(refundableAmount$1.toLocaleString('sv-SE', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }), " kr has been refunded.")
                  },
                  buttons: {
                    ok: {
                      type: 'primary',
                      text: 'OK',
                      action: function action() {
                        refetchPayments();
                        getLedgerBalance(ledger_id);
                        clearAlert();
                      }
                    }
                  },
                  type: 'success'
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                setAlert({
                  body: {
                    header: 'Refund failed',
                    message: "The refund could not be completed: ".concat(_context.t0.response.data.status, " ").concat(_context.t0.response.data.message)
                  },
                  buttons: {
                    ok: {
                      type: 'primary',
                      text: 'OK',
                      action: function action() {
                        clearAlert();
                      }
                    }
                  },
                  type: 'warning'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function refundPayment() {
        return _ref2.apply(this, arguments);
      };
    }();

    setAlert({
      body: {
        header: 'Refund payment?',
        message: "Do you want to refund the payment of ".concat(refundableAmount$1.toLocaleString('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), "? ")
      },
      buttons: {
        cancel: {
          type: 'secondary',
          text: 'Cancel',
          action: function action() {
            clearAlert();
          }
        },
        ok: {
          type: 'primary',
          text: 'Make refund',
          action: refundPayment
        }
      },
      type: 'question'
    });
  };

  return /*#__PURE__*/jsxs("tr", {
    children: [/*#__PURE__*/jsx("td", {
      children: index
    }), /*#__PURE__*/jsx("td", {
      children: status
    }), /*#__PURE__*/jsx("td", {
      children: pay_date ? pay_date : '-'
    }), /*#__PURE__*/jsx(RightAlignedTd, {
      children: amount()
    }), /*#__PURE__*/jsx("td", {
      children: period_start
    }), /*#__PURE__*/jsx("td", {
      children: period_end
    }), /*#__PURE__*/jsxs("td", {
      children: [period_duration, " days"]
    }), /*#__PURE__*/jsx(RightAlignedTd, {
      children: premium.toLocaleString('sv-SE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }), /*#__PURE__*/jsx(RightAlignedTd, {
      children: tax.toLocaleString('sv-SE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }), /*#__PURE__*/jsx(RightAlignedTd, {
      children: fee.toLocaleString('sv-SE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }), /*#__PURE__*/jsx(RightAlignedTd, {
      children: total.toLocaleString('sv-SE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }), /*#__PURE__*/jsx("td", {
      children: (status === 'Collected' || status === 'RefundFailed' && refundableAmount$1 != null) && /*#__PURE__*/jsx(ButtonContainer$1, {
        children: /*#__PURE__*/jsxs(PrimaryButton, {
          size: "small",
          onClick: handleRefundPaymentClick,
          children: ["Refund", ' ', refundableAmount$1.toLocaleString('sv-SE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })]
        })
      })
    })]
  });
};

LedgerPaymentItemForRefund.propTypes = {
  payment: PropTypes.shape({
    amount_refunded: PropTypes.number,
    collected_amount: PropTypes.number,
    fee: PropTypes.number,
    index: PropTypes.number,
    ledger_id: PropTypes.string,
    pay_date: PropTypes.string,
    period_duration: PropTypes.number,
    period_end: PropTypes.string,
    period_start: PropTypes.string,
    premium: PropTypes.number,
    status: PropTypes.string,
    tax: PropTypes.number,
    total: PropTypes.number
  }).isRequired,
  refetchPayments: PropTypes.func.isRequired
};
var Td = styled.td(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral([""])));
var RightAlignedTd = styled(Td)(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var ButtonContainer$1 = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  display: flex;\n\n  button {\n    &:first-child {\n      margin-right: 0.25rem;\n    }\n  }\n"])));

var _templateObject$s, _templateObject2$e, _templateObject3$b, _templateObject4$9, _templateObject5$4;

var LedgerPayments = function LedgerPayments(_ref) {
  var payments = _ref.payments,
      refetchPayments = _ref.refetchPayments;
  var ledgerContext$1 = useContext(ledgerContext);
  var setShowRefund = ledgerContext$1.setShowRefund;
  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsxs(HeaderContainer, {
      children: [/*#__PURE__*/jsx("h3", {
        children: "Payment information"
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(OptionsMenu, {
          menuItems: [{
            text: 'Make refund',
            action: function action() {
              setShowRefund(true);
            }
          }]
        })
      })]
    }), /*#__PURE__*/jsxs(Table$4, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx(Th$3, {
            children: "Idx"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Status"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Scheduled"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Collected"
          }), /*#__PURE__*/jsx(ThRightAlign$2, {
            children: "Amount"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Period start"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Period end"
          }), /*#__PURE__*/jsx(Th$3, {
            children: "Duration"
          }), /*#__PURE__*/jsx(ThRightAlign$2, {
            children: "Premium"
          }), /*#__PURE__*/jsx(ThRightAlign$2, {
            children: "Tax"
          }), /*#__PURE__*/jsx(ThRightAlign$2, {
            children: "Fee"
          }), /*#__PURE__*/jsx(ThRightAlign$2, {
            children: "Total"
          }), /*#__PURE__*/jsx(RefTh, {
            children: "Provider ref"
          }), /*#__PURE__*/jsx(Th$3, {}), /*#__PURE__*/jsx(Th$3, {})]
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: payments.map(function (payment) {
          return /*#__PURE__*/jsx(LedgerPaymentItem, {
            payment: payment,
            refetchPayments: refetchPayments
          }, "".concat(payment.ledger_id, "_").concat(payment.index));
        })
      })]
    })]
  });
};

LedgerPayments.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    additional_info: PropTypes.string,
    amount_refunded: PropTypes.number,
    collected_amount: PropTypes.number,
    index: PropTypes.number,
    fee: PropTypes.number,
    ledger_id: PropTypes.string,
    pay_date: PropTypes.string,
    period_duration: PropTypes.number,
    period_end: PropTypes.string,
    period_start: PropTypes.string,
    premium: PropTypes.number,
    status: PropTypes.string,
    tax: PropTypes.number,
    total: PropTypes.number
  })).isRequired,
  refetchPayments: PropTypes.func.isRequired
};
var Table$4 = styled.table(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  font-size: 0.8rem;\n"])));
var Th$3 = styled.th(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n  padding: 0 0.25rem;\n"])));
var ThRightAlign$2 = styled(Th$3)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var RefTh = styled(Th$3)(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  border-left: 0.0625rem solid #dedede;\n  padding-left: 0.85rem;\n"])));
var HeaderContainer = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  display: flex;\n\n  div {\n    margin-left: auto;\n  }\n"])));

var _templateObject$r, _templateObject2$d, _templateObject3$a, _templateObject4$8;

var LedgerPaymentsForRefund = function LedgerPaymentsForRefund(_ref) {
  var payments = _ref.payments,
      refetchPayments = _ref.refetchPayments;
  return /*#__PURE__*/jsxs(Table$3, {
    children: [/*#__PURE__*/jsx("thead", {
      children: /*#__PURE__*/jsxs("tr", {
        children: [/*#__PURE__*/jsx(Th$2, {
          children: "Index"
        }), /*#__PURE__*/jsx(Th$2, {
          children: "Status"
        }), /*#__PURE__*/jsx(Th$2, {
          children: "Pay date"
        }), /*#__PURE__*/jsx(ThRightAlign$1, {
          children: "Amount"
        }), /*#__PURE__*/jsx(Th$2, {
          children: "Period start"
        }), /*#__PURE__*/jsx(Th$2, {
          children: "Period end"
        }), /*#__PURE__*/jsx(Th$2, {
          children: "Period duration"
        }), /*#__PURE__*/jsx(ThRightAlign$1, {
          children: "Premium"
        }), /*#__PURE__*/jsx(ThRightAlign$1, {
          children: "Tax"
        }), /*#__PURE__*/jsx(ThRightAlign$1, {
          children: "Fee"
        }), /*#__PURE__*/jsx(ThRightAlign$1, {
          children: "Total"
        }), /*#__PURE__*/jsx(Th$2, {})]
      })
    }), /*#__PURE__*/jsx(Tbody, {
      children: payments.map(function (payment) {
        return /*#__PURE__*/jsx(LedgerPaymentItemForRefund, {
          payment: payment,
          refetchPayments: refetchPayments
        }, "".concat(payment.ledger_id, "_").concat(payment.index));
      })
    })]
  });
};

LedgerPaymentsForRefund.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    amount_refunded: PropTypes.number,
    collected_amount: PropTypes.number,
    fee: PropTypes.number,
    index: PropTypes.number,
    ledger_id: PropTypes.string,
    pay_date: PropTypes.string,
    period_duration: PropTypes.number,
    period_end: PropTypes.string,
    period_start: PropTypes.string,
    premium: PropTypes.number,
    status: PropTypes.string,
    tax: PropTypes.number,
    total: PropTypes.number
  })).isRequired,
  refetchPayments: PropTypes.func.isRequired
};
var Table$3 = styled.table(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n"])));
var Th$2 = styled.th(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n  padding: 0 0.5rem;\n"])));
var ThRightAlign$1 = styled(Th$2)(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var Tbody = styled.tbody(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n  td {\n    padding: 0.2rem 0.5rem;\n    border-bottom: 0.0625rem dotted #dedede;\n  }\n"])));

var _templateObject$q;

var Refund = function Refund(_ref) {
  var payments = _ref.payments,
      refetchPayments = _ref.refetchPayments;
  var ledgerContext$1 = useContext(ledgerContext);
  var showRefund = ledgerContext$1.showRefund,
      setShowRefund = ledgerContext$1.setShowRefund;

  var handleCloseClick = function handleCloseClick() {
    return setShowRefund(false);
  };

  return showRefund && /*#__PURE__*/jsx(OverlayBackground, {
    children: /*#__PURE__*/jsxs(PageSection, {
      children: [/*#__PURE__*/jsx("h3", {
        children: "Refund payments"
      }), /*#__PURE__*/jsx(LedgerPaymentsForRefund, {
        payments: payments,
        refetchPayments: refetchPayments
      }), /*#__PURE__*/jsx(ButtonContainer, {
        children: /*#__PURE__*/jsx(PrimaryButton, {
          onClick: handleCloseClick,
          children: "Close"
        })
      })]
    })
  });
};

Refund.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    amount_refunded: PropTypes.number,
    collected_amount: PropTypes.number,
    fee: PropTypes.number,
    index: PropTypes.number,
    ledger_id: PropTypes.string,
    pay_date: PropTypes.string,
    period_duration: PropTypes.number,
    period_end: PropTypes.string,
    period_start: PropTypes.string,
    premium: PropTypes.number,
    status: PropTypes.string,
    tax: PropTypes.number,
    total: PropTypes.number
  })).isRequired,
  refetchPayments: PropTypes.func.isRequired
};
var ButtonContainer = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n"])));

const ChangeLog = ({ changeLog }) => {
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Change log" }) }), jsx("main", { children: changeLog
                    .sort((a, b) => (a.changeSequence < b.changeSequence ? 1 : -1))
                    .map(logItem => (jsxs(ChangeLogItem, { children: [jsx("span", { children: formatDateTime(logItem.time) }), jsxs("p", { children: [logItem.log, ' ', logItem.userIdentifier && (jsxs(Italic, { children: ["by ", logItem.userIdentifier] }))] })] }, logItem.changeSequence))) })] }));
};
const ChangeLogItem = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 0.3rem;

  span {
    font-size: 0.8rem;
    font-weight: 300;
    color: #7b7d8c;
  }
`;
const Italic = styled.span `
  font-style: italic;
`;

var _templateObject$p, _templateObject2$c, _templateObject3$9, _templateObject4$7, _templateObject5$3;

var LedgerView = function LedgerView() {
  var _useRightPanel = useRightPanel(),
      hidePanel = _useRightPanel.hidePanel;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      changeLog = _useState2[0],
      setChangeLog = _useState2[1];

  var match = useRouteMatch(LEDGER);
  var ledgerId = match.params.ledgerId;

  var _usePaymentInfo = usePaymentInfo(ledgerId),
      loading = _usePaymentInfo.loading,
      data = _usePaymentInfo.data,
      refetch = _usePaymentInfo.refetch;

  useEffect(function () {
    var getChangeLog = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = setChangeLog;
                _context.next = 3;
                return ledgerService.log(ledgerId);

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getChangeLog() {
        return _ref.apply(this, arguments);
      };
    }();

    getChangeLog();
    return function () {
      return hidePanel();
    };
  }, []);
  if (loading) return /*#__PURE__*/jsx(Loading, {});
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(ContentContainer, {
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsxs(H1$2, {
          children: ["Ledger (", data.hasura_ledgers[0].status, ")"]
        }), data.hasura_policy_insurance_holders.length > 0 && /*#__PURE__*/jsxs(H2$2, {
          children: [data.hasura_policy_insurance_holders[0].policy.object_name, ":", ' ', data.hasura_policy_insurance_holders[0].policy.product_name, ",", ' ', data.hasura_policy_insurance_holders[0].policy.cover_level]
        })]
      }), /*#__PURE__*/jsxs(SubNavigation$1, {
        children: [data.hasura_policy_insurance_holders[0] && /*#__PURE__*/jsx("li", {
          children: /*#__PURE__*/jsx(NavLink, {
            to: "".concat(POLICIES, "/").concat(data.hasura_policy_insurance_holders[0].policy.id),
            exact: true,
            children: "Policy"
          })
        }), /*#__PURE__*/jsx("li", {
          children: /*#__PURE__*/jsx(NavLink, {
            to: "".concat(QUOTES, "/").concat(data.hasura_ledgers[0].quote_id),
            exact: true,
            children: "Quote"
          })
        }), /*#__PURE__*/jsx(LedgerOptionsMenu, {
          ledgerStatus: data.hasura_ledgers[0].status,
          policyExists: data.hasura_policy_insurance_holders[0] ? true : false,
          userId: data.hasura_policy_insurance_holders[0] ? data.hasura_policy_insurance_holders[0].holder_type === 'PersonInsuranceHolderType' ? data.hasura_policy_insurance_holders[0].person_holder.id : data.hasura_policy_insurance_holders[0].company_record.id : null
        })]
      }), /*#__PURE__*/jsxs(Grid$2, {
        children: [data.hasura_policy_insurance_holders.length > 0 && /*#__PURE__*/jsx(CustomerInformationWrapper$1, {
          children: /*#__PURE__*/jsx(CustomerInformation, {
            company: data.hasura_policy_insurance_holders[0].company_record,
            person: data.hasura_policy_insurance_holders[0].person_holder,
            refetch: refetch
          })
        }), /*#__PURE__*/jsx(LedgerBalance, {
          ledgerId: ledgerId
        }), /*#__PURE__*/jsx(LedgerPayments, {
          payments: data.hasura_ledgers[0].hasura_ledger_payments,
          refetchPayments: refetch
        }), /*#__PURE__*/jsx(ChangeLogContainer, {
          children: changeLog && /*#__PURE__*/jsx(ChangeLog, {
            changeLog: changeLog
          })
        })]
      })]
    }), /*#__PURE__*/jsx(Refund, {
      payments: data.hasura_ledgers[0].hasura_ledger_payments,
      refetchPayments: refetch
    })]
  });
};
var Grid$2 = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.5rem;\n\n  @media (min-width: 84rem) {\n    grid-template-columns: 2fr 10fr;\n  }\n"])));
var ChangeLogContainer = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  @media (min-width: 84rem) {\n    grid-column: 1 / span 2;\n  }\n"])));
var CustomerInformationWrapper$1 = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  grid-column: 1 / span 2;\n"])));
var H1$2 = styled.h1(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
var H2$2 = styled.h2(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  color: #7b7d8c;\n"])));

var LedgersView = function LedgersView() {
  var _data$hasura_ledger_p;

  var _useFailedPayments = useFailedPayments(),
      loading = _useFailedPayments.loading,
      data = _useFailedPayments.data;

  if (loading) return /*#__PURE__*/jsx(Loading, {});
  return /*#__PURE__*/jsx(FailedPaymentsList, {
    payments: (_data$hasura_ledger_p = data === null || data === void 0 ? void 0 : data.hasura_ledger_payments) !== null && _data$hasura_ledger_p !== void 0 ? _data$hasura_ledger_p : [],
    heading: "Failed payments",
    csvBaseName: "failed-payments"
  });
};

var _templateObject$o, _templateObject2$b, _templateObject3$8, _templateObject4$6;

var holderInfo = function holderInfo(policy) {
  var _policy$hasura_policy, _person$email, _person$telephone;

  var holder = policy === null || policy === void 0 ? void 0 : (_policy$hasura_policy = policy.hasura_policy_insurance_holders) === null || _policy$hasura_policy === void 0 ? void 0 : _policy$hasura_policy[0];
  var company = holder === null || holder === void 0 ? void 0 : holder.company_record;
  var person = holder === null || holder === void 0 ? void 0 : holder.person_holder;

  if (company) {
    var _company$name, _company$email, _company$phone;

    return {
      name: (_company$name = company.name) !== null && _company$name !== void 0 ? _company$name : '',
      email: (_company$email = company.email) !== null && _company$email !== void 0 ? _company$email : '',
      phone: (_company$phone = company.phone) !== null && _company$phone !== void 0 ? _company$phone : ''
    };
  }

  return {
    name: [person === null || person === void 0 ? void 0 : person.first_name, person === null || person === void 0 ? void 0 : person.last_name].filter(Boolean).join(' '),
    email: (_person$email = person === null || person === void 0 ? void 0 : person.email) !== null && _person$email !== void 0 ? _person$email : '',
    phone: (_person$telephone = person === null || person === void 0 ? void 0 : person.telephone) !== null && _person$telephone !== void 0 ? _person$telephone : ''
  };
};

var downloadCSV = function downloadCSV(ledgers, filename) {
  if (!ledgers || !ledgers.length) return;

  var escapeCsv = function escapeCsv(v) {
    var s = String(v !== null && v !== void 0 ? v : '');
    return /[;"\n\r]/.test(s) ? "\"".concat(s.replace(/"/g, '""'), "\"") : s;
  };

  var rows = ledgers.map(function (ledger) {
    var _ledger$hasura_polici, _ledger$hasura_polici2, _ledger$id, _policy$policy_number, _policy$object_name;

    var policy = (_ledger$hasura_polici = (_ledger$hasura_polici2 = ledger.hasura_policies) === null || _ledger$hasura_polici2 === void 0 ? void 0 : _ledger$hasura_polici2[0]) !== null && _ledger$hasura_polici !== void 0 ? _ledger$hasura_polici : null;
    var holder = holderInfo(policy);
    return {
      ledger_id: (_ledger$id = ledger.id) !== null && _ledger$id !== void 0 ? _ledger$id : '',
      policy_number: (_policy$policy_number = policy === null || policy === void 0 ? void 0 : policy.policy_number) !== null && _policy$policy_number !== void 0 ? _policy$policy_number : '',
      object_name: (_policy$object_name = policy === null || policy === void 0 ? void 0 : policy.object_name) !== null && _policy$object_name !== void 0 ? _policy$object_name : '',
      holder_name: holder.name,
      email: holder.email,
      phone: holder.phone,
      policy_letter: policy !== null && policy !== void 0 && policy.id && process.env.REACT_APP_PUBLIC_URL ? "".concat(process.env.REACT_APP_PUBLIC_URL, "p/").concat(policy.id) : ''
    };
  });
  var headers = Object.keys(rows[0]);
  var csvContent = [headers.join(';')].concat(_toConsumableArray(rows.map(function (row) {
    return headers.map(function (header) {
      return escapeCsv(row[header]);
    }).join(';');
  }))).join('\n');
  var csvWithBom = '﻿' + csvContent;
  var blob = new Blob([csvWithBom], {
    type: 'text/csv;charset=utf-8;'
  });
  var link = document.createElement('a');
  var url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

var MissingMandatesView = function MissingMandatesView() {
  var _data$hasura_ledgers;

  var _useMissingMandates = useMissingMandates(),
      loading = _useMissingMandates.loading,
      data = _useMissingMandates.data;

  if (loading) return /*#__PURE__*/jsx(Loading, {});
  var ledgers = (_data$hasura_ledgers = data === null || data === void 0 ? void 0 : data.hasura_ledgers) !== null && _data$hasura_ledgers !== void 0 ? _data$hasura_ledgers : [];
  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Missing mandates"
    }), ledgers.length > 0 && /*#__PURE__*/jsx(ButtonWrapper$1, {
      children: /*#__PURE__*/jsx(Button$3, {
        theme: "orange",
        variant: "secondary",
        size: "small",
        onClick: function onClick() {
          return downloadCSV(ledgers, "missing-mandates-".concat(new Date().toISOString().replace(/[:.]/g, '-'), ".csv"));
        },
        children: "Download as CSV"
      })
    }), /*#__PURE__*/jsx(PageSection, {
      children: /*#__PURE__*/jsxs(Table$2, {
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx(Th$1, {
              children: "Ledger id"
            }), /*#__PURE__*/jsx(Th$1, {
              children: "Policy"
            }), /*#__PURE__*/jsx(Th$1, {
              children: "Insured object"
            }), /*#__PURE__*/jsx(Th$1, {
              children: "Insurance holder"
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: ledgers.map(function (_ref) {
            var id = _ref.id,
                hasura_policies = _ref.hasura_policies;
            var policy = hasura_policies === null || hasura_policies === void 0 ? void 0 : hasura_policies[0];
            return /*#__PURE__*/jsxs("tr", {
              children: [/*#__PURE__*/jsx(HideOverflow$5, {
                $maxWidth: "14rem",
                children: /*#__PURE__*/jsx("a", {
                  href: "".concat(LEDGERS, "/").concat(id),
                  children: /*#__PURE__*/jsx(Tooltip, {
                    title: "Go to ledger",
                    position: "top",
                    children: id
                  })
                })
              }), /*#__PURE__*/jsx("td", {
                children: policy && /*#__PURE__*/jsx("a", {
                  href: "".concat(POLICIES, "/").concat(policy.id),
                  children: /*#__PURE__*/jsx(Tooltip, {
                    title: "Go to policy",
                    position: "top",
                    children: policy.policy_number
                  })
                })
              }), /*#__PURE__*/jsx(HideOverflow$5, {
                children: policy === null || policy === void 0 ? void 0 : policy.object_name
              }), /*#__PURE__*/jsx(HideOverflow$5, {
                children: holderInfo(policy).name
              })]
            }, id);
          })
        })]
      })
    })]
  });
};
var Table$2 = styled.table(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  width: 100%;\n  table-layout: auto;\n\n  th,\n  td {\n    padding: 0.25rem 0.75rem 0.25rem 0;\n  }\n\n  tbody {\n    td {\n      border-bottom: 0.0625rem dotted #dedede;\n\n      a {\n        color: #fc8e49;\n\n        &:hover {\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"])));
var HideOverflow$5 = styled.td(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: ", ";\n"])), function (_ref2) {
  var $maxWidth = _ref2.$maxWidth;
  return $maxWidth || '0';
});
var Th$1 = styled.th(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n"])));
var ButtonWrapper$1 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));

var ActiveFilterItem = function ActiveFilterItem(_ref) {
  var filter = _ref.filter,
      onRemoveClick = _ref.onRemoveClick;

  var handleRemoveClick = function handleRemoveClick() {
    return onRemoveClick(filter.filterGroup, filter.key);
  };

  return /*#__PURE__*/jsxs("li", {
    children: [filter.filterGroup, ":", ' ', typeof filter.filterItem === 'boolean' ? filter.filterItem ? 'Yes' : 'No' : filter.filterItem, /*#__PURE__*/jsx("span", {
      onClick: handleRemoveClick,
      children: /*#__PURE__*/jsx(Icon, {
        iconName: "faTimes"
      })
    })]
  });
};

ActiveFilterItem.propTypes = {
  filter: PropTypes.shape({
    filterGroup: PropTypes.string.isRequired,
    filterItem: PropTypes.string.isRequired
  }),
  onRemoveClick: PropTypes.func.isRequired
};

var _templateObject$n;

var ActiveFilters = function ActiveFilters(_ref) {
  var activeFilters = _ref.activeFilters,
      onRemoveClick = _ref.onRemoveClick;
  return /*#__PURE__*/jsx(ActiveFiltersList, {
    children: Object.values(activeFilters).map(function (filter) {
      return /*#__PURE__*/jsx(ActiveFilterItem, {
        filter: filter,
        onRemoveClick: onRemoveClick
      }, "".concat(filter.filterGroup, "_").concat(filter.filterItem));
    })
  });
};

ActiveFilters.propTypes = {
  activeFilters: PropTypes.shape({
    filterGroup: PropTypes.string.isRequired,
    filterItem: PropTypes.string.isRequired
  }).isRequired,
  onRemoveClick: PropTypes.func.isRequired
};
var ActiveFiltersList = styled.ul(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  font-size: 0.8rem;\n  color: #7b7d8c;\n  padding: 0.5rem 1rem;\n\n  li {\n    background-color: #fafafa;\n    border: 0.0625rem solid #dedede;\n    padding: 0.25rem;\n    margin-right: 0.5rem;\n\n    span {\n      margin-left: 0.5rem;\n      cursor: pointer;\n\n      &:hover {\n        color: #fc8e49;\n      }\n    }\n  }\n"])));

var GroupListItem = function GroupListItem(_ref) {
  var filterGroup = _ref.filterGroup,
      item = _ref.item,
      itemKey = _ref.itemKey,
      onSelectFilterItem = _ref.onSelectFilterItem;

  var handleClick = function handleClick() {
    return onSelectFilterItem(filterGroup, item, itemKey);
  };

  return /*#__PURE__*/jsx("li", {
    onClick: handleClick,
    children: typeof item === 'boolean' ? item ? 'Yes' : 'No' : item.split(/(?=[A-Z])/).join(' ')
  });
};

GroupListItem.propTypes = {};

var _templateObject$m, _templateObject2$a, _templateObject3$7;

var FilterGroupList = function FilterGroupList(_ref) {
  var filterGroup = _ref.filterGroup,
      onSelectFilterGroup = _ref.onSelectFilterGroup,
      onSelectFilterItem = _ref.onSelectFilterItem;
  var selector = useRef(null);

  var handleOutsideClick = function handleOutsideClick(e) {
    var _selector$current;

    e.preventDefault();

    if ((_selector$current = selector.current) !== null && _selector$current !== void 0 && _selector$current.contains(e.target)) {
      return;
    }

    onSelectFilterGroup(null);
  };

  useEffect(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return /*#__PURE__*/jsxs(GroupContainer$1, {
    ref: selector,
    children: [/*#__PURE__*/jsxs(Caption$1, {
      children: ["Filter by ", filterGroup.name]
    }), /*#__PURE__*/jsx(GroupList$1, {
      children: filterGroup.contents.map(function (filterItem) {
        return /*#__PURE__*/jsx(GroupListItem, {
          filterGroup: filterGroup.name,
          item: Object.values(filterItem)[0],
          onSelectFilterItem: onSelectFilterItem
        }, filterItem.status);
      })
    })]
  });
};

FilterGroupList.propTypes = {
  filterGroup: PropTypes.shape({
    contents: PropTypes.arrayOf(PropTypes.shape({
      status: PropTypes.string
    })),
    name: PropTypes.string.isRequired
  }).isRequired,
  onSelectFilterGroup: PropTypes.func.isRequired,
  onSelectFilterItem: PropTypes.func.isRequired
};
var GroupContainer$1 = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 2rem;\n  left: 0;\n  background-color: #fff;\n  border: 0.0625rem solid #dedede;\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.3);\n"])));
var Caption$1 = styled.span(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  padding: 0.5rem 2rem 0.5rem 0.2rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n"])));
var GroupList$1 = styled.ul(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  display: block;\n  max-height: 20rem;\n  overflow: auto;\n  list-style: none;\n  padding: 0;\n  padding-bottom: 1rem;\n\n  li {\n    position: relative;\n    padding: 0;\n    border-bottom: 0.0625rem solid #dedede;\n    padding: 0.2rem 0.5rem;\n    color: #7b7d8c;\n    cursor: pointer;\n\n    &:before {\n      content: '';\n      display: block;\n      opacity: 0;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n      background-color: #202124;\n      transform: scale(0);\n      transition: all 0.3s;\n    }\n\n    &:hover {\n      text-decoration: underline;\n\n      &:before {\n        opacity: 0.06;\n        transform: scale(1);\n      }\n    }\n  }\n"])));

var _templateObject$l, _templateObject2$9, _templateObject3$6, _templateObject4$5;

var PeopleFilterGroup = function PeopleFilterGroup(_ref) {
  var filterGroup = _ref.filterGroup,
      onSelectFilterGroup = _ref.onSelectFilterGroup,
      onSelectFilterItem = _ref.onSelectFilterItem;

  var _useSearchCustomers = useSearchCustomers(),
      _useSearchCustomers2 = _slicedToArray(_useSearchCustomers, 2),
      getCustomers = _useSearchCustomers2[0],
      data = _useSearchCustomers2[1].data;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var selector = useRef(null);

  var handleOutsideClick = function handleOutsideClick(e) {
    var _selector$current;

    if ((_selector$current = selector.current) !== null && _selector$current !== void 0 && _selector$current.contains(e.target)) {
      return;
    }

    onSelectFilterGroup(null);
  };

  useEffect(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  useEffect(function () {
    var delaySearch = setTimeout(function () {
      if (searchQuery.length >= 3) {
        var filters = [{
          social_security: {
            _like: "%".concat(searchQuery.replace('-', ''), "%")
          }
        }, {
          first_name: {
            _ilike: "%".concat(searchQuery.replace('-', ''), "%")
          }
        }, {
          last_name: {
            _ilike: "%".concat(searchQuery.replace('-', ''), "%")
          }
        }];
        getCustomers({
          variables: {
            where: {
              _or: filters
            },
            limit: 20
          }
        });
      } else {
        if (data) {
          console.log('kommer in hit');
          data.hasura_people.length = 0;
        }
      }
    }, 500);
    return function () {
      return clearTimeout(delaySearch);
    }; // if (searchQuery.length > 3) {
    //   const filters = [
    //     {
    //       social_security: { _like: `%${searchQuery.replace('-', '')}%` },
    //     },
    //   ];
    //   getCustomers({
    //     variables: {
    //       where: {
    //         _or: filters,
    //       },
    //     },
    //   });
    // }
  }, [searchQuery]);

  var handleChange = function handleChange(e) {
    return setSearchQuery(e.target.value);
  };

  return /*#__PURE__*/jsxs(GroupContainer, {
    ref: selector,
    children: [/*#__PURE__*/jsxs(Caption, {
      children: ["Filter by ", filterGroup.name]
    }), /*#__PURE__*/jsx(SearchContainer, {
      children: /*#__PURE__*/jsx("input", {
        value: searchQuery,
        onChange: handleChange,
        autoFocus: true
      })
    }), /*#__PURE__*/jsx(GroupList, {
      children: data && data.hasura_people.map(function (person) {
        return /*#__PURE__*/jsx(GroupListItem, {
          filterGroup: filterGroup.name,
          item: "".concat(person.social_security, ": ").concat(person.first_name, " ").concat(person.last_name),
          itemKey: person.id,
          onSelectFilterItem: onSelectFilterItem
        }, person.id);
      })
    })]
  });
};

PeopleFilterGroup.propTypes = {};
var GroupContainer = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 2rem;\n  left: 0;\n  background-color: #fff;\n  border: 0.0625rem solid #dedede;\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.3);\n"])));
var Caption = styled.span(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  padding: 0.5rem 2rem 0.5rem 0.2rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n"])));
var GroupList = styled.ul(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  display: block;\n  max-height: 20rem;\n  overflow: auto;\n  list-style: none;\n  padding: 0;\n  padding-bottom: 1rem;\n\n  li {\n    position: relative;\n    padding: 0;\n    border-bottom: 0.0625rem solid #dedede;\n    padding: 0.2rem 0.5rem;\n    color: #7b7d8c;\n    cursor: pointer;\n\n    &:before {\n      content: '';\n      display: block;\n      opacity: 0;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n      background-color: #202124;\n      transform: scale(0);\n      transition: all 0.3s;\n    }\n\n    &:hover {\n      text-decoration: underline;\n\n      &:before {\n        opacity: 0.06;\n        transform: scale(1);\n      }\n    }\n  }\n"])));
var SearchContainer = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n  padding: 0.4rem 0.2rem;\n  border-top: 0.0625rem solid #dedede;\n  border-bottom: 0.0625rem solid #dedede;\n"])));

var _templateObject$k, _templateObject2$8;

var FilterGroup = function FilterGroup(_ref) {
  var filterGroup = _ref.filterGroup,
      selectedFilterGroup = _ref.selectedFilterGroup,
      onSelectFilterGroup = _ref.onSelectFilterGroup,
      onSelectFilterItem = _ref.onSelectFilterItem;

  var handleFilterGroupClick = function handleFilterGroupClick() {
    return onSelectFilterGroup(filterGroup.name);
  };

  return /*#__PURE__*/jsxs(Group, {
    children: [/*#__PURE__*/jsxs(GroupTitle, {
      onClick: handleFilterGroupClick,
      children: [filterGroup.name, " ", /*#__PURE__*/jsx(Icon, {
        iconName: "faCaretDown"
      }), "\xA0"]
    }), filterGroup.name === selectedFilterGroup && (filterGroup.advancedSearch ? /*#__PURE__*/jsx(PeopleFilterGroup, {
      filterGroup: filterGroup,
      onSelectFilterGroup: onSelectFilterGroup,
      onSelectFilterItem: onSelectFilterItem
    }) : /*#__PURE__*/jsx(FilterGroupList, {
      filterGroup: filterGroup,
      onSelectFilterGroup: onSelectFilterGroup,
      onSelectFilterItem: onSelectFilterItem
    }))]
  });
};

FilterGroup.propTypes = {
  filterGroup: PropTypes.shape({
    contents: PropTypes.arrayOf(PropTypes.shape({
      status: PropTypes.string
    })),
    name: PropTypes.string.isRequired
  }).isRequired,
  onSelectFilterGroup: PropTypes.func.isRequired,
  selectedFilterGroup: PropTypes.string.isRequired,
  onSelectFilterItem: PropTypes.string.isRequired
};
var Group = styled.li(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 0.5rem;\n"])));
var GroupTitle = styled.span(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  color: #fc8e49;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));

var _templateObject$j;

var FilterGroups = function FilterGroups(_ref) {
  var filters = _ref.filters,
      onSelectFilterItem = _ref.onSelectFilterItem;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFilter = _useState2[0],
      setSelectedFilter = _useState2[1];

  return /*#__PURE__*/jsx(Groups, {
    children: filters.map(function (filter) {
      return /*#__PURE__*/jsx(FilterGroup, {
        filterGroup: filter,
        selectedFilterGroup: selectedFilter,
        onSelectFilterGroup: setSelectedFilter,
        onSelectFilterItem: onSelectFilterItem
      });
    })
  });
};
var Groups = styled.ul(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  list-style: none;\n  display: flex;\n  padding: 0;\n  white-space: nowrap;\n  border-bottom: 0.125rem solid #dedede;\n"])));

var _templateObject$i;

var PaginationNavigation = function PaginationNavigation(_ref) {
  var limit = _ref.limit,
      offset = _ref.offset,
      setOffset = _ref.setOffset,
      totalNumberOfRecords = _ref.totalNumberOfRecords;
  var firstPageRecord = limit * offset + 1;
  var lastPageRecord = limit * offset + limit < totalNumberOfRecords ? limit * offset + limit : totalNumberOfRecords;

  var handleGoToNextPageClick = function handleGoToNextPageClick() {
    setOffset(offset + 1);
  };

  var handleGoToPreviousPageClick = function handleGoToPreviousPageClick() {
    setOffset(offset - 1);
  };

  return /*#__PURE__*/jsxs(NavigationContainer$1, {
    children: [firstPageRecord, "-", lastPageRecord, " of ", totalNumberOfRecords, /*#__PURE__*/jsx(PrimaryButton, {
      disabled: offset === 0,
      size: "small",
      onClick: handleGoToPreviousPageClick,
      children: "Previous"
    }), /*#__PURE__*/jsx(PrimaryButton, {
      disabled: lastPageRecord === totalNumberOfRecords,
      size: "small",
      onClick: handleGoToNextPageClick,
      children: "Next"
    })]
  });
};

PaginationNavigation.propTypes = {
  limit: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  setOffset: PropTypes.func.isRequired,
  totalNumberOfRecords: PropTypes.number.isRequired
};
var NavigationContainer$1 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: #7b7d8c;\n  margin-top: 0.5rem;\n"])));

var getStatusIcon = function getStatusIcon(status) {
  var showStatusColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  switch (status) {
    case 'Collected':
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faCheckCircle,
        size: "1x",
        color: showStatusColor ? '#34ad6c' : 'inherit'
      });

    case 'Failed':
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faTimesCircle,
        size: "1x",
        color: showStatusColor ? '#ff4747' : 'inherit'
      });

    case 'Pending':
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faHourglassHalf,
        size: "1x",
        color: showStatusColor ? '#2343d1' : 'inherit'
      });

    case 'Unprocessed':
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faExclamationCircle,
        size: "1x",
        color: showStatusColor ? '#fc7522' : 'inherit'
      });

    case 'Upcoming':
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faCalendarAlt,
        size: "1x",
        color: showStatusColor ? '#2343d1' : 'inherit'
      });

    default:
      return /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faFileInvoiceDollar,
        size: "1x"
      });
  }
};

var _templateObject$h, _templateObject2$7, _templateObject3$5, _templateObject4$4, _templateObject5$2, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1;

var PaymentCard = function PaymentCard(_ref) {
  var _payment$additional_i, _hasura_policies$0$po;

  var payment = _ref.payment;
  var hasura_ledger = payment.hasura_ledger,
      _payment$hasura_ledge = payment.hasura_ledger,
      hasura_ledger_mandates = _payment$hasura_ledge.hasura_ledger_mandates,
      hasura_policies = _payment$hasura_ledge.hasura_policies,
      hasura_quote = _payment$hasura_ledge.hasura_quote,
      hasura_person = _payment$hasura_ledge.hasura_quote.hasura_person,
      status = payment.status;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAdditionalInfo = _useState2[0],
      setShowAdditionalInfo = _useState2[1];

  var handleViewMoreClick = function handleViewMoreClick() {
    return setShowAdditionalInfo(!showAdditionalInfo);
  }; // A string-shaped additional_info is one of our own messages, not provider data.


  var internal = (_payment$additional_i = payment.additional_info) === null || _payment$additional_i === void 0 ? void 0 : _payment$additional_i.trimStart().startsWith('"');

  var prettyAdditionalInfo = function prettyAdditionalInfo() {
    try {
      var _parsed$error, _parsed$Left;

      var parsed = JSON.parse(payment.additional_info); // Six legacy lin charge-failures (from 2020) wrapped the error in a `Left`.

      var error = (_parsed$error = parsed === null || parsed === void 0 ? void 0 : parsed.error) !== null && _parsed$error !== void 0 ? _parsed$error : parsed === null || parsed === void 0 ? void 0 : (_parsed$Left = parsed.Left) === null || _parsed$Left === void 0 ? void 0 : _parsed$Left.error;

      if (error && typeof error.body === 'string') {
        try {
          error.body = JSON.parse(error.body);
        } catch (_unused) {// body isn't JSON-encoded; leave the original string
        }
      }

      return JSON.stringify(parsed, undefined, 2);
    } catch (_unused2) {
      return payment.additional_info;
    }
  };

  return /*#__PURE__*/jsxs(Card, {
    children: [/*#__PURE__*/jsxs(MainInfoContainer, {
      children: [/*#__PURE__*/jsx(StatusContainer, {
        children: getStatusIcon(status, true)
      }), /*#__PURE__*/jsxs(PaymentInfoContainer, {
        children: [/*#__PURE__*/jsxs(PolicySection, {
          children: [/*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Policy"
            }), hasura_policies.length > 0 ? /*#__PURE__*/jsx(NavLink, {
              to: "".concat(POLICIES, "/").concat(hasura_policies[0].id),
              children: (_hasura_policies$0$po = hasura_policies[0].policy_number) !== null && _hasura_policies$0$po !== void 0 ? _hasura_policies$0$po : 'No policy number'
            }) : 'No policy']
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Policy status"
            }), hasura_policies.length > 0 ? hasura_policies[0].status : 'No policy']
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Product"
            }), hasura_quote.product_name]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Cover"
            }), hasura_quote.cover_level]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Ledger status"
            }), hasura_ledger.status]
          })]
        }), /*#__PURE__*/jsxs(CustomerSection, {
          children: [/*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "SSN"
            }), /*#__PURE__*/jsx(NavLink, {
              to: "".concat(CUSTOMERS, "/").concat(hasura_person.user_id),
              children: hasura_person.social_security
            })]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "First name"
            }), hasura_person.first_name]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Last name"
            }), hasura_person.last_name]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "E-mail"
            }), hasura_person.email]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Telephone"
            }), hasura_person.telephone]
          })]
        }), /*#__PURE__*/jsxs(PaymentSection, {
          children: [/*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Amount"
            }), payment.total.toLocaleString('sv-SE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Scheduled collection date"
            }), payment.scheduled_collection_date]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Period start date"
            }), payment.period_start]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Period end date"
            }), payment.period_end]
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Payment provider"
            }), hasura_ledger_mandates.length > 0 ? hasura_ledger_mandates[0].payment_provider : 'N/A']
          }), /*#__PURE__*/jsxs(ItemContainer, {
            children: [/*#__PURE__*/jsx("label", {
              children: "Is mandate active"
            }), hasura_ledger_mandates.length > 0 ? hasura_ledger_mandates[0].is_active === true ? 'true' : 'false' : 'N/A']
          })]
        }), /*#__PURE__*/jsxs(Footer, {
          children: [/*#__PURE__*/jsx(NavLink, {
            to: "".concat(LEDGERS, "/").concat(payment.ledger_id),
            children: "Go to ledger"
          }), payment.additional_info && /*#__PURE__*/jsxs(ShowMoreInfo, {
            onClick: handleViewMoreClick,
            children: [showAdditionalInfo ? 'Hide' : 'View', " more info"]
          })]
        })]
      })]
    }), /*#__PURE__*/jsxs(AdditionalInfo, {
      show: showAdditionalInfo,
      children: [internal && /*#__PURE__*/jsx("em", {
        children: "Internal check \u2014 no charge sent to the provider, so no order id."
      }), /*#__PURE__*/jsx("pre", {
        children: prettyAdditionalInfo()
      })]
    })]
  });
};

PaymentCard.propTypes = {};
var Card = styled.li(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  //   display: flex;\n  //   width: 100%;\n  gap: 1rem;\n  background-color: #fff;\n  border: 0.0625rem solid #dedede;\n  border-top: 0;\n  padding: 0.5rem;\n\n  &:hover {\n    background-color: #fee6d7;\n  }\n"])));
var StatusContainer = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  font-size: 1.5rem;\n"])));
var PaymentInfoContainer = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  flex: 1;\n  //   width: 100%;\n"])));
var PolicySection = styled.section(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 8rem 12rem 12rem 10rem 10rem;\n  gap: 0.5rem;\n"])));
var PaymentSection = styled.section(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 8rem 12rem 12rem 10rem 9.5rem 8rem;\n  gap: 0.5rem;\n"])));
var CustomerSection = styled.section(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 8rem 12rem 12rem 20rem 8rem;\n  gap: 0.5rem;\n"])));
var Footer = styled.footer(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var MainInfoContainer = styled.section(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 1rem;\n"])));
var AdditionalInfo = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  overflow-x: auto;\n  max-height: ", ";\n  transition: all 0.2s;\n  pre {\n    overflow-x: auto;\n  }\n"])), function (_ref2) {
  var show = _ref2.show;
  return show ? '1rem' : 0;
}, function (_ref3) {
  var show = _ref3.show;
  return show ? '20rem' : 0;
});
var ShowMoreInfo = styled.span(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));

var _templateObject$g;

var PaymentList = function PaymentList(_ref) {
  var payments = _ref.payments;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(List, {
      children: payments.map(function (payment) {
        return /*#__PURE__*/jsx(PaymentCard, {
          payment: payment
        }, "".concat(payment.ledger_id, "_").concat(payment.index));
      })
    })
  });
};

PaymentList.propTypes = {
  payments: PropTypes.shape({})
};
var List = styled.ul(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n"])));

var _templateObject$f, _templateObject2$6;

({
  onOutsideClick: PropTypes.func.isRequired
});
styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 2rem;\n  left: 0;\n  background-color: #fff;\n  border: 0.0625rem solid #dedede;\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.3);\n"])));
styled.ul(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  display: block;\n  max-height: 20rem;\n  overflow: auto;\n  list-style: none;\n  padding: 0;\n  padding-bottom: 1rem;\n\n  li {\n    position: relative;\n    padding: 0;\n    border-bottom: 0.0625rem solid #dedede;\n    padding: 0.2rem 0.5rem;\n    color: #7b7d8c;\n    cursor: pointer;\n\n    &:before {\n      content: '';\n      display: block;\n      opacity: 0;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n      background-color: #202124;\n      transform: scale(0);\n      transition: all 0.3s;\n    }\n\n    &:hover {\n      text-decoration: underline;\n\n      &:before {\n        opacity: 0.06;\n        transform: scale(1);\n      }\n    }\n  }\n"])));

var _templateObject$e, _templateObject2$5;
styled.li(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 0.5rem;\n"])));
styled.span(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  color: #fc8e49;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])));

var FILTER_FAILED = 'Failed';
var LIMIT = 25;

var FILTER_GROUP_ACTIVE_MANDATE = 'Active mandate';
var FILTER_GROUP_PAYMENT_PROVIDER = 'Payment provider';
var FILTER_GROUP_PAYMENT_STATUS = 'Payment status';
var FILTER_GROUP_PEOPLE = 'Customer';
var FILTER_GROUP_POLICY_STATUS = 'Policy status';
var FILTER_GROUP_PRODUCT = 'Product';

var PaymentsView = function PaymentsView() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      offset = _useState2[0],
      setOffset = _useState2[1];

  var _useState3 = useState({
    _and: [{
      status: {
        _in: [FILTER_FAILED]
      }
    }]
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      filter = _useState4[0],
      setFilter = _useState4[1];

  var _useState5 = useState(_defineProperty({}, "".concat(FILTER_GROUP_PAYMENT_STATUS, "_Failed"), {
    filterGroup: FILTER_GROUP_PAYMENT_STATUS,
    filterItem: FILTER_FAILED,
    key: FILTER_FAILED
  })),
      _useState6 = _slicedToArray(_useState5, 2),
      activeFilters = _useState6[0],
      setActiveFilters = _useState6[1];

  var _usePayments = usePayments(offset * LIMIT, LIMIT, filter),
      loading = _usePayments.loading,
      data = _usePayments.data;

  useEffect(function () {
    if (Object.keys(activeFilters).length === 0) {
      setFilter({
        _and: []
      });
    } else {
      var newFilter = []; // Payment status:

      var newPaymentStatusFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_PAYMENT_STATUS;
      }).map(function (filter) {
        return filter.key;
      });
      newPaymentStatusFilter.length > 0 && newFilter.push({
        status: {
          _in: newPaymentStatusFilter
        }
      }); // Policy status:

      var newPolicyStatusFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_POLICY_STATUS;
      }).map(function (filter) {
        return filter.key;
      });
      newPolicyStatusFilter.length > 0 && newFilter.push({
        hasura_ledger: {
          hasura_policies: {
            status: {
              _in: newPolicyStatusFilter
            }
          }
        }
      }); // Product:

      var newProductFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_PRODUCT;
      }).map(function (filter) {
        return filter.key;
      });
      newProductFilter.length > 0 && newFilter.push({
        hasura_ledger: {
          hasura_quote: {
            product_name: {
              _in: newProductFilter
            }
          }
        }
      }); // Payment providers

      var newPaymentProviderFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_PAYMENT_PROVIDER;
      }).map(function (filter) {
        return filter.key;
      });
      newPaymentProviderFilter.length > 0 && newFilter.push({
        hasura_ledger: {
          hasura_ledger_mandates: {
            payment_provider: {
              _in: newPaymentProviderFilter
            }
          }
        }
      }); // Active mandate

      var newActiveMandateFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_ACTIVE_MANDATE;
      }).map(function (filter) {
        return filter.key;
      });
      console.log('Mandates: ', newActiveMandateFilter);
      newActiveMandateFilter.length > 0 && newFilter.push({
        hasura_ledger: {
          hasura_ledger_mandates: {
            is_active: {
              _in: newActiveMandateFilter
            }
          }
        }
      }); // Person

      var newPersonFilter = Object.values(activeFilters).filter(function (filter) {
        return filter.filterGroup === FILTER_GROUP_PEOPLE;
      }).map(function (filter) {
        return filter.key;
      });
      newPersonFilter.length > 0 && newFilter.push({
        hasura_ledger: {
          hasura_quote: {
            hasura_person: {
              id: {
                _in: newPersonFilter
              }
            }
          }
        }
      });
      setFilter({
        _and: newFilter
      });
    }
  }, [activeFilters]);

  var removeActiveFilter = function removeActiveFilter(filterGroup, filterItem) {
    var activeFiltersCopy = activeFilters;
    delete activeFiltersCopy["".concat(filterGroup, "_").concat(filterItem)];
    setActiveFilters(function () {
      return _objectSpread2({}, activeFiltersCopy);
    });
  };

  var handleSetFilter = function handleSetFilter(filterGroup, filterItem, filterItemKey) {
    return setActiveFilters(function (activeFilters) {
      return _objectSpread2(_objectSpread2({}, activeFilters), {}, _defineProperty({}, "".concat(filterGroup, "_").concat(filterItemKey !== null && filterItemKey !== void 0 ? filterItemKey : filterItem), {
        filterGroup: filterGroup,
        filterItem: filterItem,
        key: filterItemKey !== null && filterItemKey !== void 0 ? filterItemKey : filterItem
      }));
    });
  };

  if (loading) return /*#__PURE__*/jsx(Loading, {});
  var filters = [{
    name: FILTER_GROUP_PAYMENT_STATUS,
    contents: data.payment_statuses
  }, // { name: FILTER_GROUP_PAYMENT_PROVIDER, contents: data.payment_providers },
  // {
  //   name: FILTER_GROUP_ACTIVE_MANDATE,
  //   contents: [{ status: true }, { status: false }],
  // },
  {
    name: FILTER_GROUP_POLICY_STATUS,
    contents: data.policy_statuses
  }, // { name: FILTER_GROUP_PRODUCT, contents: data.products },
  {
    name: FILTER_GROUP_PEOPLE,
    contents: [],
    advancedSearch: true
  }];
  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Payments"
    }), /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx(FilterGroups, {
        filters: filters,
        onSelectFilterItem: handleSetFilter
      }), /*#__PURE__*/jsx(ActiveFilters, {
        activeFilters: activeFilters,
        onRemoveClick: removeActiveFilter
      })]
    }), data.hasura_ledger_payments_aggregate.aggregate.count > 0 ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(PaymentList, {
        payments: data.hasura_ledger_payments
      }), /*#__PURE__*/jsx(PaginationNavigation, {
        limit: LIMIT,
        offset: offset,
        setOffset: setOffset,
        totalNumberOfRecords: data.hasura_ledger_payments_aggregate.aggregate.count
      })]
    }) : 'No payments match the filters.']
  });
};

var _templateObject$d;
var GET_POLICY_DAY_PREMIUMS = gql(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  query premiums($policyId: uuid!) {\n    hasura_policies(where: { id: { _eq: $policyId } }) {\n      period_written_premium\n      hasura_policy_cover_premiums {\n        day_premium\n        day_tax\n      }\n    }\n  }\n"])));

var useDayPremiums = function useDayPremiums(policyId) {
  return useQuery(GET_POLICY_DAY_PREMIUMS, {
    variables: {
      policyId: policyId
    }
  });
};

var _templateObject$c;

var MtaDifference = function MtaDifference(_ref) {
  var quoteId = _ref.quoteId;
  var query = useQueryParam();

  var _useDayPremiums = useDayPremiums(query.get('mtaForPolicy')),
      loading = _useDayPremiums.loading,
      error = _useDayPremiums.error,
      data = _useDayPremiums.data;

  var _useState = useState({
    premiumDifference: 0,
    annualizedDifference: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      difference = _useState2[0],
      setDifference = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentAnnualizedPremium = _useState4[0],
      setCurrentAnnualizedPremium = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentWrittenPremium = _useState6[0],
      setCurrentWrittenPremium = _useState6[1];

  useEffect(function () {
    if (data && data.hasura_policies.length !== 0) {
      setCurrentAnnualizedPremium(data.hasura_policies[0].hasura_policy_cover_premiums.reduce(function (a, b) {
        return a + b.day_premium + b.day_tax;
      }, 0) * 365);
      setCurrentWrittenPremium(data.hasura_policies[0].period_written_premium);
    }
  }, [data]);
  useEffect(function () {
    var getPremiumDifference = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var mtaDifference;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return quoteService.mtaDifference(quoteId);

              case 2:
                mtaDifference = _context.sent;
                setDifference(function (state) {
                  return _objectSpread2(_objectSpread2({}, state), {}, {
                    premiumDifference: mtaDifference.difference,
                    annualizedDifference: mtaDifference.annualizedDifference
                  });
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPremiumDifference() {
        return _ref2.apply(this, arguments);
      };
    }();

    getPremiumDifference();
  }, []);
  return /*#__PURE__*/jsxs(DifferenceContainer, {
    children: ["New period premium for policy:", error || !loading && data.hasura_policies.length === 0 ? ' Could not calculate' : " ".concat((currentWrittenPremium + difference.premiumDifference).toLocaleString('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }), " (").concat(difference.premiumDifference > 0 ? '+' : '').concat(difference.premiumDifference.toLocaleString('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }), ")"), /*#__PURE__*/jsx("br", {}), "New annualized premium for policy:", error || !loading && data.hasura_policies.length === 0 ? ' Could not calculate' : " ".concat((currentAnnualizedPremium + difference.annualizedDifference).toLocaleString('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }), " (").concat(difference.annualizedDifference > 0 ? '+' : '').concat(difference.annualizedDifference.toLocaleString('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }), ")")]
  });
};

MtaDifference.propTypes = {
  quoteId: PropTypes.string.isRequired
};
var DifferenceContainer = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  font-weight: 500;\n  margin-bottom: 0.3rem;\n  background-color: #fff3cd;\n  color: #856404;\n  padding: 0.5rem;\n  border: 0.0625rem solid #856404;\n"])));

var QuoteAccounts = function QuoteAccounts(_ref) {
  var purchaseMethods = _ref.purchaseMethods,
      quoteId = _ref.quoteId;
  return /*#__PURE__*/jsx(PageSection, {
    children: purchaseMethods.map(function (purchaseMethod) {
      return /*#__PURE__*/jsxs(ItemContainer, {
        children: [/*#__PURE__*/jsxs("span", {
          children: ["Purchase link ", purchaseMethod.providerName]
        }), /*#__PURE__*/jsx(CopyLink, {
          url: "".concat(process.env.REACT_APP_PUBLIC_URL, "pay/").concat(purchaseMethod.providerUrlParam, "/").concat(quoteId)
        })]
      });
    })
  });
};

QuoteAccounts.propTypes = {
  productName: PropTypes.string.isRequired,
  quoteId: PropTypes.string.isRequired
};

var _templateObject$b;

var QuoteAnswers = function QuoteAnswers(_ref) {
  var quoteAnswers = _ref.quoteAnswers;
  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "All named answers"
    }), /*#__PURE__*/jsx(Grid$1, {
      children: quoteAnswers.map(function (answer) {
        return /*#__PURE__*/jsxs(ItemContainer, {
          children: [/*#__PURE__*/jsx("label", {
            children: answer.key
          }), answer.value]
        }, answer.key);
      })
    })]
  });
};

QuoteAnswers.propTypes = {
  quoteAnswers: PropTypes.array.isRequired
};
var Grid$1 = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  column-gap: 0.5rem;\n"])));

var _templateObject$a, _templateObject2$4, _templateObject3$4, _templateObject4$3;

var QuoteCoveragePeriods = function QuoteCoveragePeriods(_ref) {
  var covers = _ref.covers;
  var totals = covers.reduce(function (total, cover) {
    total.premium += cover.period_premium;
    total.tax += cover.period_tax;
    total.grandTotal += cover.period_premium + cover.period_tax;
    return total;
  }, {
    premium: 0,
    tax: 0,
    grandTotal: 0
  });
  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Coverage"
    }), /*#__PURE__*/jsxs(Table$1, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx(Th, {
            children: "Period start"
          }), /*#__PURE__*/jsx(Th, {
            children: "Period end"
          }), /*#__PURE__*/jsx(Th, {
            children: "Name"
          }), /*#__PURE__*/jsx(Th, {
            children: "Created"
          }), /*#__PURE__*/jsx(ThRightAlign, {
            children: "Premium"
          }), /*#__PURE__*/jsx(ThRightAlign, {
            children: "Tax"
          }), /*#__PURE__*/jsx(ThRightAlign, {
            children: "Total"
          })]
        })
      }), /*#__PURE__*/jsx("tfoot", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx("td", {}), /*#__PURE__*/jsx("td", {}), /*#__PURE__*/jsx("td", {}), /*#__PURE__*/jsx("td", {}), /*#__PURE__*/jsxs("td", {
            children: [totals.premium.toLocaleString('sv-SE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }), ' ', "kr"]
          }), /*#__PURE__*/jsxs("td", {
            children: [totals.tax.toLocaleString('sv-SE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }), ' ', "kr"]
          }), /*#__PURE__*/jsxs("td", {
            children: [totals.grandTotal.toLocaleString('sv-SE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }), ' ', "kr"]
          })]
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: covers.map(function (_ref2) {
          var cover_id = _ref2.cover_id,
              hasura_quote = _ref2.hasura_quote,
              name = _ref2.name,
              period_premium = _ref2.period_premium,
              period_tax = _ref2.period_tax;
          return /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              children: hasura_quote.start_date
            }), /*#__PURE__*/jsx("td", {
              children: hasura_quote.end_date
            }), /*#__PURE__*/jsx("td", {
              children: name
            }), /*#__PURE__*/jsx("td", {
              children: formatDateTime(hasura_quote.created)
            }), /*#__PURE__*/jsx("td", {
              className: "right-align",
              children: period_premium.toLocaleString('sv-SE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }), /*#__PURE__*/jsx("td", {
              className: "right-align",
              children: period_tax.toLocaleString('sv-SE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }), /*#__PURE__*/jsx("td", {
              className: "right-align",
              children: (period_premium + period_tax).toLocaleString('sv-SE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            })]
          }, cover_id);
        })
      })]
    })]
  });
};

QuoteCoveragePeriods.propTypes = {
  covers: PropTypes.array.isRequired
};
var Table$1 = styled.table(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  width: 100%;\n\n  tbody {\n    td {\n      padding: 0.2rem 0.5rem;\n      border-bottom: 0.0625rem dotted #dedede;\n    }\n\n    td.right-align {\n      text-align: right;\n    }\n  }\n\n  tfoot {\n    font-weight: 500;\n\n    tr {\n      border-top: 0.125rem solid #dedede;\n    }\n\n    td {\n      padding: 0.2rem 0.5rem;\n      text-align: right;\n    }\n  }\n"])));
var Th = styled.th(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  text-align: left;\n  padding: 0 0.5rem;\n"])));
var ThRightAlign = styled(Th)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  text-align: right;\n"]))); // const Tbody = styled.tbody`
//   td {
//     padding: 0.2rem 0.5rem;
//     border-bottom: 0.0625rem dotted #dedede;
//   }
// `;

styled.td(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  text-align: right;\n"])));

var QuoteFailedFilters = function QuoteFailedFilters(_ref) {
  var failedFilters = _ref.failedFilters;
  return /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Failed filters"
    }), /*#__PURE__*/jsx("ul", {
      children: failedFilters.map(function (faildFilter) {
        return /*#__PURE__*/jsx("li", {
          children: faildFilter
        }, faildFilter);
      })
    })]
  });
};

QuoteFailedFilters.propTypes = {
  failedFilters: PropTypes.array.isRequired
};

var _templateObject$9;

var QuoteLedgers = function QuoteLedgers(_ref) {
  var quoteId = _ref.quoteId;

  var _useQuoteLedgers = useQuoteLedgers(quoteId),
      data = _useQuoteLedgers.data;

  var history = useHistory();

  var handleClick = function handleClick(quoteId) {
    return history.push("".concat(LEDGERS, "/").concat(quoteId));
  };

  return data && data.hasura_ledgers.length > 0 ? /*#__PURE__*/jsxs(PageSection, {
    children: [/*#__PURE__*/jsx("h3", {
      children: "Quote ledgers"
    }), /*#__PURE__*/jsxs(Table, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx("th", {
            children: "Quote id"
          }), /*#__PURE__*/jsx("th", {
            children: "Status"
          }), /*#__PURE__*/jsx("th", {
            children: "Last updated"
          })]
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: data.hasura_ledgers.map(function (_ref2) {
          var id = _ref2.id,
              last_updated = _ref2.last_updated,
              status = _ref2.status;
          return /*#__PURE__*/jsxs("tr", {
            onClick: function onClick() {
              return handleClick(id);
            },
            children: [/*#__PURE__*/jsx("td", {
              children: id
            }), /*#__PURE__*/jsx("td", {
              children: status
            }), /*#__PURE__*/jsx("td", {
              children: formatDateTime(last_updated)
            })]
          }, id);
        })
      })]
    })]
  }) : null;
};

QuoteLedgers.propTypes = {
  quoteId: PropTypes.string.isRequired
};
var Table = styled.table(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  width: 100%;\n\n  tbody {\n    color: #fc8e49;\n\n    td {\n      padding: 0.2rem 0.5rem;\n      border-bottom: 0.0625rem dotted #dedede;\n    }\n\n    tr {\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n\n      &:last-child {\n        td {\n          border: 0;\n        }\n      }\n    }\n  }\n\n  thead {\n    th {\n      font-size: 0.8rem;\n      font-weight: 500;\n      color: #7b7d8c;\n      text-align: left;\n      padding: 0 0.5rem;\n    }\n  }\n"])));

const policyService = {
    acceptRenewal: function (policyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.post('KrakenAPI', `policy/renewal/accept/${policyId}`, {});
        });
    },
    log: function (policyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.get('KrakenAPI', `policy/history/${policyId}`, {});
        });
    },
    mta: function (policyId, updatedAnswers, effectiveDay) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body: {
                    effectiveDay,
                    policyId,
                    updatedAnswers,
                },
            };
            return API.post('KrakenAPI', 'policy/mta', myInit);
        });
    },
    renew: function (policyId, body, forceRecreate = false, queryStringParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body,
                queryStringParameters: Object.assign({ forceRecreate }, queryStringParams),
            };
            return API.post('KrakenAPI', `policy/renew/${policyId}`, myInit);
        });
    },
    terminate: function (policyId, terminationDate, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = reason
                ? {
                    body: { reason },
                }
                : {};
            return reason
                ? API.put('KrakenAPI', `policy/terminatewithbody/from/${terminationDate}/${policyId}`, myInit)
                : API.put('KrakenAPI', `policy/terminate/from/${terminationDate}/${policyId}`, myInit);
        });
    },
    getVtrCertificates: function (car) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                queryStringParameters: {
                    car,
                },
            };
            return API.get('KrakenAPI', 'vtrforfrontend/certs', myInit);
        });
    },
    terminateVtrCertificate: function (body) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                body,
            };
            return API.post('KrakenAPI', 'vtrforfrontend/terminate', myInit);
        });
    },
    invalidateVtrCache: function (car, person) {
        return __awaiter(this, void 0, void 0, function* () {
            const myInit = {
                queryStringParameters: {
                    car,
                    person,
                },
            };
            return API.post('KrakenAPI', 'vtrforfrontend/cache/invalidate', myInit);
        });
    },
    undo: function (policyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `policy/terminate/from/beginning/${policyId}`, {});
        });
    },
    undoMarkForTermination: function (policyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `policy/unset/markedForTermination/${policyId}`, {});
        });
    },
    undoTermination: function (policyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return API.put('KrakenAPI', `policy/undo/termination/${policyId}`, {});
        });
    },
};

const VtrTableRow = ({ content }) => {
    return (jsxs(Fragment, { children: [jsx(GridTableCell, { children: content.partner }), jsx(GridTableCell, { children: content.start_date }), jsx(GridTableCell, { children: content.owner }), jsx(GridTableCell, { children: content.monitoring })] }));
};

const VtrCertificates = ({ registrationNumber, insuranceHolder, vtrPartnerName, onTerminateClick = null, }) => {
    const { addNotification, removeNotificationWithDelay } = useNotification();
    const [tableData, setTableData] = useState([]);
    const [certificates, setCertificates] = useState([]);
    const getVtrCertificates = () => __awaiter(void 0, void 0, void 0, function* () {
        const certificates = yield policyService.getVtrCertificates(registrationNumber);
        setCertificates(certificates);
    });
    useEffect(() => {
        getVtrCertificates();
    }, []);
    useEffect(() => {
        setTableData(certificates.map((certificate) => ({
            partner: certificate.fbolagpopnamn,
            start_date: certificate.begyndatum,
            owner: certificate.ftagare === insuranceHolder ? 'Policy holder' : 'Other',
            monitoring: certificate.bevanl,
        })));
    }, [certificates]);
    const handleTerminateClick = () => {
        onTerminateClick &&
            onTerminateClick(certificates.find((certificates) => certificates.fbolagnamn === vtrPartnerName).begyndatum, getVtrCertificates);
    };
    const handleRefreshVtrCertificates = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield policyService.invalidateVtrCache(registrationNumber, insuranceHolder);
            yield getVtrCertificates();
            removeNotificationWithDelay(addNotification('VTR certificates was successfully refreshed.', 'success'));
        }
        catch (error) {
            removeNotificationWithDelay(addNotification(`Something went wrong when trying to refresh VTR certificates.`, 'alert'));
        }
    });
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "VTR Certificates" }) }), jsx("main", { children: tableData.length > 0 ? (jsxs(Fragment, { children: [jsx(GridTable$1, { columns: [
                                { header: 'Company', name: 'company', isSortable: false },
                                { header: 'Start date', name: 'start_date', isSortable: false },
                                { header: 'Owner', name: 'owner', isSortable: false },
                                { header: 'Monitoring', name: 'monitoring', isSortable: false },
                            ], Row: VtrTableRow, data: tableData }), jsxs(ButtonsWrapper$3, { children: [jsx(Button$3, Object.assign({ theme: 'blue', size: 'small', onClick: handleRefreshVtrCertificates }, { children: "Refresh VTR certificates" })), onTerminateClick &&
                                    certificates.find((certificate) => certificate.fbolagnamn === vtrPartnerName) && (jsxs(Button$3, Object.assign({ theme: 'red', size: 'small', onClick: handleTerminateClick }, { children: ["Terminate ", vtrPartnerName, " certificate"] })))] })] })) : ('No active certificate.') })] }));
};

var _templateObject$8, _templateObject2$3, _templateObject3$3, _templateObject4$2, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var INITIAL_RETRY_DELAY = 200;
var MAXIMUM_NUMBERS_OF_RETRIES = 5;

var QuoteView = function QuoteView() {
  var _productDefinition$vt;

  var _useAlert = useAlert(),
      clearAlert = _useAlert.clearAlert,
      setAlert = _useAlert.setAlert;

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification,
      removeNotificationWithDelay = _useNotification.removeNotificationWithDelay;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      viewActions = _useState2[0],
      setViewActions = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      changeLog = _useState4[0],
      setChangeLog = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      numberOfRetries = _useState6[0],
      setNumberOfRetries = _useState6[1];

  var match = useRouteMatch(QUOTE);
  var quoteId = match.params.quoteId;
  var query = useQueryParam();
  useEffect(function () {
    setViewActions(global.definitions.views.find(function (view) {
      return view.name === 'quote';
    }).actions);
  }, []);
  useEffect(function () {
    var getChangeLog = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = setChangeLog;
                _context.next = 3;
                return quoteService.log(quoteId);

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getChangeLog() {
        return _ref.apply(this, arguments);
      };
    }();

    getChangeLog();
  }, []);
  var history = useHistory();

  var _useQuoteDetailsHooks = useQuoteDetailsHooks(quoteId),
      loading = _useQuoteDetailsHooks.loading,
      data = _useQuoteDetailsHooks.data,
      refetch = _useQuoteDetailsHooks.refetch;

  if (loading) return /*#__PURE__*/jsx(Loading, {});

  if (data.hasura_quote_insurance_holders.length === 0) {
    if (numberOfRetries < MAXIMUM_NUMBERS_OF_RETRIES) {
      setTimeout(function () {
        setNumberOfRetries(numberOfRetries + 1);
        refetch();
      }, INITIAL_RETRY_DELAY * (numberOfRetries + 1));
    }
  }

  if (data.hasura_quote_insurance_holders.length === 0) return numberOfRetries < MAXIMUM_NUMBERS_OF_RETRIES ? /*#__PURE__*/jsx(Loading, {}) : /*#__PURE__*/jsx("span", {
    children: "Could not find quote"
  });
  var productName = data.hasura_quote_insurance_holders[0].quote.product_name;
  var productDefinition = global.definitions.products.find(function (product) {
    return product.name === productName;
  });
  var _data$hasura_quote_in = data.hasura_quote_insurance_holders[0],
      company_record = _data$hasura_quote_in.company_record,
      person_holder = _data$hasura_quote_in.person_holder,
      _data$hasura_quote_in2 = _data$hasura_quote_in.quote,
      failed_filters = _data$hasura_quote_in2.failed_filters,
      hasura_quote_answers = _data$hasura_quote_in2.hasura_quote_answers,
      hasura_quotes_cover_premiums = _data$hasura_quote_in2.hasura_quotes_cover_premiums,
      id = _data$hasura_quote_in2.id,
      object_name = _data$hasura_quote_in2.object_name,
      renewal_for = _data$hasura_quote_in2.renewal_for,
      status = _data$hasura_quote_in2.status,
      type = _data$hasura_quote_in2.type;

  var handleAcceptClick = function handleAcceptClick() {
    setAlert({
      body: {
        header: 'Accept quote',
        message: 'Do you want to accept the quote?'
      },
      buttons: {
        Cancel: {
          type: 'secondary',
          text: 'Cancel',
          action: function action() {
            clearAlert();
          }
        },
        OK: {
          type: 'primary',
          text: 'Accept quote',
          action: function () {
            var _action = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
              var response;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return function () {
                        switch (type) {
                          case 'MTAQuoteType':
                            return quoteService.acceptMta(id);

                          case 'RenewalQuoteType':
                            return policyService.acceptRenewal(renewal_for);

                          default:
                            return quoteService.accept(id, productDefinition.withInvoiceMandate);
                        }
                      }();

                    case 3:
                      response = _context2.sent;
                      setAlert({
                        body: {
                          header: 'Quote accepted',
                          message: 'The quote was successfully accepted.'
                        },
                        buttons: {
                          Ok: {
                            type: 'primary',
                            text: 'OK',
                            action: function action() {
                              clearAlert();
                              history.push("".concat(LEDGERS, "/").concat(type === 'MTAQuoteType' || type === 'RenewalQuoteType' ? response.contents.ledgerId : response.ledgerId));
                            }
                          }
                        },
                        type: 'success'
                      });
                      _context2.next = 10;
                      break;

                    case 7:
                      _context2.prev = 7;
                      _context2.t0 = _context2["catch"](0);
                      setAlert({
                        body: {
                          header: 'Something went wrong',
                          message: "Could not accept quote: ".concat(_context2.t0)
                        },
                        buttons: {
                          Ok: {
                            type: 'primary',
                            text: 'OK',
                            action: function action() {
                              clearAlert();
                            }
                          }
                        },
                        type: 'warning'
                      });

                    case 10:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[0, 7]]);
            }));

            function action() {
              return _action.apply(this, arguments);
            }

            return action;
          }()
        }
      },
      type: 'question'
    });
  };

  var handleDiscardClick = function handleDiscardClick() {
    setAlert({
      body: {
        header: 'Discard quote',
        message: 'Do you want to discard the quote?'
      },
      buttons: {
        Cancel: {
          type: 'secondary',
          text: 'Cancel',
          action: function action() {
            clearAlert();
          }
        },
        OK: {
          type: 'primary',
          text: 'Discard quote',
          action: function () {
            var _action2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      _context3.next = 3;
                      return quoteService.discard(id);

                    case 3:
                      setAlert({
                        body: {
                          header: 'Quote discarded',
                          message: 'The quote was successfully discarded.'
                        },
                        buttons: {
                          Ok: {
                            type: 'primary',
                            text: 'OK',
                            action: function action() {
                              clearAlert();
                              window.location.reload();
                            }
                          }
                        },
                        type: 'success'
                      });
                      _context3.next = 9;
                      break;

                    case 6:
                      _context3.prev = 6;
                      _context3.t0 = _context3["catch"](0);
                      setAlert({
                        body: {
                          header: 'Something went wrong',
                          message: "Could not discard quote: ".concat(_context3.t0)
                        },
                        buttons: {
                          Ok: {
                            type: 'primary',
                            text: 'OK',
                            action: function action() {
                              clearAlert();
                            }
                          }
                        },
                        type: 'warning'
                      });

                    case 9:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[0, 6]]);
            }));

            function action() {
              return _action2.apply(this, arguments);
            }

            return action;
          }()
        }
      },
      type: 'warning'
    });
  };

  var handleCloneQuoteClick = function handleCloneQuoteClick() {
    return history.push("".concat(CREATE_QUOTE_SELECT_PRODUCT, "/").concat(productName, "?quoteId=").concat(quoteId));
  };

  var handleInvalidateVtrCacheClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return policyService.invalidateVtrCache(object_name, person_holder.social_security);

            case 3:
              removeNotificationWithDelay(addNotification('VTR cache was successfully invalidated', 'success'));
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              removeNotificationWithDelay(addNotification("Something went wrong when trying to invalidate VTR cache: ".concat(_context4.t0.response.status, ": ").concat(_context4.t0.response.data.message), 'alert'));

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }));

    return function handleInvalidateVtrCacheClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsxs(H1$1, {
      children: ["Quote (", status, type === 'MTAQuoteType' && ' MTA', type === 'RenewalQuoteType' && ' renewal', ")"]
    }), /*#__PURE__*/jsx(H2$1, {
      children: productName
    }), status === 'New' && /*#__PURE__*/jsxs(Fragment, {
      children: [type === 'MTAQuoteType' && query.get('mtaForPolicy') && /*#__PURE__*/jsx(MtaDifference, {
        quoteId: id
      }), /*#__PURE__*/jsxs(SubNavigation$1, {
        children: [viewActions && viewActions.find(function (action) {
          return action.name === 'acceptQuote' && action.show;
        }) && /*#__PURE__*/jsx("li", {
          children: /*#__PURE__*/jsxs(PrimaryButton, {
            color: "success",
            onClick: handleAcceptClick,
            children: [/*#__PURE__*/jsx(Icon, {
              iconName: "faCheckCircle",
              color: "#fff"
            }), " Accept", type === 'MTAQuoteType' && ' MTA', type === 'RenewalQuoteType' && ' renewal', " quote"]
          })
        }), viewActions && viewActions.find(function (action) {
          return action.name === 'discardQuote' && action.show;
        }) && /*#__PURE__*/jsx("li", {
          children: /*#__PURE__*/jsxs(PrimaryButton, {
            color: "warning",
            onClick: handleDiscardClick,
            children: [/*#__PURE__*/jsx(Icon, {
              iconName: "faTimesCircle",
              color: "#fff"
            }), " Discard quote"]
          })
        }), /*#__PURE__*/jsx("li", {
          children: viewActions && viewActions.find(function (action) {
            return action.name === 'quotationLink' && action.show;
          }) && /*#__PURE__*/jsx(Link, {
            href: "".concat(process.env.REACT_APP_PUBLIC_URL, "q/").concat(id),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Quotation letter"
          })
        }), /*#__PURE__*/jsxs(CloneListItem, {
          children: [productDefinition.possibleToCreateQuote && /*#__PURE__*/jsxs(PrimaryButton, {
            onClick: handleCloneQuoteClick,
            children: [/*#__PURE__*/jsx(Icon, {
              iconName: "faCopy",
              color: "#fff"
            }), " Clone quote"]
          }), productDefinition.possibleToInvalidateVtrCache && /*#__PURE__*/jsx(PrimaryButton, {
            onClick: handleInvalidateVtrCacheClick,
            children: "Invalidate VTR cache"
          })]
        })]
      })]
    }), /*#__PURE__*/jsxs(Grid, {
      children: [/*#__PURE__*/jsxs(MainContentContainer, {
        children: [/*#__PURE__*/jsx(QuoteCoversContainer, {
          children: /*#__PURE__*/jsx(QuoteCoveragePeriods, {
            covers: hasura_quotes_cover_premiums
          })
        }), productName && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(DefinedPolicyAnswers, {
            defaultValues: {
              cover_level: data.hasura_quote_insurance_holders[0].quote.cover_level,
              created: data.hasura_quote_insurance_holders[0].quote.created,
              end_date: data.hasura_quote_insurance_holders[0].quote.end_date,
              start_date: data.hasura_quote_insurance_holders[0].quote.start_date
            },
            productSpecificFields: productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.outputFields.find(function (fields) {
              return fields.group === 'policy';
            }).fields,
            source: hasura_quote_answers
          }), /*#__PURE__*/jsx(DefinedCustomerAnswers, {
            defaultPersonValues: person_holder,
            defaultCompanyValues: company_record,
            productSpecificFields: productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.outputFields.find(function (fields) {
              return fields.group === 'customer';
            }).fields,
            source: person_holder !== null && person_holder !== void 0 ? person_holder : company_record,
            backupSource: hasura_quote_answers
          }), /*#__PURE__*/jsx(DefinedObjectAnswers, {
            productSpecificFields: productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.outputFields.find(function (fields) {
              return fields.group === 'object';
            }).fields,
            source: hasura_quote_answers
          })]
        }), /*#__PURE__*/jsx(QuoteLedgersContainer, {
          children: /*#__PURE__*/jsx(QuoteLedgers, {
            quoteId: id
          })
        })]
      }), /*#__PURE__*/jsxs(SideContentContainer, {
        children: [(productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.purchaseMethods) && /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(QuoteAccounts, {
            purchaseMethods: productDefinition.purchaseMethods,
            quoteId: id
          })
        }), failed_filters.length > 0 && /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(QuoteFailedFilters, {
            failedFilters: failed_filters
          })
        }), (productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.showVtrCertificates) && /*#__PURE__*/jsx(VtrCertificates, {
          registrationNumber: object_name,
          insuranceHolder: person_holder ? person_holder.social_security : company_record.reference,
          vtrPartnerName: (_productDefinition$vt = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.vtrPartnerName) !== null && _productDefinition$vt !== void 0 ? _productDefinition$vt : null
        }), changeLog && /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(ChangeLog, {
            changeLog: changeLog
          })
        })]
      }), hasura_quote_answers.length > 0 && /*#__PURE__*/jsx(QuoteAnswersContainer, {
        children: /*#__PURE__*/jsx(QuoteAnswers, {
          quoteAnswers: hasura_quote_answers
        })
      })]
    })]
  });
};
var H1$1 = styled.h1(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
var H2$1 = styled.h2(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  color: #7b7d8c;\n"])));
var Grid = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  gap: 0.5rem;\n"])));
var MainContentContainer = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n"])));
var SideContentContainer = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"])));
var QuoteAnswersContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  grid-column: 1 / span 2;\n"])));
var QuoteCoversContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  grid-column: 1 / span 3;\n"])));
var QuoteLedgersContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  grid-column: 1 / span 3;\n"])));
var CloneListItem = styled.li(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n"])));
var Link = styled.a(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  text-decoration: none;\n"])));

const TableRow$2 = ({ content, onClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const getTagColor = (status) => {
        switch (status) {
            case 'Accepted':
                return 'green';
            case 'Discarded':
                return 'red';
            default:
                return 'blue';
        }
    };
    const handleMouseEnter = () => setIsMouseOver(true);
    const handleMouseLeave = () => setIsMouseOver(false);
    const handleClick = () => onClick && onClick(content.id);
    return (jsxs(Fragment, { children: [jsx(HideOverflow$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuredObject }, { children: content.insuredObject })), jsxs(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [new Date(content.created).toLocaleDateString('sv-SE'), ' ', new Date(content.created).toLocaleTimeString('sv-SE', {
                        hour: '2-digit',
                        minute: '2-digit',
                    })] })), jsx(TableCell$4, Object.assign({ onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: jsx(TagWrapper$3, { children: jsx(TagsContainer$2, { children: jsx(Tag, { text: content.status, color: getTagColor(content.status), size: 'small' }) }) }) })), jsx(HideOverflow$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.product }, { children: content.product })), jsx(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.startDate })), jsx(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.endDate })), jsx(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.periodPremium.toLocaleString('sv-SE', {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                }) })), jsx(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.annualPremium.toLocaleString('sv-SE', {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                }) })), jsx(HideOverflow$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuranceHolder }, { children: content.insuranceHolder })), jsx(TableCell$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.telephone })), jsx(HideOverflow$4, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.email }, { children: content.email }))] }));
};
const TagsContainer$2 = styled.div `
  display: flex;
  gap: 0.25rem;
  align-self: center;
`;
const TableCell$4 = styled(GridTableCell) `
  color: ${({ isHovering }) => (isHovering ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isHovering }) => (isHovering ? 'underline' : 'none')};
  cursor: pointer;
`;
const TagWrapper$3 = styled.div `
  display: flex;
  height: 100%;
`;
const HideOverflow$4 = styled(TableCell$4) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

var QuotesView = function QuotesView() {
  var _useSearchQuotes = useSearchQuotes(),
      _useSearchQuotes2 = _slicedToArray(_useSearchQuotes, 2),
      getQuotes = _useSearchQuotes2[0],
      _useSearchQuotes2$ = _useSearchQuotes2[1],
      called = _useSearchQuotes2$.called,
      loading = _useSearchQuotes2$.loading,
      data = _useSearchQuotes2$.data;

  var history = useHistory();
  var query = useQueryParam();

  var _useState = useState(query.get('q') ? query.get('q').trim() : ''),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tableData = _useState4[0],
      setTableData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      redirect = _useState6[0],
      setRedirect = _useState6[1];

  useEffect(function () {
    if (data) {
      setTableData(data.hasura_quote_insurance_holders.map(function (insuranceHolder) {
        var _insuranceHolder$comp, _insuranceHolder$comp2, _insuranceHolder$comp3, _insuranceHolder$comp4, _insuranceHolder$comp5, _insuranceHolder$comp6, _insuranceHolder$quot;

        return {
          annualPremium: insuranceHolder.quote.hasura_quotes_cover_premiums.reduce(function (a, b) {
            return a + b.day_premium + b.day_tax;
          }, 0) * 365,
          created: insuranceHolder.quote.created,
          email: insuranceHolder.person_holder ? insuranceHolder.person_holder.email : (_insuranceHolder$comp = (_insuranceHolder$comp2 = insuranceHolder.company_record) === null || _insuranceHolder$comp2 === void 0 ? void 0 : _insuranceHolder$comp2.email) !== null && _insuranceHolder$comp !== void 0 ? _insuranceHolder$comp : '',
          endDate: insuranceHolder.quote.end_date,
          id: insuranceHolder.quote.id,
          insuranceHolder: insuranceHolder.person_holder ? "".concat(insuranceHolder.person_holder.first_name, " ").concat(insuranceHolder.person_holder.last_name) : (_insuranceHolder$comp3 = (_insuranceHolder$comp4 = insuranceHolder.company_record) === null || _insuranceHolder$comp4 === void 0 ? void 0 : _insuranceHolder$comp4.name) !== null && _insuranceHolder$comp3 !== void 0 ? _insuranceHolder$comp3 : '',
          insuredObject: insuranceHolder.quote.object_name,
          product: insuranceHolder.quote.product_name,
          startDate: insuranceHolder.quote.start_date,
          status: insuranceHolder.quote.status,
          telephone: insuranceHolder.person_holder ? insuranceHolder.person_holder.telephone : (_insuranceHolder$comp5 = (_insuranceHolder$comp6 = insuranceHolder.company_record) === null || _insuranceHolder$comp6 === void 0 ? void 0 : _insuranceHolder$comp6.phone) !== null && _insuranceHolder$comp5 !== void 0 ? _insuranceHolder$comp5 : '',
          periodPremium: insuranceHolder.quote.hasura_quotes_cover_premiums.reduce(function (a, b) {
            return a + b.period_premium + b.period_tax;
          }, 0),
          reference: (_insuranceHolder$quot = insuranceHolder.quote.hasura_quote_answers[0]) === null || _insuranceHolder$quot === void 0 ? void 0 : _insuranceHolder$quot.value
        };
      }));
    }
  }, [data]);
  useEffect(function () {
    var params = new URLSearchParams();
    searchQuery ? params.append('q', searchQuery) : params.delete('q', searchQuery);
    history.push("".concat(QUOTES, "?").concat(params.toString()));
  }, [searchQuery, history]);
  useEffect(function () {
    if (searchQuery.trim().length > 0) {
      doSearch();
    }
  }, [searchQuery]);

  var doSearch = function doSearch() {
    var trimmedSearchQuery = searchQuery.trim();

    if (trimmedSearchQuery.length > 0) {
      var filters = [];
      filters.push({
        quote: {
          object_name: {
            _ilike: "%".concat(trimmedSearchQuery, "%")
          }
        }
      });
      filters.push({
        company_record: {
          reference: {
            _eq: trimmedSearchQuery.replace('-', '')
          }
        }
      });
      filters.push({
        company_record: {
          name: {
            _ilike: "%".concat(trimmedSearchQuery, "%")
          }
        }
      });
      filters.push({
        person_holder: {
          social_security: {
            _ilike: "%".concat(trimmedSearchQuery.replace('-', ''))
          }
        }
      });

      if (emailCheck.test(trimmedSearchQuery)) {
        filters.push({
          company_record: {
            email: {
              _ilike: "%".concat(trimmedSearchQuery, "%")
            }
          }
        });
        filters.push({
          person_holder: {
            email: {
              _ilike: "%".concat(trimmedSearchQuery, "%")
            }
          }
        });
      }

      if (trimmedSearchQuery.match(telephoneWithoutCountryCodeCheck)) {
        filters.push({
          company_record: {
            phone: {
              _like: "%".concat(trimmedSearchQuery.slice(1), "%")
            }
          }
        });
        filters.push({
          person_holder: {
            telephone: {
              _like: "%".concat(trimmedSearchQuery.slice(1), "%")
            }
          }
        });
      }

      if (trimmedSearchQuery.match(telephoneWithCountryCodeCheck)) {
        filters.push({
          company_record: {
            phone: {
              _like: "%".concat(trimmedSearchQuery.slice(3), "%")
            }
          }
        });
        filters.push({
          person_holder: {
            telephone: {
              _like: "%".concat(trimmedSearchQuery.slice(3), "%")
            }
          }
        });
      }

      getQuotes({
        variables: {
          where: {
            _or: filters
          }
        }
      });
    }
  };

  var handleSubmit = function handleSubmit(registrationNumber) {
    setRedirect(true);
    setSearchQuery(registrationNumber);
  };

  var handleQuoteClick = function handleQuoteClick(quoteId) {
    return history.push("".concat(QUOTES, "/").concat(quoteId));
  };

  if (called && loading) return /*#__PURE__*/jsx(Loading, {});
  if (!called) return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Quotes"
    }), /*#__PURE__*/jsx(Search, {
      label: "Find quote by registration number",
      onSubmit: handleSubmit,
      value: searchQuery,
      autoFocus: true
    })]
  });
  var hasura_quote_insurance_holders = data.hasura_quote_insurance_holders;
  return redirect && hasura_quote_insurance_holders.length === 1 ? /*#__PURE__*/jsx(Redirect, {
    push: true,
    to: "".concat(QUOTES, "/").concat(hasura_quote_insurance_holders[0].quote.id)
  }) : /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Quotes"
    }), /*#__PURE__*/jsx(Search, {
      label: "Find quote",
      onSubmit: handleSubmit,
      value: searchQuery,
      autoFocus: true
    }), hasura_quote_insurance_holders.length === 0 ? /*#__PURE__*/jsx("div", {
      children: "No quotes found."
    }) : /*#__PURE__*/jsx(GridTable$1, {
      columns: [{
        header: 'Object',
        name: 'insuredObject',
        isSortable: true,
        type: 'string'
      }, {
        header: 'Created',
        name: 'created',
        isSortable: true,
        type: 'string'
      }, {
        header: 'Status',
        name: 'status',
        isSortable: false,
        type: 'string'
      }, {
        header: 'Product',
        name: 'product',
        isSortable: true,
        type: 'string'
      }, {
        header: 'Start date',
        name: 'startDate',
        isSortable: true,
        type: 'string'
      }, {
        header: 'End date',
        name: 'endDate',
        isSortable: true,
        type: 'string'
      }, {
        header: 'Period premium',
        name: 'periodPremium',
        isSortable: true,
        type: 'number'
      }, {
        header: 'Annual premium',
        name: 'annualPremium',
        isSortable: true,
        type: 'number'
      }, {
        header: 'Policy holder',
        name: 'insuranceHolder',
        isSortable: true,
        type: 'string'
      }, {
        header: 'Telephone',
        name: 'telephone',
        isSortable: true,
        type: 'string'
      }, {
        header: 'E-mail',
        name: 'email',
        isSortable: true,
        type: 'string'
      }],
      data: tableData,
      Row: TableRow$2,
      tableRowCustomProps: {
        onClick: handleQuoteClick
      },
      sort: {
        columnName: 'startDate',
        direction: 'desc'
      },
      isLoading: called && loading,
      noOfLoadingRows: 3
    })]
  });
};

const PolicyRenewFrom = ({ id }) => {
    const { loading, data } = usePolicy(id);
    return !loading && data.hasura_policy_insurance_holders[0] ? (jsxs(Fragment, { children: [jsx("br", {}), jsxs(RenewedFrom$1, { children: ["Renewed from", ' ', data.hasura_policy_insurance_holders[0].policy.policy_number] })] })) : null;
};
const PolicyTableRow = ({ content, onClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const policyStatus = () => {
        if (content.status === 'Active' && new Date(content.endDate) < new Date()) {
            return 'Lapsed';
        }
        if (content.status === 'Terminated' &&
            new Date(content.endDate) > new Date()) {
            return 'To be terminated';
        }
        return content.status;
    };
    const getTagColor = (status) => {
        switch (status) {
            case 'Active':
                return 'green';
            case 'Lapsed':
            case 'To be terminated':
                return 'orange';
            case 'Terminated':
            case 'Undone':
                return 'red';
            default:
                return 'blue';
        }
    };
    const handleMouseEnter = () => setIsMouseOver(true);
    const handleMouseLeave = () => setIsMouseOver(false);
    const handleClick = () => onClick && onClick(content.id);
    return (jsxs(Fragment, { children: [jsxs(HideOverflow$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: `${new Date(content.created).toLocaleDateString('sv-SE')} ${new Date(content.created).toLocaleTimeString('sv-SE', {
                    hour: '2-digit',
                    minute: '2-digit',
                })}` }, { children: [new Date(content.created).toLocaleDateString('sv-SE'), ' ', new Date(content.created).toLocaleTimeString('sv-SE', {
                        hour: '2-digit',
                        minute: '2-digit',
                    })] })), jsxs(TableCell$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [content.policyNumber, content.previousPolicyId && (jsx(PolicyRenewFrom, { id: content.previousPolicyId }))] })), jsx(TableCell$3, Object.assign({ onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: jsx(TagWrapper$2, { children: jsxs(TagsContainer$1, { children: [jsx(Tag, { text: policyStatus(), color: getTagColor(policyStatus()), size: 'small' }), content.coveragePeriods.length > 1 && (jsx(Tag, { text: 'MTA', color: getTagColor('mta'), size: 'small' })), content.nextPolicyId && (jsx(Tag, { text: 'Renewed', color: getTagColor('renewed'), size: 'small' }))] }) }) })), jsx(HideOverflow$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuredObject }, { children: content.insuredObject })), jsx(HideOverflow$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.product }, { children: content.product })), jsx(TableCell$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.startDate })), jsx(TableCell$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.endDate })), jsx(HideOverflow$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuranceHolder }, { children: content.insuranceHolder })), jsx(TableCell$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.telephone })), jsx(HideOverflow$3, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.email }, { children: content.email }))] }));
};
const TagsContainer$1 = styled.div `
  display: flex;
  gap: 0.25rem;
  align-self: center;
`;
const TagWrapper$2 = styled.div `
  display: flex;
  height: 100%;
`;
const TableCell$3 = styled(GridTableCell) `
  color: ${({ isHovering }) => (isHovering ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isHovering }) => (isHovering ? 'underline' : 'none')};
  cursor: pointer;
`;
const HideOverflow$3 = styled(TableCell$3) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const RenewedFrom$1 = styled.span `
  font-size: 0.75rem;
  font-style: italic;
  white-space: nowrap;
`;

const QuoteTableRow = ({ content, onClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const getTagColor = (status) => {
        switch (status) {
            case 'Accepted':
                return 'green';
            case 'Discarded':
                return 'red';
            default:
                return 'blue';
        }
    };
    const handleMouseEnter = () => setIsMouseOver(true);
    const handleMouseLeave = () => setIsMouseOver(false);
    const handleClick = () => onClick && onClick(content.id);
    return (jsxs(Fragment, { children: [jsxs(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: `${new Date(content.created).toLocaleDateString('sv-SE')} ${new Date(content.created).toLocaleTimeString('sv-SE', {
                    hour: '2-digit',
                    minute: '2-digit',
                })}` }, { children: [new Date(content.created).toLocaleDateString('sv-SE'), ' ', new Date(content.created).toLocaleTimeString('sv-SE', {
                        hour: '2-digit',
                        minute: '2-digit',
                    })] })), jsx(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuredObject }, { children: content.insuredObject })), jsx(TableCell$2, Object.assign({ onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: jsx(TagWrapper$1, { children: jsx(TagsContainer, { children: jsx(Tag, { text: content.status, color: getTagColor(content.status), size: 'small' }) }) }) })), jsx(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.product }, { children: content.product })), jsx(TableCell$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.startDate })), jsx(TableCell$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.endDate })), jsx(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.insuranceHolder }, { children: content.insuranceHolder })), jsx(TableCell$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: content.telephone })), jsx(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.email }, { children: content.email })), jsx(HideOverflow$2, Object.assign({ isHovering: isMouseOver, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, title: content.reference }, { children: content.reference }))] }));
};
const TagsContainer = styled.div `
  display: flex;
  gap: 0.25rem;
  align-self: center;
`;
const TableCell$2 = styled(GridTableCell) `
  color: ${({ isHovering }) => (isHovering ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isHovering }) => (isHovering ? 'underline' : 'none')};
  cursor: pointer;
`;
const TagWrapper$1 = styled.div `
  display: flex;
  height: 100%;
`;
const HideOverflow$2 = styled(TableCell$2) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RecentView = () => {
    var _a;
    const query = useQueryParam();
    const view = query.get('view') === 'quotes' ? 'quotes' : 'policies';
    const { loading, error, data, called, refetch } = useRecentActivites();
    const history = useHistory();
    const [policiesTableData, setPoliciesTableData] = useState([]);
    const [quotesTableData, setQuotesTableData] = useState([]);
    useEffect(() => {
        if (data) {
            setPoliciesTableData(data.hasura_policies.map((policy) => {
                var _a, _b, _c, _d, _e, _f;
                return ({
                    coveragePeriods: policy.hasura_policy_coverage_periods,
                    created: policy.created,
                    email: policy.hasura_policy_insurance_holders[0].person_holder
                        ? policy.hasura_policy_insurance_holders[0].person_holder.email
                        : (_b = (_a = policy.hasura_policy_insurance_holders[0].company_record) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : '',
                    endDate: policy.end_date,
                    id: policy.id,
                    insuranceHolder: policy.hasura_policy_insurance_holders[0]
                        .person_holder
                        ? `${policy.hasura_policy_insurance_holders[0].person_holder.first_name} ${policy.hasura_policy_insurance_holders[0].person_holder.last_name}`
                        : (_d = (_c = policy.hasura_policy_insurance_holders[0].company_record) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                    insuredObject: policy.object_name,
                    nextPolicyId: policy.next_policy_id,
                    policyNumber: policy.policy_number,
                    previousPolicyId: policy.previous_policy_id,
                    product: policy.product_name,
                    startDate: policy.start_date,
                    status: policy.status,
                    telephone: policy.hasura_policy_insurance_holders[0].person_holder
                        ? policy.hasura_policy_insurance_holders[0].person_holder.telephone
                        : (_f = (_e = policy.hasura_policy_insurance_holders[0].company_record) === null || _e === void 0 ? void 0 : _e.phone) !== null && _f !== void 0 ? _f : '',
                });
            }));
            setQuotesTableData(data.hasura_quotes.map((quote) => {
                var _a, _b, _c, _d, _e, _f, _g;
                return ({
                    created: quote.created,
                    email: quote.hasura_quote_insurance_holders[0].person_holder
                        ? quote.hasura_quote_insurance_holders[0].person_holder.email
                        : (_b = (_a = quote.hasura_quote_insurance_holders[0].company_record) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : '',
                    endDate: quote.end_date,
                    id: quote.id,
                    insuranceHolder: quote.hasura_quote_insurance_holders[0].person_holder
                        ? `${quote.hasura_quote_insurance_holders[0].person_holder.first_name} ${quote.hasura_quote_insurance_holders[0].person_holder.last_name}`
                        : (_c = quote.hasura_quote_insurance_holders[0].company_record.name) !== null && _c !== void 0 ? _c : '',
                    insuredObject: quote === null || quote === void 0 ? void 0 : quote.object_name,
                    product: quote.product_name,
                    startDate: quote.start_date,
                    status: quote.status,
                    telephone: quote.hasura_quote_insurance_holders[0].person_holder
                        ? quote.hasura_quote_insurance_holders[0].person_holder.telephone
                        : (_e = (_d = quote.hasura_quote_insurance_holders[0].company_record) === null || _d === void 0 ? void 0 : _d.phone) !== null && _e !== void 0 ? _e : '',
                    reference: (_g = (_f = quote.hasura_quote_answers[0]) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '',
                });
            }));
        }
    }, [data]);
    useEffect(() => {
        const poll = setInterval(() => {
            refetch();
        }, 5 * 60 * 1000);
        return () => {
            clearInterval(poll);
        };
    }, []);
    if (error) {
        return (jsxs(ContentContainer, { children: [jsx("h1", { children: "Something went wrong" }), jsx("p", { children: error.message })] }));
    }
    const handlePolicyClick = (policyId) => {
        history.push(`${RECENT}?view=policies`);
        history.push(`${POLICIES}/${policyId}`);
    };
    const handleQuoteClick = (quoteId) => {
        history.push(`${RECENT}?view=quotes`);
        history.push(`${QUOTES}/${quoteId}`);
    };
    let TabIndexes;
    (function (TabIndexes) {
        TabIndexes[TabIndexes["policies"] = 0] = "policies";
        TabIndexes[TabIndexes["quotes"] = 1] = "quotes";
    })(TabIndexes || (TabIndexes = {}));
    return (jsxs(ContentContainer, { children: [jsxs("h1", { children: ["Recent ", view] }), jsx(TabContent, { contents: [
                    {
                        item: { content: jsx("span", { children: "Policies" }) },
                        component: (jsx(GridTable$1, { columns: [
                                {
                                    header: 'Created',
                                    name: 'created',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Policy',
                                    name: 'policy',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Status',
                                    name: 'status',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Insured object',
                                    name: 'insuredObject',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Product',
                                    name: 'product',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Start date',
                                    name: 'startDate',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'End date',
                                    name: 'endDate',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Policy holder',
                                    name: 'insuranceHolder',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Telephone',
                                    name: 'telephone',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'E-mail',
                                    name: 'email',
                                    isSortable: false,
                                    type: 'string',
                                },
                            ], data: policiesTableData, Row: PolicyTableRow, tableRowCustomProps: {
                                onClick: handlePolicyClick,
                            }, isLoading: called && loading, noOfLoadingRows: 20 })),
                    },
                    {
                        item: { content: jsx("span", { children: "Quotes" }) },
                        component: (jsx(GridTable$1, { columns: [
                                {
                                    header: 'Created',
                                    name: 'created',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Object',
                                    name: 'insuredObject',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Status',
                                    name: 'status',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Product',
                                    name: 'product',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Start date',
                                    name: 'startDate',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'End date',
                                    name: 'endDate',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Policy holder',
                                    name: 'insuranceHolder',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Telephone',
                                    name: 'telephone',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'E-mail',
                                    name: 'email',
                                    isSortable: false,
                                    type: 'string',
                                },
                                {
                                    header: 'Reference',
                                    name: 'reference',
                                    isSortable: false,
                                    type: 'string',
                                },
                            ], data: quotesTableData, Row: QuoteTableRow, tableRowCustomProps: {
                                onClick: handleQuoteClick,
                            }, isLoading: called && loading, noOfLoadingRows: 20 })),
                    },
                ], size: 'medium', defaultIndex: (_a = TabIndexes[view]) !== null && _a !== void 0 ? _a : 0 })] }));
};

var _templateObject$7, _templateObject2$2, _templateObject3$2, _templateObject4$1;
var DAYS_IN_A_YEAR$2 = 365;

var TableRow$1 = function TableRow(_ref) {
  var _policyHolder$policy$, _policyHolder$policy$2, _policyHolder$policy$3, _policyHolder$policy$4;

  var policyHolder = _ref.policyHolder,
      onClick = _ref.onClick;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      isMouseOver = _useState2[0],
      setIsMouseOver = _useState2[1];

  var handleMouseEnter = function handleMouseEnter() {
    return setIsMouseOver(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    return setIsMouseOver(false);
  };

  var handleClick = function handleClick() {
    return onClick(policyHolder.policy.id);
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.policy_number
    }), /*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.product_name
    }), /*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.cover_level
    }), /*#__PURE__*/jsx(HideOverflow$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.object_name
    }), /*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.start_date
    }), /*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: policyHolder.policy.end_date
    }), /*#__PURE__*/jsx(TableCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: (_policyHolder$policy$ = (_policyHolder$policy$2 = policyHolder.policy.hasura_ledger) === null || _policyHolder$policy$2 === void 0 ? void 0 : (_policyHolder$policy$3 = _policyHolder$policy$2.hasura_ledger_mandates) === null || _policyHolder$policy$3 === void 0 ? void 0 : (_policyHolder$policy$4 = _policyHolder$policy$3[0]) === null || _policyHolder$policy$4 === void 0 ? void 0 : _policyHolder$policy$4.payment_provider) !== null && _policyHolder$policy$ !== void 0 ? _policyHolder$policy$ : ''
    }), policyHolder.person_holder ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(HideOverflow$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [policyHolder.person_holder.first_name, ' ', policyHolder.person_holder.last_name]
      }), /*#__PURE__*/jsx(TableCell$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: policyHolder.person_holder.telephone
      }), /*#__PURE__*/jsx(HideOverflow$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: policyHolder.person_holder.email
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(TableCell$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: policyHolder.company_record.name
      }), /*#__PURE__*/jsx(TableCell$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: policyHolder.company_record.phone
      }), /*#__PURE__*/jsx(TableCell$1, {
        isHovering: isMouseOver,
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: policyHolder.company_record.email
      })]
    }), /*#__PURE__*/jsx(RightAlignCell$1, {
      isHovering: isMouseOver,
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: (policyHolder.policy.hasura_policy_coverage_periods.reduce(function (sum, period) {
        return sum + period.day_premium + period.day_tax;
      }, 0) * DAYS_IN_A_YEAR$2).toLocaleString('sv-SE', {
        maximumFractionDigits: 0
      })
    }), /*#__PURE__*/jsx(RowBorder, {})]
  });
};
var TableCell$1 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: ", ";\n  cursor: pointer;\n  /* padding-right: 1rem; */\n"])), function (_ref2) {
  var isHovering = _ref2.isHovering;
  return isHovering ? '#fc8e49' : 'inherit';
}, function (_ref3) {
  var isHovering = _ref3.isHovering;
  return isHovering ? 'underline' : 'none';
});
var RightAlignCell$1 = styled(TableCell$1)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var RowBorder = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  grid-column: 1 / span 11;\n  border-bottom: 0.0625rem dotted #dedede;\n"])));
var HideOverflow$1 = styled(TableCell$1)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));

var _templateObject$6;
var NUMBER_OF_DAYS_EXPIRATION = 75;

var UpcomingRenewalsView = function UpcomingRenewalsView() {
  var history = useHistory();

  var _useUpcomingRenewals = useUpcomingRenewals(formatDate(addDays(new Date(), NUMBER_OF_DAYS_EXPIRATION))),
      data = _useUpcomingRenewals.data,
      loading = _useUpcomingRenewals.loading;

  if (loading) return /*#__PURE__*/jsx(Loading, {});

  var handlePolicyClick = function handlePolicyClick(policyId) {
    return history.push("".concat(POLICIES, "/").concat(policyId));
  };

  var downloadCSV = function downloadCSV(insuranceHolders) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'upcoming-renewals.csv';
    if (!insuranceHolders || !insuranceHolders.length) return;

    var escapeCsv = function escapeCsv(v) {
      var s = String(v !== null && v !== void 0 ? v : '');
      return /[;"\n\r]/.test(s) ? "\"".concat(s.replace(/"/g, '""'), "\"") : s;
    };

    var rows = insuranceHolders.map(function (insurance) {
      var _insurance$policy, _insurance$person_hol, _policy$hasura_ledger, _policy$hasura_ledger2, _person$first_name, _person$email, _policy$object_name, _policy$start_date, _policy$end_date, _mandates$0$payment_p, _mandates$;

      var policy = (_insurance$policy = insurance.policy) !== null && _insurance$policy !== void 0 ? _insurance$policy : null;
      var person = (_insurance$person_hol = insurance.person_holder) !== null && _insurance$person_hol !== void 0 ? _insurance$person_hol : null;
      var mandates = (_policy$hasura_ledger = policy === null || policy === void 0 ? void 0 : (_policy$hasura_ledger2 = policy.hasura_ledger) === null || _policy$hasura_ledger2 === void 0 ? void 0 : _policy$hasura_ledger2.hasura_ledger_mandates) !== null && _policy$hasura_ledger !== void 0 ? _policy$hasura_ledger : [];
      return {
        first_name: (_person$first_name = person === null || person === void 0 ? void 0 : person.first_name) !== null && _person$first_name !== void 0 ? _person$first_name : '',
        email: (_person$email = person === null || person === void 0 ? void 0 : person.email) !== null && _person$email !== void 0 ? _person$email : '',
        object_name: (_policy$object_name = policy === null || policy === void 0 ? void 0 : policy.object_name) !== null && _policy$object_name !== void 0 ? _policy$object_name : '',
        period_start_date: (_policy$start_date = policy === null || policy === void 0 ? void 0 : policy.start_date) !== null && _policy$start_date !== void 0 ? _policy$start_date : '',
        period_end_date: (_policy$end_date = policy === null || policy === void 0 ? void 0 : policy.end_date) !== null && _policy$end_date !== void 0 ? _policy$end_date : '',
        payment_provider: (_mandates$0$payment_p = (_mandates$ = mandates[0]) === null || _mandates$ === void 0 ? void 0 : _mandates$.payment_provider) !== null && _mandates$0$payment_p !== void 0 ? _mandates$0$payment_p : ''
      };
    });
    var headers = Object.keys(rows[0]);
    var csvContent = [headers.join(';')].concat(_toConsumableArray(rows.map(function (row) {
      return headers.map(function (header) {
        return escapeCsv(row[header]);
      }).join(';');
    }))).join('\n');
    var csvWithBom = "\uFEFF" + csvContent;
    var blob = new Blob([csvWithBom], {
      type: 'text/csv;charset=utf-8;'
    });
    var link = document.createElement('a');
    var url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return /*#__PURE__*/jsxs(ContentContainer, {
    children: [/*#__PURE__*/jsx("h1", {
      children: "Upcoming renewals"
    }), /*#__PURE__*/jsx(ButtonWrapper, {
      children: /*#__PURE__*/jsx(Button$3, {
        theme: "orange",
        variant: "secondary",
        size: "small",
        onClick: function onClick() {
          return downloadCSV(data.hasura_policy_insurance_holders, "upcoming-renewals-".concat(new Date().toISOString().replace(/[:.]/g, '-'), ".csv"));
        },
        children: "Download as CSV"
      })
    }), /*#__PURE__*/jsx(PageSection, {
      children: data.hasura_policy_insurance_holders.length > 0 ? /*#__PURE__*/jsx(GridTable, {
        headerItems: ['Policy', 'Product', 'Coverage', 'Object', 'Start date', 'End date', 'Payment provider', 'Policy holder', 'Telephone', 'E-mail', 'Annual premium'],
        children: data.hasura_policy_insurance_holders.map(function (policyHolder) {
          return /*#__PURE__*/jsx(TableRow$1, {
            policyHolder: policyHolder,
            onClick: handlePolicyClick
          }, policyHolder.policy.id);
        })
      }) : "No policies upcoming for renewal the next ".concat(NUMBER_OF_DAYS_EXPIRATION, " days.")
    })]
  });
};
var ButtonWrapper = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));

const ChangePaymentProvider = ({ paymentProvider, ledgerId, paymentProviderUrlParam, }) => {
    return (jsxs(NamedItem, { children: [jsxs("label", { children: ["Change account ", paymentProvider] }), jsx(CopyText, { text: `${process.env.REACT_APP_PUBLIC_URL}reattach/${paymentProviderUrlParam}/${ledgerId}` })] }));
};

const bankStatusLabel = (lifecycle) => {
    switch (lifecycle.tag) {
        case 'AwaitingBank':
            return 'Awaiting bank';
        case 'Live':
            return lifecycle.approval === 'Suspended' ? 'Suspended' : 'Live';
        case 'Abandoned':
            return 'Abandoned';
        case 'Revoked':
            return 'Revoked';
    }
};
const MddStatusFields = ({ mdd }) => (jsxs(Fragment, { children: [jsxs(NamedItem, { children: [jsx("span", { children: "Bank status" }), bankStatusLabel(mdd.lifecycle)] }), jsxs(NamedItem, { children: [jsx("span", { children: "Chargeable" }), mdd.signedAndApproved ? 'Yes' : 'No'] }), mdd.lifecycle.tag === 'Revoked' && (jsxs(FullWidthItem, { children: [jsx("span", { children: "Revoked at" }), formatDateTime(new Date(mdd.lifecycle.revokedAt)), mdd.lifecycle.reason ? ` — ${mdd.lifecycle.reason}` : ''] }))] }));
const MandateItem = ({ mandate, status, statusPending }) => {
    var _a;
    return (jsxs(ListItem, Object.assign({ theme: mandate.is_active ? 'green' : 'grey' }, { children: [jsx("h4", { children: mandate.payment_provider }), jsxs(AttributsWrapper, { children: [jsxs(NamedItem, { children: [jsx("span", { children: "Id" }), mandate.id] }), jsxs(NamedItem, { children: [jsx("span", { children: "Index" }), mandate.index] }), mandate.merchant_reference && (jsxs(FullWidthItem, { children: [jsx("span", { children: "Merchant ref" }), mandate.merchant_reference] })), jsxs(NamedItem, { children: [jsx("span", { children: "Added" }), formatDateTime(new Date(mandate.added_at))] }), !statusPending &&
                        ((status === null || status === void 0 ? void 0 : status.mdd) ? (jsx(MddStatusFields, { mdd: status.mdd })) : (jsxs(Fragment, { children: [jsxs(NamedItem, { children: [jsx("span", { children: "Approved" }), mandate.signed_and_approved ? 'Yes' : 'No'] }), jsxs(NamedItem, { children: [jsx("span", { children: "Revoked" }), mandate.revoked ? 'Yes' : 'No'] })] }))), ((_a = mandate.attributes) === null || _a === void 0 ? void 0 : _a.bank) && (jsxs(FullWidthItem, { children: [jsx("span", { children: "Bank" }), mandate.attributes.bank.replaceAll('"', '')] }))] })] })));
};
const AttributsWrapper = styled.div `
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 0.25rem;
`;
const FullWidthItem = styled(NamedItem) `
  grid-column: 1 / span 4;
`;

const MandateHistory = ({ mandateHistory, mandateStatuses, }) => {
    // hasura_ledger_mandates.index equals the endpoint's mandateIndex.
    const statusFor = (mandate) => mandateStatuses === null || mandateStatuses === void 0 ? void 0 : mandateStatuses.find(status => status.mandateIndex === mandate.index);
    const statusPending = mandateStatuses === undefined;
    return (jsx(TabContent, { contents: [
            {
                item: { content: jsx("span", { children: "Active mandate" }) },
                component: (jsx(MandateList, { children: mandateHistory
                        .filter(mandate => mandate.is_active)
                        .map(mandate => (jsx(MandateItem, { mandate: mandate, status: statusFor(mandate), statusPending: statusPending }, mandate.id))) })),
            },
            {
                item: { content: jsx("span", { children: "Old mandates" }) },
                component: (jsx(MandateList, { children: mandateHistory
                        .filter(mandate => !mandate.is_active)
                        .map(mandate => (jsx(MandateItem, { mandate: mandate, status: statusFor(mandate), statusPending: statusPending }, mandate.id))) })),
            },
        ], size: 'small' }));
};
const MandateList = styled.ul `
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0;
`;

const PaymentMandate = ({ productName, ledgerId, mandateHistory, }) => {
    var _a, _b;
    // undefined until the fetch settles; empty when the endpoint is unavailable.
    const [mandateStatuses, setMandateStatuses] = useState(undefined);
    const { addNotification, removeNotificationWithDelay } = useNotification();
    useEffect(() => {
        ledgerService
            .mandateStatus(ledgerId)
            .then(setMandateStatuses)
            .catch((error) => {
            var _a, _b;
            // 404 = backend without the endpoint yet; the hasura flags cover it.
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
                removeNotificationWithDelay(addNotification(`Failed to fetch mandate status: ${(_b = error.response) === null || _b === void 0 ? void 0 : _b.status}: ${error.message}`, 'alert'));
            }
            setMandateStatuses([]);
        });
    }, [ledgerId]);
    const paymentMethods = (_b = (_a = global.definitions.products) === null || _a === void 0 ? void 0 : _a.find(product => product.name === productName)) === null || _b === void 0 ? void 0 : _b.purchaseMethods;
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Mandate" }) }), jsxs(Main$3, { children: [jsx(MandateHistory, { mandateHistory: mandateHistory, mandateStatuses: mandateStatuses }), paymentMethods &&
                        paymentMethods.map(paymentMethod => paymentMethod.show && (jsx(ChangePaymentProvider, { paymentProvider: paymentMethod.providerName, paymentProviderUrlParam: paymentMethod.providerUrlParam, ledgerId: ledgerId }, paymentMethod.providerName)))] })] }));
};
const Main$3 = styled.main `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MidTermAdjustment = ({ productName, policyAnswers, createMidTermAdjustmentQuote, }) => {
    var _a, _b, _c, _d, _e;
    const mtaInputFields = (_a = global.definitions.products.find((product) => product.name === productName)) === null || _a === void 0 ? void 0 : _a.mtaInputFields;
    const initialValues = mtaInputFields
        ? mtaInputFields.reduce((a, b) => {
            var _a, _b, _c, _d;
            return (Object.assign(Object.assign({}, a), { [(_a = b === null || b === void 0 ? void 0 : b.mtaName) !== null && _a !== void 0 ? _a : b.name]: (_d = (_c = (_b = policyAnswers.find((answer) => answer.key === b.name)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : b.defaultValue) !== null && _d !== void 0 ? _d : '' }));
        }, {})
        : null;
    const { hidePanel } = useRightPanel();
    const [inputValues, setInputValues] = useState(initialValues);
    const [updatedAnswers, setUpdatedAnswers] = useState({});
    const [effectiveDay, setEffectiveDay] = useState(null);
    const [isPosting, setIsPosting] = useState(false);
    useEffect(() => {
        let newUpdatedAnswers = {};
        if (initialValues && inputValues) {
            Object.keys(initialValues).forEach((key) => {
                if (initialValues[key] !== inputValues[key]) {
                    newUpdatedAnswers = Object.assign(Object.assign({}, newUpdatedAnswers), { [key]: inputValues[key] });
                }
                setUpdatedAnswers(newUpdatedAnswers);
            });
        }
    }, [inputValues]);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInputValues((inputValues) => (Object.assign(Object.assign({}, inputValues), { [name]: value })));
    };
    const midTermAdjustPolicy = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (effectiveDay) {
            event.preventDefault();
            setIsPosting(true);
            yield createMidTermAdjustmentQuote(updatedAnswers, effectiveDay);
            setIsPosting(false);
        }
    });
    return (jsxs(ContentWrapper$1, { children: [mtaInputFields &&
                inputValues &&
                mtaInputFields.map((field) => {
                    var _a;
                    return (jsxs(NamedItem, { children: [jsx("label", { children: field.label }), field.type === 'list' && (jsx("select", Object.assign({ name: field.mtaName || field.name, value: inputValues[field.mtaName || field.name], disabled: isPosting, onChange: handleChange }, { children: (_a = field.options) === null || _a === void 0 ? void 0 : _a.map((option) => (jsx("option", Object.assign({ value: option.value }, { children: option.text }), `${field.name}_${option.text}`))) }))), field.type === 'number' && (jsx("input", { type: 'text', name: field.mtaName || field.name, value: inputValues[field.mtaName || field.name], disabled: isPosting, onChange: handleChange })), field.type === 'text' && (jsx("input", { type: 'text', name: field.mtaName || field.name, value: inputValues[field.mtaName || field.name], disabled: isPosting, onChange: handleChange }))] }, field.mtaName || field.name));
                }), jsxs(NamedItem, { children: [jsx("label", { children: "Effictive date" }), jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', selected: effectiveDay, minDate: new Date((_c = (_b = policyAnswers.find((answer) => answer.key === 'startDate')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : ''), maxDate: new Date((_e = (_d = policyAnswers.find((answer) => answer.key === 'endDate')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : ''), disabled: isPosting, onChange: (date) => setEffectiveDay(date) })] }), jsxs(ButtonsWrapper$3, { children: [jsx(Button$3, Object.assign({ variant: 'secondary', disabled: isPosting, size: 'small', onClick: hidePanel }, { children: "Cancel" })), jsx(Button$3, Object.assign({ disabled: Object.entries(updatedAnswers).length === 0 ||
                            !effectiveDay ||
                            isPosting, size: 'small', onClick: midTermAdjustPolicy }, { children: "Create MTA quote" }))] })] }));
};
const ContentWrapper$1 = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const PolicyAnswers = ({ policyAnswers }) => {
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "All named answers" }) }), jsx(Main$2, { children: policyAnswers.map(answer => (jsxs(NamedItem, { children: [jsx("span", { children: answer.key }), answer.value] }, answer.key))) })] }));
};
const Main$2 = styled.main `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
`;

const DAYS_IN_A_YEAR$1 = 365;
const CoverageTableRow = ({ content }) => {
    return (jsxs(Fragment, { children: [jsx(GridTableCell, { children: content.cover_name }), jsx(GridTableCell, { children: content.period_start }), jsx(GridTableCell, { children: content.period_end }), jsx(RightAlignCell, { children: ((content.day_premium + content.day_tax) *
                    DAYS_IN_A_YEAR$1).toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(HighlightedCell, { children: content.period_premium.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(HighlightedCell, { children: content.period_tax.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(HighlightedCell, { children: (content.period_premium + content.period_tax).toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) })] }));
};
const RightAlignCell = styled(GridTableCell) `
  text-align: right;
`;
const HighlightedCell = styled(RightAlignCell) `
  background-color: #fffaeb;
`;

const DAYS_IN_A_YEAR = 365;
const CoverageTableFooter = ({ totals }) => {
    return (jsxs(Fragment, { children: [jsx(RightAlignTableCellSpan4, { children: ((totals.dayPremium + totals.dayTax) * DAYS_IN_A_YEAR).toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(RightAlignTableCell, { children: totals.premium.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(RightAlignTableCell, { children: totals.tax.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) }), jsx(RightAlignTableCell, { children: totals.grandTotal.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) })] }));
};
const RightAlignTableCell = styled(GridTableCell) `
  text-align: right;
  border-bottom: none;
  border-top: 0.0625rem solid #dedede;
`;
const RightAlignTableCellSpan4 = styled(RightAlignTableCell) `
  grid-column: 1 / span 4;
`;

const PolicyCoveragePeriods = ({ coveragePeriods, policyAnswers, activePeriod, setActivePeriod, }) => {
    // const [activePeriod, setActivePeriod] = useState<number | null>(null);
    const updatedAnswers = [
        ...new Set(policyAnswers
            .filter((answer) => answer.period_index > 1)
            .map((answer) => answer.key)),
    ];
    function createMatrix(policyAnswers) {
        const uniquePeriods = [
            ...new Set(policyAnswers
                .filter((answer) => answer.period_index > 0)
                .map((answer) => answer.period_index)),
        ].sort((a, b) => a - b);
        const uniqueKeys = [...new Set(policyAnswers.map((answer) => answer.key))];
        const matrix = uniquePeriods.map((period) => {
            const row = { period };
            uniqueKeys.forEach((key) => {
                row[key] = null; // Initialize with null or any default value
            });
            return row;
        });
        policyAnswers.forEach((answer) => {
            const rowIndex = uniquePeriods.indexOf(answer.period_index);
            if (rowIndex !== -1) {
                matrix[rowIndex][answer.key] = answer.value;
            }
        });
        return { matrix, matrixPeriods: uniquePeriods };
    }
    const { matrix, matrixPeriods } = createMatrix(policyAnswers.filter((answer) => updatedAnswers.includes(answer.key)));
    const coveragePeriodsDates = coveragePeriods.map((period) => ({
        period_end: period.period_end,
        period_index: period.period_index,
        period_start: period.period_start,
    }));
    const uniquePeriods = coveragePeriodsDates.filter((obj, index) => coveragePeriodsDates.findIndex((item) => item.period_index === obj.period_index) === index);
    const coveregesById = coveragePeriods.reduce((a, b) => {
        if (!a[b.cover_id]) {
            a[b.cover_id] = [];
        }
        a[b.cover_id].push(b);
        return a;
    }, {});
    const aggregatedPeriods = Object.values(coveregesById).reduce((a, b) => {
        const totalPremiumAndTax = b.reduce((a, b) => {
            a.premium += b.period_premium;
            a.tax += b.period_tax;
            return a;
        }, { premium: 0, tax: 0 });
        a.push({
            cover_id: b[0].cover_id,
            cover_name: b[0].cover_name,
            period_end: b[b.length - 1].period_end,
            period_premium: totalPremiumAndTax.premium,
            period_start: b[0].period_start,
            period_tax: totalPremiumAndTax.tax,
            timestamp: b[0].timestamp,
            period_index: b[0].period_index,
            day_premium: b[b.length - 1].day_premium,
            day_tax: b[b.length - 1].day_tax,
        });
        return a;
    }, []);
    const getPartialPeriod = (periodIndex) => coveragePeriods.filter((period) => period.period_index === periodIndex);
    const getPeriodLength = () => uniquePeriods.reduce((a, b) => {
        const startDate = new Date(b.period_start);
        const endDate = new Date(b.period_end);
        const numberOfDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) + 1;
        a += `${numberOfDays}fr `;
        return a;
    }, '');
    const handlePeriodClick = (periodIndex) => () => setActivePeriod(activePeriod === periodIndex ? 0 : periodIndex);
    const tableColumns = [
        {
            header: 'Cover',
            name: 'cover_name',
            isSortable: false,
        },
        {
            header: 'Period start',
            name: 'period_start',
            isSortable: false,
        },
        {
            header: 'Period end',
            name: 'period_end',
            isSortable: false,
        },
        {
            header: 'Annual premium',
            name: 'annual_premium',
            isSortable: false,
            textAlign: 'right',
        },
        {
            header: 'Premium',
            name: 'period_premium',
            isSortable: false,
            textAlign: 'right',
        },
        {
            header: 'Tax',
            name: 'period_tax',
            isSortable: false,
            textAlign: 'right',
        },
        {
            header: 'Total',
            name: 'period_total',
            isSortable: false,
            textAlign: 'right',
        },
    ];
    const getTableData = (periods) => periods.map((period) => ({
        cover_name: period.cover_name,
        day_premium: period.day_premium,
        day_tax: period.day_tax,
        period_start: period.period_start,
        period_end: period.period_end,
        period_premium: period.period_premium,
        period_tax: period.period_tax,
    }));
    const getTotals = (periods) => periods.reduce((a, b) => {
        return {
            dayPremium: a.dayPremium + b.day_premium,
            dayTax: a.dayTax + b.day_tax,
            grandTotal: a.grandTotal + b.period_premium + b.period_tax,
            premium: a.premium + b.period_premium,
            tax: a.tax + b.period_tax,
        };
    }, {
        dayPremium: 0,
        dayTax: 0,
        grandTotal: 0,
        premium: 0,
        tax: 0,
    });
    return (jsxs(Section$1, { children: [jsx("header", { children: jsxs("h3", { children: ["Coverage", uniquePeriods.length > 1 && ' (midterm adjusted)'] }) }), jsxs("main", { children: [uniquePeriods.length > 1 && (jsxs(Fragment, { children: [jsx(PeriodsContainer, Object.assign({ fractions: getPeriodLength() }, { children: uniquePeriods.map((period) => (jsx(Tooltip, Object.assign({ title: `${period.period_start} - ${period.period_end}`, position: 'top' }, { children: jsx(Period, { isActive: activePeriod === 0 || activePeriod === period.period_index, onClick: handlePeriodClick(period.period_index) }) }), period.period_index))) })), jsx(AdjustmentMadeContainer, { children: jsxs("table", { children: [jsx("thead", { children: jsxs("tr", { children: [jsx("th", {}), matrixPeriods.map((period) => (jsxs("th", { children: ["Period ", period] })))] }) }), jsx("tbody", { children: matrix.length > 0 &&
                                                Object.keys(matrix[0])
                                                    .filter((key) => key !== 'period')
                                                    .map((key) => (jsxs("tr", { children: [jsx("td", { children: key }), matrix.map((row) => (jsx("td", { children: row[key] })))] }))) })] }) })] })), jsx(TableWrapper, { children: jsx(GridTable$1, { columns: tableColumns, data: getTableData(activePeriod === 0
                                ? aggregatedPeriods
                                : getPartialPeriod(activePeriod)), Row: CoverageTableRow, Footer: jsx(CoverageTableFooter, { totals: getTotals(activePeriod === 0
                                    ? aggregatedPeriods
                                    : getPartialPeriod(activePeriod)) }) }) })] })] }));
};
const AdjustmentMadeContainer = styled.div `
  background-color: #f5f5f5;
  border-radius: 0.375rem;
  padding: 0.5rem;

  table {
    font-size: 0.75rem;
    
    td,
    th {
      padding: 0.25rem;
      text-align: left;
    }

    td {
      &:first-child {
      font-weight: bold;
    }
  }
`;
const PeriodsContainer = styled.div `
  display: grid;
  height: 1rem;
  margin: 0.5rem 0;
  grid-template-columns: ${({ fractions }) => fractions};
  gap: 0.125rem;
`;
const Period = styled.div `
  width: 100%;
  height: 100%;
  background-color: ${({ isActive }) => (isActive ? '#34ad6c' : '#81d9aa')};
  cursor: pointer;
  border-radius: 0.375rem;

  &:hover {
    background-color: #34ad6c;
    box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.2);
  }
`;
const TableWrapper = styled.div `
  overflow-y: auto;
`;

const PolicyRenewedFrom = ({ renewedPolicyId }) => {
    const { loading, data } = usePolicy(renewedPolicyId);
    return !loading && data.hasura_policy_insurance_holders.length > 0 ? (jsxs(RenewedFrom, { children: ["Policy renewed from", ' ', jsx(PolicyLink, Object.assign({ href: `${POLICIES}/${data.hasura_policy_insurance_holders[0].policy.id}` }, { children: data.hasura_policy_insurance_holders[0].policy.policy_number }))] })) : null;
};
const PolicyLink = styled.a `
  color: #fc8e49;
  font-weight: 00;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const RenewedFrom = styled.p `
  font-weight: 400;
`;

const PolicyViewHeader = ({ policy, exposedActions, hiddenActions, }) => {
    var _a;
    const [viewActions, setViewActions] = useState([]);
    useEffect(() => {
        var _a, _b;
        setViewActions((_b = (_a = global.definitions.views.find((view) => view.name === 'policy')) === null || _a === void 0 ? void 0 : _a.actions) !== null && _b !== void 0 ? _b : []);
    }, []);
    const policyStatus = () => {
        if (policy.status === 'Active' && new Date(policy.end_date) < new Date()) {
            return 'Lapsed';
        }
        if (policy.status === 'Terminated' &&
            new Date(policy.end_date) > new Date()) {
            return 'To be terminated';
        }
        return policy.status;
    };
    const getTagColor = (status) => {
        switch (status) {
            case 'Active':
                return 'green';
            case 'Lapsed':
            case 'To be terminated':
                return 'orange';
            case 'Terminated':
            case 'Undone':
                return 'red';
            default:
                return 'blue';
        }
    };
    return (jsxs("header", { children: [jsxs(H1Wrapper, { children: [jsxs(H1, { children: ["Policy ", policy.policy_number, " "] }), jsx(TagWrapper, { children: jsx(Tag, { color: getTagColor(policyStatus()), text: policyStatus(), size: 'large' }) })] }), policy.previous_policy_id && (jsx(PolicyRenewedFrom, { renewedPolicyId: policy.previous_policy_id })), jsxs(H2, { children: [policy.object_name, ": ", policy.product_name, ", ", policy.cover_level] }), jsxs(ActionsWrapper, { children: [jsxs(SubNavigation, { children: [jsx("a", Object.assign({ href: `${LEDGERS}/${policy.ledger_id}` }, { children: "Payments" })), jsxs("a", Object.assign({ href: `${process.env.REACT_APP_PUBLIC_URL}p/${policy.id}`, target: '_blank', rel: 'noreferrer' }, { children: ["Policy letter", ' ', jsx("span", { children: jsx(Icon, { iconName: 'faUpRightFromSquare' }) })] })), ((_a = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === 'optAssistance')) === null || _a === void 0 ? void 0 : _a.value) === 'true' &&
                                viewActions &&
                                viewActions.find((action) => action.name === 'roadsideAssistanceCertificateLink' &&
                                    action.show) && (jsxs("a", Object.assign({ href: `${process.env.REACT_APP_PUBLIC_URL}rac/${policy.id}`, target: '_blank', rel: 'noreferrer' }, { children: ["Roadside assistance certificate", ' ', jsx("span", { children: jsx(Icon, { iconName: 'faUpRightFromSquare' }) })] })))] }), jsxs(ActionList, { children: [Object.values(exposedActions)
                                .filter((action) => action.isActionAllowed)
                                .map((action) => (jsx("li", { children: jsx(Button$3, Object.assign({ theme: action.button.color, size: 'medium', onClick: action.action }, { children: action.button.text })) }, action.name))), Object.values(hiddenActions).filter((action) => action.isActionAllowed).length > 0 && (jsx(ContextMenu, { options: Object.values(hiddenActions)
                                    .filter((action) => action.isActionAllowed)
                                    .map((action) => ({
                                    action: action.action,
                                    text: action.button.text,
                                    color: action.button.color,
                                })) }))] })] })] }));
};
const H1 = styled.h1 `
  margin-bottom: 0;
`;
const H2 = styled.h2 `
  margin-bottom: 1rem;
  color: #7b7d8c;
`;
const ActionList = styled.ul `
  list-style: none;
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 0;
`;
const SubNavigation = styled.nav `
  display: flex;
  gap: 0.5rem;

  a {
    font-size: 1rem;
    color: #fc8e49;

    span {
      font-size: 0.8rem;
    }
  }
`;
const ActionsWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const H1Wrapper = styled.div `
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
const TagWrapper = styled.div `
  display: flex;
`;

const RenewPolicy = ({ policy, createRenewalQuote }) => {
    var _a, _b, _c, _d, _e;
    const renewPolicyIntoProductField = (_a = global.definitions.products.find((product) => product.name === policy.product_name)) === null || _a === void 0 ? void 0 : _a.renewPolicyIntoProduct;
    const { hidePanel } = useRightPanel();
    const [renewPolicyIntoProduct, setRenewPolicyIntoProduct] = useState(renewPolicyIntoProductField &&
        renewPolicyIntoProductField.length > 0 &&
        !renewPolicyIntoProductField.includes(policy.product_name)
        ? renewPolicyIntoProductField[0]
        : policy.product_name);
    const handleRenewPolicyIntoChange = (event) => {
        setRenewPolicyIntoProduct(event.target.value);
    };
    const inputFields = (_c = (_b = global.definitions.products.find((product) => product.name === policy.product_name)) === null || _b === void 0 ? void 0 : _b.inputFields) !== null && _c !== void 0 ? _c : [];
    // const additionalRenewalInputFields =
    //   global.definitions.products.find(
    //     (product) => product.name === policy.product_name
    //   )?.additionalRenewalInputFields ?? [];
    const getNewStartDate = (deriveFromDate) => {
        if (!deriveFromDate)
            return null;
        const d = new Date(deriveFromDate);
        d.setDate(d.getDate() + 1);
        return d;
    };
    const inputValuesFromPolicy = [
        ...inputFields,
        {
            label: 'Floor',
            type: 'text',
            name: 'newFloor',
            defaultValue: '',
            visible: true,
        },
        {
            label: 'Ceiling',
            type: 'text',
            name: 'newCeiling',
            defaultValue: '',
            visible: true,
        },
    ].reduce((a, b) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const name = (_a = b === null || b === void 0 ? void 0 : b.renewalName) !== null && _a !== void 0 ? _a : b.name;
        switch (b.type) {
            case 'date':
                return Object.assign(Object.assign({}, a), { [name]: {
                        tag: 'date',
                        value: b.name === 'endDate' || b.name === 'startDate'
                            ? b.name === 'endDate'
                                ? policy.end_date
                                : policy.start_date
                            : (_c = (_b = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === b.name)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : null,
                        name,
                    } });
            case 'email':
                return Object.assign(Object.assign({}, a), { [name]: {
                        tag: 'email',
                        value: (_f = (_e = (_d = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === b.name)) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : b.defaultValue) !== null && _f !== void 0 ? _f : '',
                        name,
                    } });
            case 'list':
                return Object.assign(Object.assign({}, a), { [name]: {
                        tag: 'list',
                        value: (_j = (_h = (_g = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === b.name)) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : b.defaultValue) !== null && _j !== void 0 ? _j : '',
                        name,
                        options: (_k = b.options) !== null && _k !== void 0 ? _k : [],
                    } });
            case 'number':
                return Object.assign(Object.assign({}, a), { [name]: {
                        tag: 'number',
                        value: (_o = (_m = (_l = policy.hasura_policy_answers
                            .find((answer) => answer.period_index === 0 && answer.key === b.name)) === null || _l === void 0 ? void 0 : _l.value.toString()) !== null && _m !== void 0 ? _m : b.defaultValue.toString()) !== null && _o !== void 0 ? _o : '',
                        name,
                    } });
            case 'text':
                return Object.assign(Object.assign({}, a), { [name]: {
                        tag: 'text',
                        value: (_r = (_q = (_p = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === b.name)) === null || _p === void 0 ? void 0 : _p.value) !== null && _q !== void 0 ? _q : b.defaultValue) !== null && _r !== void 0 ? _r : '',
                        name,
                    } });
        }
        return a;
    }, {});
    inputValuesFromPolicy.startDate.value = getNewStartDate((_e = (_d = policy.hasura_policy_answers.find((answer) => answer.period_index === 0 && answer.key === 'endDate')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : null);
    inputValuesFromPolicy.startDate.value = getNewStartDate(policy.end_date);
    inputFields
        .filter((inputField) => inputField.defaultValue === 'dateAdd')
        .forEach((inputField) => {
        var _a;
        const name = (_a = inputField.renewalName) !== null && _a !== void 0 ? _a : inputField.name;
        const d = inputField.defaultValueOriginatesFrom
            ? inputValuesFromPolicy[inputField.defaultValueOriginatesFrom].value
            : new Date();
        if (d instanceof Date) {
            const year = d.getFullYear();
            const month = d.getMonth();
            const day = d.getDate();
            const defaultDateValue = new Date(year + inputField.defaultValueArguments[0], month + inputField.defaultValueArguments[1], day + inputField.defaultValueArguments[2]);
            inputValuesFromPolicy[name] = {
                tag: 'date',
                value: defaultDateValue,
                name,
            };
        }
    });
    const [inputValues, setInputValues] = useState(inputValuesFromPolicy);
    const [isPosting, setIsPosting] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInputValues((state) => (Object.assign(Object.assign({}, state), { [name]: Object.assign(Object.assign({}, state[name]), { value }) })));
    };
    const handleDateChange = (date, fieldName) => {
        setInputValues((state) => (Object.assign(Object.assign({}, state), { [fieldName]: Object.assign(Object.assign({}, state[fieldName]), { value: date }) })));
        inputFields
            .filter((field) => field.defaultValueOriginatesFrom === fieldName)
            .forEach((field) => {
            if (field.defaultValue === 'dateAdd') {
                const d = field.defaultValueOriginatesFrom ? date : new Date();
                const year = d.getFullYear();
                const month = d.getMonth();
                const day = d.getDate();
                const defaultDateValue = new Date(year + field.defaultValueArguments[0], month + field.defaultValueArguments[1], day + field.defaultValueArguments[2]);
                setInputValues((inputValues) => (Object.assign(Object.assign({}, inputValues), { [field.name]: defaultDateValue })));
            }
        });
    };
    const handleRenewPolicyClick = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setIsPosting(true);
        yield createRenewalQuote(inputValues, renewPolicyIntoProduct !== policy.product_name
            ? renewPolicyIntoProduct
            : null);
        setIsPosting(false);
    });
    const getInput = (inputValue) => {
        switch (inputValue.tag) {
            case 'date':
                return (jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', name: inputValue.name, selected: inputValue.value === null ? null : new Date(inputValue.value), disabled: isPosting, onChange: (date) => handleDateChange(date, inputValue.renewalName || inputValue.name) }));
            case 'email':
                return (jsx("input", { name: inputValue.name, value: inputValue.value, type: 'email', disabled: isPosting, onChange: handleChange }));
            case 'list':
                return (jsx("select", Object.assign({ name: inputValue.name, value: inputValue.value, disabled: isPosting, onChange: handleChange }, { children: inputValue.options.map((option) => (jsx("option", Object.assign({ value: option.value }, { children: option.text }), option.value))) })));
            case 'number':
            case 'text':
                return (jsx("input", { name: inputValue.name, value: inputValue.value, type: 'text', disabled: isPosting, onChange: handleChange }));
        }
    };
    return (jsx("form", { children: jsxs(ContentWrapper, { children: [renewPolicyIntoProductField &&
                    renewPolicyIntoProductField.length > 0 && (jsxs(NamedItem, { children: [jsx("label", { children: "Renew policy into" }), jsx("select", Object.assign({ value: renewPolicyIntoProduct, onChange: handleRenewPolicyIntoChange }, { children: renewPolicyIntoProductField.map((field) => (jsx("option", Object.assign({ value: field }, { children: field }), field))) }))] })), [
                    {
                        label: 'Floor',
                        type: 'text',
                        name: 'newFloor',
                        defaultValue: '',
                        visible: true,
                    },
                    {
                        label: 'Ceiling',
                        type: 'text',
                        name: 'newCeiling',
                        defaultValue: '',
                        visible: true,
                    },
                    ...inputFields,
                ].map((field) => field.visible &&
                    !field.hideOnRenewal && (jsxs(NamedItem, { children: [jsx("label", { children: field.label }), getInput(inputValues[field.renewalName || field.name])] }, field.renewalName || field.name))), jsxs(ButtonsWrapper$3, { children: [jsx(Button$3, Object.assign({ variant: 'secondary', disabled: isPosting, size: 'small', onClick: hidePanel }, { children: "Cancel" })), jsx(Button$3, Object.assign({ disabled: isPosting, size: 'small', onClick: handleRenewPolicyClick }, { children: "Create renewal quote" }))] })] }) }));
};
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const TerminationDatePicker = ({ otherReasons, setTerminationOptions, }) => {
    const { clearChildNodes } = useOverlay();
    const [pickedDate, setPickedDate] = useState(new Date());
    const [reason, setReason] = useState('');
    const handleDateChange = (date) => setPickedDate(date);
    const handleReasonChange = (event) => setReason(event.target.value);
    const handleCancelClick = () => clearChildNodes();
    const handleConfirmClick = () => {
        const terminationReason = reason === ''
            ? null
            : reason === 'AcceptedRequote' ||
                reason === 'ChangeOfOwnership' ||
                reason === 'ChangeOfInsurer' ||
                reason === 'CertificateIdle' ||
                reason === 'UnpaidPremium'
                ? { tag: reason }
                : { tag: 'TerminationOther', contents: reason };
        clearChildNodes();
        setTerminationOptions({
            date: pickedDate,
            reason: terminationReason,
        });
    };
    return (jsxs(DatePickerSection, { children: [jsx("header", { children: jsx("h3", { children: "Terminate policy" }) }), jsxs("main", { children: [jsxs(NamedItem, { children: [jsx("label", { children: "Reason for termination" }), jsxs("select", Object.assign({ value: reason, onChange: handleReasonChange }, { children: [jsx("option", Object.assign({ value: '' }, { children: "-" })), jsx("option", Object.assign({ value: 'ChangeOfOwnership' }, { children: "Change of ownership" })), jsx("option", Object.assign({ value: 'ChangeOfInsurer' }, { children: "Change of insurer" })), jsx("option", Object.assign({ value: 'UnpaidPremium' }, { children: "Unpaid premium" })), jsx("option", Object.assign({ value: 'AcceptedRequote' }, { children: "Accepted requote" })), jsx("option", Object.assign({ value: 'CertificateIdle' }, { children: "Out of traffic" })), otherReasons.map(reason => (jsx("option", Object.assign({ value: reason.value }, { children: reason.text }), reason.value)))] }))] }), jsxs(NamedItem, { children: [jsx("label", { children: "Date of termination" }), jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', selected: pickedDate, onChange: date => handleDateChange(date) })] }), jsxs(ButtonsWrapper$3, { children: [jsx(Button$3, Object.assign({ variant: 'secondary', size: 'small', onClick: handleCancelClick }, { children: "Cancel" })), jsx(Button$3, Object.assign({ size: 'small', onClick: handleConfirmClick }, { children: "Termination policy" }))] })] })] }));
};
const DatePickerSection = styled(Section$1) `
  max-width: 90rem;
  max-height: 100%;
  border: 0.0625rem solid #dedede;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);

  main {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const TerminateVtrCertificate = ({ registrationNumber, policyHolder, certificateStartDate, terminateVtrCertificate, }) => {
    const { setChildNodes } = useOverlay();
    const [state, setState] = useState({
        anamorsak: 'Bolagsbyte',
        avtalsdatum: null,
        begdatum: new Date(certificateStartDate),
        forstagare: policyHolder,
        regnr: registrationNumber,
        upphordatum: null,
    });
    useEffect(() => {
        setState(state => (Object.assign(Object.assign({}, state), { avtalsdatum: state.upphordatum })));
    }, [state.upphordatum]);
    useEffect(() => {
        if (state.anamorsak === 'RättelseFelaktigtUtfärdat') {
            setState(state => (Object.assign(Object.assign({}, state), { avtalsdatum: state.begdatum, upphordatum: state.begdatum })));
        }
        else if (state.anamorsak === 'BorttagVilande') {
            setState(state => (Object.assign(Object.assign({}, state), { avtalsdatum: null, begdatum: null, upphordatum: null })));
        }
    }, [certificateStartDate, state.anamorsak]);
    useEffect(() => {
        state.anamorsak !== 'BorttagVilande' &&
            setState(state => (Object.assign(Object.assign({}, state), { begdatum: new Date(certificateStartDate) })));
    }, [certificateStartDate, state.anamorsak]);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setState(state => (Object.assign(Object.assign({}, state), { [name]: value })));
    };
    const handleDateChange = (name) => (date) => setState(state => (Object.assign(Object.assign({}, state), { [name]: date })));
    const handleCancelClick = () => setChildNodes(null);
    const handleRegisterClick = () => {
        const body = Object.assign(Object.assign({}, state), { avtalsdatum: state.avtalsdatum ? formatDate(state.avtalsdatum) : null, begdatum: state.begdatum ? formatDate(state.begdatum) : null, upphordatum: state.upphordatum ? formatDate(state.upphordatum) : null });
        terminateVtrCertificate(body);
    };
    return (jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Terminate VTR certificate" }) }), jsxs(Main$1, { children: [jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'regnr' }, { children: "Regnr" })), jsx("input", { id: 'regnr', name: 'regnr', value: state.regnr, onChange: handleChange })] }), jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'forstagare' }, { children: "F\u00F6rs\u00E4kringstagarens org/persnr" })), jsx("input", { id: 'forstagare', name: 'forstagare', value: state.forstagare, onChange: handleChange })] }), jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'anamorsak' }, { children: "Avanm\u00E4lansorsak" })), jsxs("select", Object.assign({ id: 'anamorsak', name: 'anamorsak', value: state.anamorsak, onChange: handleChange }, { children: [jsx("option", Object.assign({ value: 'ObetaldPremie' }, { children: "Obetald premie" })), jsx("option", Object.assign({ value: 'Bolagsbyte' }, { children: "Bolagsbyte" })), jsx("option", Object.assign({ value: 'R\u00E4ttelseFelaktigtUtf\u00E4rdat' }, { children: "R\u00E4ttelse felaktigt utf\u00E4rdat" })), jsx("option", Object.assign({ value: 'BorttagVilande' }, { children: "Borttag vilande" })), jsx("option", Object.assign({ value: 'Upph\u00F6rdKorttid' }, { children: "Upph\u00F6rd, korttid" }))] }))] }), state.anamorsak !== 'BorttagVilande' && (jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'begdatum' }, { children: "Begynnelsedatum" })), jsx(DatePicker, { readOnly: state.anamorsak !== 'RättelseFelaktigtUtfärdat', className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', selected: state.begdatum, onChange: handleDateChange('begdatum') })] })), state.anamorsak !== 'RättelseFelaktigtUtfärdat' &&
                        state.anamorsak !== 'BorttagVilande' && (jsxs(Fragment, { children: [jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'upphordatum' }, { children: "Upph\u00F6randedatum" })), jsx(DatePicker, { className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', selected: state.upphordatum, onChange: handleDateChange('upphordatum') })] }), jsxs(NamedItem, { children: [jsx("label", Object.assign({ htmlFor: 'avtalsdatum' }, { children: "Avtalsdatum" })), jsx(DatePicker, { readOnly: true, className: 'default', locale: 'sv', dateFormat: 'yyyy-MM-dd', selected: state.avtalsdatum, onChange: handleDateChange('avtalsdatum') })] })] })), jsxs(ButtonsWrapper$3, { children: [jsx(Button$3, Object.assign({ variant: 'secondary', size: 'small', onClick: handleCancelClick }, { children: "Cancel" })), jsx(Button$3, Object.assign({ size: 'small', onClick: handleRegisterClick }, { children: "Registrera" }))] })] })] }));
};
const Main$1 = styled.main `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const PolicyView = ({ match }) => {
    var _a, _b, _c, _d, _e;
    const { setChildNodes } = useOverlay();
    const { setAlert } = useAlert();
    const { addNotification, removeNotificationWithDelay } = useNotification();
    const { hidePanel, setContent, showPanel } = useRightPanel();
    const [changeLog, setChangeLog] = useState(null);
    const [termination, setTermination] = useState({
        date: null,
        reason: null,
    });
    const policyId = match.params.policyId;
    const { loading, data, refetch } = usePolicy(policyId);
    const [answerPeriodIndex, setAnswerPeriodIndex] = useState(0);
    const history = useHistory();
    useEffect(() => {
        const getChangeLog = () => __awaiter(void 0, void 0, void 0, function* () { return setChangeLog(yield policyService.log(policyId)); });
        getChangeLog();
        return () => hidePanel();
    }, []);
    useEffect(() => {
        if (termination.date) {
            const doTerminate = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c;
                try {
                    yield policyService.terminate(policy.id, formatDate((_a = termination.date) !== null && _a !== void 0 ? _a : ''), termination.reason);
                    setAlert({
                        body: {
                            header: 'Policy terminated',
                            message: `Policy ${policy.policy_number} was successfully terminated.`,
                        },
                        buttons: {
                            Ok: {
                                type: 'primary',
                                text: 'OK',
                                action: function () {
                                    setAlert(null);
                                    refetch();
                                },
                            },
                        },
                        type: 'success',
                    });
                }
                catch (error) {
                    setAlert({
                        body: {
                            header: 'Something went wrong!',
                            message: `Could not terminate policy ${policy.policy_number}: ${(_b = error.response) === null || _b === void 0 ? void 0 : _b.status}: ${(_c = error.response) === null || _c === void 0 ? void 0 : _c.data.message}`,
                        },
                        buttons: {
                            Ok: {
                                type: 'primary',
                                text: 'OK',
                                action() {
                                    setAlert(null);
                                },
                            },
                        },
                        type: 'warning',
                    });
                }
            });
            setAlert({
                body: {
                    header: 'Terminate policy?',
                    message: `Do you want to terminate the policy ${policy.policy_number} and set the termination to ${formatDate(termination.date)}?`,
                },
                buttons: {
                    Cancel: {
                        type: 'secondary',
                        text: 'Cancel',
                        action() {
                            setAlert(null);
                            setTermination({ date: null, reason: null });
                        },
                    },
                    Ok: {
                        type: 'primary',
                        text: 'Terminate policy',
                        action() {
                            doTerminate();
                        },
                    },
                },
                type: 'question',
            });
        }
    }, [termination]);
    if (loading)
        return jsx(Loading, {});
    const productName = data.hasura_policy_insurance_holders[0].policy.product_name;
    const productDefinition = global.definitions.products.find((product) => product.name === productName);
    const { company_record, person_holder, policy } = data.hasura_policy_insurance_holders[0];
    const showRenewPolicy = () => !policy.is_marked_for_termination &&
        dateDiff(new Date(policy.end_date), new Date()) >= -75;
    const createMidTermAdjustmentQuote = (updatedAnswers, effectiveDay) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g;
        try {
            const quote = yield policyService.mta(policy.id, updatedAnswers, formatDate(effectiveDay));
            removeNotificationWithDelay(addNotification('Quote for Mid term adjustment was sucessfully created.', 'success'));
            setTimeout(() => history.push(`${QUOTES}/${quote.contents.quoteId}?mtaForPolicy=${policy.id}`), 500);
        }
        catch (error) {
            const axiosError = error;
            removeNotificationWithDelay(addNotification(`Could not create quote for Mid term adjustment: ${(_f = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _f === void 0 ? void 0 : _f.status}: ${(_g = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _g === void 0 ? void 0 : _g.data.message}`, 'alert'));
        }
    });
    const showMtaPanel = () => {
        setContent('Mid term adjustment', jsx(MidTermAdjustment, { productName: policy.product_name, policyAnswers: policy.hasura_policy_answers.filter((answer) => answer.period_index === 0), createMidTermAdjustmentQuote: createMidTermAdjustmentQuote }));
        showPanel();
    };
    const createRenewalQuote = (inputValues, renewPolicyIntoProduct) => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j, _k, _l;
        try {
            const body = Object.values(inputValues).reduce((a, b) => {
                const value = (() => {
                    switch (b.tag) {
                        case 'date':
                            return formatDate(b.value);
                        case 'number':
                            return b.value.toString();
                        default:
                            return b.value;
                    }
                })();
                return Object.assign(Object.assign({}, a), { [b.name]: value });
            }, {});
            const queryParams = {};
            Object.values(inputValues)
                .filter((field) => {
                const name = field.renewalName || field.name;
                return (name === 'customPof' ||
                    name === 'endDate' ||
                    name === 'newCeiling' ||
                    name === 'newFloor' ||
                    name === 'product' ||
                    name === 'productVersion');
            })
                .forEach((field) => {
                const name = field.renewalName || field.name;
                if (name === 'customPof' ||
                    name === 'endDate' ||
                    name === 'newCeiling' ||
                    name === 'newFloor' ||
                    name === 'product' ||
                    name === 'productVersion') {
                    if (body[name]) {
                        queryParams[name] = body[name];
                    }
                    delete body[name];
                }
            });
            if (renewPolicyIntoProduct) {
                queryParams.product = renewPolicyIntoProduct;
            }
            const quote = yield policyService.renew(policy.id, body, true, queryParams);
            removeNotificationWithDelay(addNotification('Quote for renewal was successfully created.', 'success'));
            setTimeout(() => history.push(`${QUOTES}/${quote.quoteId}`), 500);
        }
        catch (error) {
            const axiosError = error;
            removeNotificationWithDelay(addNotification(`Could not create quote for renewal: ${(_h = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _h === void 0 ? void 0 : _h.data.status}: ${(_k = (_j = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _j === void 0 ? void 0 : _j.data.message) !== null && _k !== void 0 ? _k : (_l = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _l === void 0 ? void 0 : _l.data.error}`, 'alert'));
        }
    });
    const showRenewPanel = () => {
        setContent('Renew policy', jsx(RenewPolicy, { policy: policy, createRenewalQuote: createRenewalQuote }));
        showPanel();
    };
    // const undoTerminaion = () => {
    //   const doUndoTermination = async () => {
    //     try {
    //       await policyService.undoTermination(policy.id);
    //       setAlert({
    //         body: {
    //           header: 'Policy termination undone',
    //           message: `The termination of policy ${policy.policy_number} was successfully undone.`,
    //         },
    //         buttons: {
    //           Ok: {
    //             type: 'primary',
    //             text: 'OK',
    //             action() {
    //               setAlert(null);
    //               refetch();
    //             },
    //           },
    //         },
    //         type: 'success',
    //       });
    //     } catch (error) {
    //       const axiosError = error as AxiosError;
    //       setAlert({
    //         body: {
    //           header: 'Something went wrong',
    //           message: `Could not undo termination of policy ${policy.policy_number}: ${axiosError.response?.status}: ${axiosError.response?.data.message}`,
    //         },
    //         buttons: {
    //           Ok: {
    //             type: 'primary',
    //             text: 'OK',
    //             action() {
    //               setAlert(null);
    //             },
    //           },
    //         },
    //         type: 'warning',
    //       });
    //     }
    //   };
    //   setAlert({
    //     body: {
    //       header: 'Undo termination of policy?',
    //       message: `Do you want to undo the termination of policy ${policy.policy_number}?`,
    //     },
    //     buttons: {
    //       Cancel: {
    //         type: 'secondary',
    //         text: 'Cancel',
    //         action() {
    //           setAlert(null);
    //         },
    //       },
    //       Ok: {
    //         type: 'primary',
    //         text: 'Undo termination',
    //         action() {
    //           doUndoTermination();
    //         },
    //       },
    //     },
    //     type: 'question',
    //   });
    // };
    const undoMarkedForTermination = () => {
        const doUndoMarkedForTermination = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                yield policyService.undoMarkForTermination(policy.id);
                setAlert({
                    body: {
                        header: 'Policy marked for termination undone',
                        message: `The marked for termination of policy ${policy.policy_number} was successfully undone.`,
                    },
                    buttons: {
                        Ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                setAlert(null);
                                refetch();
                            },
                        },
                    },
                    type: 'success',
                });
            }
            catch (error) {
                const axiosError = error;
                setAlert({
                    body: {
                        header: 'Something went wrong',
                        message: `Could not undo marked for termination of policy ${policy.policy_number}: ${(_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status}: ${(_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data.message}`,
                    },
                    buttons: {
                        Ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                setAlert(null);
                            },
                        },
                    },
                    type: 'warning',
                });
            }
        });
        setAlert({
            body: {
                header: 'Undo marked for termination of policy?',
                message: `Do you want to undo the marked of termination of policy ${policy.policy_number}?`,
            },
            buttons: {
                Cancel: {
                    type: 'secondary',
                    text: 'Cancel',
                    action() {
                        setAlert(null);
                    },
                },
                Ok: {
                    type: 'primary',
                    text: 'Undo marked for termination',
                    action() {
                        doUndoMarkedForTermination();
                    },
                },
            },
            type: 'question',
        });
    };
    const undo = () => {
        const doUndo = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                yield policyService.undo(policy.id);
                setAlert({
                    body: {
                        header: 'Policy undone',
                        message: `The policy ${policy.policy_number} was successfully undone.`,
                    },
                    buttons: {
                        Ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                setAlert(null);
                                refetch();
                            },
                        },
                    },
                    type: 'success',
                });
            }
            catch (error) {
                const axiosError = error;
                setAlert({
                    body: {
                        header: 'Something went wrong',
                        message: `Could not undo policy ${policy.policy_number}: ${(_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status}: ${(_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data.message}`,
                    },
                    buttons: {
                        Ok: {
                            type: 'primary',
                            text: 'OK',
                            action() {
                                setAlert(null);
                            },
                        },
                    },
                    type: 'warning',
                });
            }
        });
        setAlert({
            body: {
                header: 'Undo policy?',
                message: `Do you want to undo the policy ${policy.policy_number}. The action cannot be undone.`,
            },
            buttons: {
                Cancel: {
                    type: 'secondary',
                    text: 'Cancel',
                    action() {
                        setAlert(null);
                    },
                },
                Ok: {
                    type: 'primary',
                    text: 'Undo policy',
                    action() {
                        doUndo();
                    },
                },
            },
            type: 'question',
        });
    };
    const terminate = () => {
        var _a;
        return setChildNodes(jsx(TerminationDatePicker, { otherReasons: (_a = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.terminationReasons) !== null && _a !== void 0 ? _a : [], setTerminationOptions: setTermination }));
    };
    const terminateVtrCertificate = (certificateStartDate, callback) => {
        var _a, _b;
        const terminateVtrCertificate = (body) => __awaiter(void 0, void 0, void 0, function* () {
            const doTermination = () => __awaiter(void 0, void 0, void 0, function* () {
                var _c;
                try {
                    yield policyService.terminateVtrCertificate(body);
                    refetch();
                    setChildNodes(null);
                    setAlert({
                        body: {
                            header: 'VTR certificate terminated',
                            message: `The VTR certificate for registration number ${body.regnr} has been terminated.`,
                        },
                        buttons: {
                            ok: {
                                type: 'primary',
                                text: 'OK',
                                action() {
                                    callback();
                                    setAlert(null);
                                },
                            },
                        },
                        type: 'success',
                    });
                }
                catch (error) {
                    const axiosError = error;
                    setAlert({
                        body: {
                            header: 'Something went wrong',
                            message: `Could not terminate the VTR certificate for registration number ${body.regnr}: ${(_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data.errorMessage}`,
                        },
                        buttons: {
                            ok: {
                                type: 'primary',
                                text: 'OK',
                                action() {
                                    setAlert(null);
                                },
                            },
                        },
                        type: 'warning',
                    });
                }
            });
            setAlert({
                body: {
                    header: 'Terminate VTR certificate',
                    message: `Do you want to terminate the VTR certificate for registration number ${body.regnr}?`,
                },
                buttons: {
                    cancel: {
                        type: 'secondary',
                        text: 'Cancel',
                        action() {
                            setAlert(null);
                        },
                    },
                    ok: {
                        type: 'primary',
                        text: 'Terminate VTR certificate',
                        action() {
                            doTermination();
                        },
                    },
                },
                type: 'question',
            });
        });
        setChildNodes(jsx(TerminateVtrCertificate, { registrationNumber: policy.object_name, policyHolder: (_b = (_a = person_holder === null || person_holder === void 0 ? void 0 : person_holder.social_security) !== null && _a !== void 0 ? _a : company_record === null || company_record === void 0 ? void 0 : company_record.reference) !== null && _b !== void 0 ? _b : '', certificateStartDate: certificateStartDate, terminateVtrCertificate: terminateVtrCertificate }));
    };
    const exposedActions = {
        renew: {
            button: {
                text: (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faRotateRight' }), " Renew policy"] })),
                color: 'green',
            },
            action: showRenewPanel,
            isActionAllowed: showRenewPolicy(),
            name: 'renew',
        },
        mta: {
            button: {
                text: (jsxs(Fragment, { children: [jsx(Icon, { iconName: 'faSliders' }), " Make Mid term adjustment"] })),
                color: 'blue',
            },
            action: showMtaPanel,
            isActionAllowed: policy.status === 'Active',
            name: 'mta',
        },
    };
    const hiddenActions = {
        undoMarkedForTermination: {
            button: {
                text: 'Undo Marked for termination',
                color: 'blue',
            },
            action: undoMarkedForTermination,
            isActionAllowed: policy.is_marked_for_termination === true,
            name: 'undoMarkedForTermination',
        },
        terminate: {
            button: {
                text: 'Terminate policy',
                color: 'red',
            },
            action: terminate,
            isActionAllowed: policy.status === 'Active',
            name: 'terminate',
        },
        undo: {
            button: {
                text: 'Undo policy',
                color: 'red',
            },
            action: undo,
            isActionAllowed: policy.status === 'Active',
            name: 'undo',
        },
        clone: {
            button: {
                text: 'Create new quote from policy',
                color: 'blue',
            },
            action() {
                history.push(`${CREATE_QUOTE_SELECT_PRODUCT}/${policy.product_name}?policyId=${policy.id}`);
            },
            isActionAllowed: true,
            name: 'clone',
        },
    };
    return (jsxs(ContentContainer, { children: [jsx(PolicyViewHeader, { policy: policy, exposedActions: exposedActions, hiddenActions: hiddenActions }), jsxs(PolicyContainer, { children: [jsx(CustomerInformationWrapper, { children: jsx(CustomerInformation, { company: company_record, person: person_holder, refetch: refetch }) }), jsxs(MainWrapper, { children: [jsx(CoverageContainer, { children: jsx(PolicyCoveragePeriods, { coveragePeriods: policy.hasura_policy_coverage_periods, policyAnswers: policy.hasura_policy_answers, activePeriod: answerPeriodIndex, setActivePeriod: setAnswerPeriodIndex }) }), jsx(DefinedPolicyAnswers, { defaultValues: {
                                    cover_level: policy.cover_level,
                                    created: policy.hasura_quote.created,
                                    end_date: policy.end_date,
                                    start_date: policy.start_date,
                                }, productSpecificFields: (_a = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.outputFields.find((fields) => fields.group === 'policy')) === null || _a === void 0 ? void 0 : _a.fields, source: policy.hasura_policy_answers.filter((answer) => answer.period_index === answerPeriodIndex) }), jsx(DefinedObjectAnswers, { productSpecificFields: (_b = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.outputFields.find((fields) => fields.group === 'object')) === null || _b === void 0 ? void 0 : _b.fields, source: policy.hasura_policy_answers.filter((answer) => answer.period_index === answerPeriodIndex) })] }), jsxs(AsideWrapper, { children: [jsxs(Section$1, { children: [jsx("header", { children: jsx("h3", { children: "Tasks" }) }), jsx("main", { children: jsx(Tasks, { associatedEntity: {
                                                tag: 'AssociatedPolicy',
                                                contents: policy.id,
                                            } }) })] }), jsx(Notes, { associatedEntity: { tag: 'AssociatedPolicy', contents: policy.id }, caption: 'Notes on policy' }), jsx(Notes, { associatedEntity: person_holder
                                    ? {
                                        tag: 'AssociatedPerson',
                                        contents: person_holder.id,
                                    }
                                    : { tag: 'AssociatedCompany', contents: company_record.id }, caption: 'Notes on customer' }), ((_d = (_c = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.purchaseMethods) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 && (jsx(PaymentMandate, { productName: productName, ledgerId: policy.ledger_id, mandateHistory: policy.hasura_ledger.hasura_ledger_mandates })), (productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.showVtrCertificates) && (jsx(VtrCertificates, { registrationNumber: policy.object_name, insuranceHolder: data.hasura_policy_insurance_holders[0].person_holder
                                    ? data.hasura_policy_insurance_holders[0].person_holder
                                        .social_security
                                    : data.hasura_policy_insurance_holders[0].company_record
                                        .reference, vtrPartnerName: (_e = productDefinition === null || productDefinition === void 0 ? void 0 : productDefinition.vtrPartnerName) !== null && _e !== void 0 ? _e : null, onTerminateClick: terminateVtrCertificate })), changeLog && jsx(ChangeLog, { changeLog: changeLog })] }), jsx(PolicyAnswersWrapper, { children: jsx(PolicyAnswers, { policyAnswers: policy.hasura_policy_answers.filter((answer) => answer.period_index === answerPeriodIndex) }) })] })] }));
};
const CoverageContainer = styled.div `
  grid-column: 1 / span 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const PolicyAnswersWrapper = styled.div `
  grid-column: 1 / span 2;
`;
const PolicyContainer = styled.div `
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.5rem;
`;
const CustomerInformationWrapper = styled.div `
  grid-column: 1 / span 2;
`;
const MainWrapper = styled.main `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  height: fit-content;
`;
const AsideWrapper = styled.aside `
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;

var _templateObject$5;
var GET_UPCOMING_REFUNDS = gql(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  query upcoming_refunds {\n    hasura_ledger_payments(\n      where: {\n        hasura_ledger: { status: { _eq: \"Open\" } }\n        status: { _eq: \"UpcomingRefundDueToAdjustment\" }\n      }\n      limit: 1000\n    ) {\n      hasura_ledger {\n        hasura_policies {\n          hasura_person {\n            first_name\n            last_name\n          }\n          id\n          object_name\n          policy_number\n        }\n      }\n      index\n      ledger_id\n      total\n    }\n  }\n"])));

var useUpcomingRefunds = function useUpcomingRefunds() {
  return useQuery(GET_UPCOMING_REFUNDS);
};

const TableRow = ({ content, onLedgerClick, onPolicyClick }) => {
    const handleLedgerClick = () => onLedgerClick && onLedgerClick(content.ledger_id);
    const handlePolicyClick = () => onPolicyClick && onPolicyClick(content.policy_id);
    return (jsxs(Fragment, { children: [jsx(HideOverflow, Object.assign({ isLink: true, title: content.ledger_id, onClick: handleLedgerClick }, { children: content.ledger_id })), jsx(TableCell, Object.assign({ isLink: true, onClick: handlePolicyClick }, { children: content.policy_number })), jsx(GridTableCell, { children: content.object_name }), jsx(HideOverflow, Object.assign({ title: content.customer_name }, { children: content.customer_name })), jsx(GridTableCell, { children: content.index }), jsx(RightAlignContent, { children: content.total.toLocaleString('sv-SE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) })] }));
};
const TableCell = styled(GridTableCell) `
  color: ${({ isLink }) => (isLink ? '#fc8e49' : 'inherit')};
  text-decoration: ${({ isLink }) => (isLink ? 'underline' : 'none')};
  cursor: ${({ isLink }) => (isLink ? 'pointer' : 'inherit')};

  &:hover {
    text-decoration: none;
  }
`;
const HideOverflow = styled(TableCell) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const RightAlignContent = styled(TableCell) `
  text-align: right;
`;

const UpcomingRefundsView = () => {
    const { called, loading, data } = useUpcomingRefunds();
    const history = useHistory();
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (data && data.hasura_ledger_payments.length > 0) {
            setTableData(data.hasura_ledger_payments.map((payment) => {
                var _a, _b, _c, _d;
                return ({
                    ledger_id: payment.ledger_id,
                    policy_id: payment.hasura_ledger.hasura_policies[0].id,
                    policy_number: payment.hasura_ledger.hasura_policies[0].policy_number,
                    object_name: payment.hasura_ledger.hasura_policies[0].object_name,
                    customer_name: payment.hasura_ledger.hasura_policies[0].hasura_person
                        ? `${(_b = (_a = payment.hasura_ledger.hasura_policies[0].hasura_person) === null || _a === void 0 ? void 0 : _a.first_name) !== null && _b !== void 0 ? _b : ''} ${(_d = (_c = payment.hasura_ledger.hasura_policies[0].hasura_person) === null || _c === void 0 ? void 0 : _c.last_name) !== null && _d !== void 0 ? _d : ''}`
                        : '',
                    index: payment.index,
                    total: payment.total,
                });
            }));
        }
    }, [data]);
    const onLedgerClick = (ledgerId) => history.push(`${LEDGERS}/${ledgerId}`);
    const onPolicyClick = (policyId) => history.push(`${POLICIES}/${policyId}`);
    return (jsxs(ContentContainer, { children: [jsx("h1", { children: "Upcoming refunds" }), data && data.hasura_ledger_payments.length > 0 ? (jsx(GridTable$1, { columns: [
                    {
                        header: 'Ledger id',
                        name: 'ledger_id',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Policy',
                        name: 'policy_number',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Insured object',
                        name: 'object_name',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Customer',
                        name: 'customer_name',
                        isSortable: true,
                        type: 'string',
                    },
                    {
                        header: 'Index',
                        name: 'index',
                        isSortable: true,
                        type: 'number',
                    },
                    {
                        header: 'Amount',
                        name: 'total',
                        isSortable: true,
                        type: 'number',
                        textAlign: 'right',
                    },
                ], data: tableData, Row: TableRow, tableRowCustomProps: {
                    onLedgerClick: onLedgerClick,
                    onPolicyClick: onPolicyClick,
                }, sort: { columnName: 'policy_number', direction: 'desc' }, isLoading: called && loading, noOfLoadingRows: 10 })) : ('No upcoming refunds')] }));
};

const TasksView = () => {
    return (jsxs(ContentContainer, { children: [jsx("h1", { children: "Tasks" }), jsx(TaskSection, { children: jsx("main", { children: jsx(Tasks, { tabSize: 'medium' }) }) })] }));
};
const TaskSection = styled(Section$1) `
  main {
    border-radius: 0.5rem;
  }
`;

var RouterConfig = function RouterConfig() {
  var _useMatomo = useMatomo(),
      enableLinkTracking = _useMatomo.enableLinkTracking,
      trackPageView = _useMatomo.trackPageView;

  useEffect(function () {
    trackPageView();
  }, []);
  enableLinkTracking();
  return /*#__PURE__*/jsxs(Switch, {
    children: [global.definitions.views.find(function (view) {
      return view.name === 'createQuote';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CREATE_QUOTE,
      component: CreateQuoteView
    }), global.definitions.views.find(function (view) {
      return view.name === 'createQuoteNew';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CREATE_QUOTE_NEW,
      component: CreateQuoteViewNew
    }), global.definitions.views.find(function (view) {
      return view.name === 'createQuote';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CREATE_QUOTE_SELECT_PRODUCT,
      component: CreateQuoteView
    }), global.definitions.views.find(function (view) {
      return view.name === 'createQuoteNew';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CREATE_QUOTE_SELECT_PRODUCT_NEW,
      component: CreateQuoteViewNew
    }), global.definitions.views.find(function (view) {
      return view.name === 'customer';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CUSTOMER,
      component: CustomerView
    }), global.definitions.views.find(function (view) {
      return view.name === 'customers';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: CUSTOMERS,
      component: CustomersView
    }), global.definitions.views.find(function (view) {
      return view.name === 'ledger';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: LEDGER,
      component: LedgerView
    }), global.definitions.views.find(function (view) {
      return view.name === 'ledgers';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: LEDGERS,
      component: LedgersView
    }), global.definitions.views.find(function (view) {
      return view.name === 'ledgers';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: FAILED_REFUNDS,
      component: FailedRefundsView
    }), global.definitions.views.find(function (view) {
      return view.name === 'ledgers';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: MISSING_MANDATES,
      component: MissingMandatesView
    }), global.definitions.views.find(function (view) {
      return view.name === 'payments';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: PAYMENTS,
      component: PaymentsView
    }), global.definitions.views.find(function (view) {
      return view.name === 'policies';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: POLICIES,
      component: PoliciesView
    }), global.definitions.views.find(function (view) {
      return view.name === 'policy';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: POLICY,
      component: PolicyView
    }), global.definitions.views.find(function (view) {
      return view.name === 'recentQuotes';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: ['/', RECENT],
      component: RecentView
    }), global.definitions.views.find(function (view) {
      return view.name === 'quote';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: QUOTE,
      component: QuoteView
    }), global.definitions.views.find(function (view) {
      return view.name === 'quotes';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: QUOTES,
      component: QuotesView
    }), global.definitions.views.find(function (view) {
      return view.name === 'tasks';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: TASKS,
      component: TasksView
    }), global.definitions.views.find(function (view) {
      return view.name === 'upcomingRenewals';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: UPCOMING_RENEWALS,
      component: UpcomingRenewalsView
    }), global.definitions.views.find(function (view) {
      return view.name === 'ledgers';
    }) && /*#__PURE__*/jsx(Route, {
      exact: true,
      path: UPCOMING_REFUNDS,
      component: UpcomingRefundsView
    })]
  });
};

var _templateObject$4;

var HamburgerMenu = function HamburgerMenu(_ref) {
  var isOpen = _ref.isOpen,
      onClick = _ref.onClick;
  return /*#__PURE__*/jsxs(Hamburger, {
    isOpen: isOpen,
    onClick: onClick,
    children: [/*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {})]
  });
};

HamburgerMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
var Hamburger = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 500;\n  left: ", ";\n  top: 1rem;\n  display: flex;\n  justify-content: space-around;\n  flex-flow: column nowrap;\n  width: ", ";\n  height: ", ";\n  cursor: pointer;\n  justify-self: flex-start;\n  background-color: ", ";\n  border-radius: 50%;\n  padding: ", ";\n  opacity: 0.6;\n  box-shadow: rgba(0, 0, 0, 0.4) 0 0.25rem 1rem;\n  transition: all 0.2s;\n\n  @media (min-width: 75rem) {\n    display: none;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n\n  div {\n    width: 2rem;\n    height: 0.25rem;\n    border-radius: 10px;\n    transform-origin: 1px;\n    transition: all 0.3s linear;\n    background-color: #fff;\n\n    &:nth-child(1) {\n      transform: ", ";\n    }\n\n    &:nth-child(2) {\n      opacity: ", ";\n    }\n\n    &:nth-child(3) {\n      transform: ", ";\n    }\n  }\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? '1rem' : '1rem';
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? '2rem' : '3rem';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? '2rem' : '3rem';
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen ? 'transparent' : '#fc8e49';
}, function (_ref6) {
  var isOpen = _ref6.isOpen;
  return isOpen ? '0' : '0.5rem';
}, function (_ref7) {
  var isOpen = _ref7.isOpen;
  return isOpen ? 'rotate(45deg)' : 'rotate(0)';
}, function (_ref8) {
  var isOpen = _ref8.isOpen;
  return isOpen ? 0 : 1;
}, function (_ref9) {
  var isOpen = _ref9.isOpen;
  return isOpen ? 'rotate(-45deg)' : 'rotate(0)';
});

var _templateObject$3;
var ITEM_COUNT = gql(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  query item_count {\n    failedPayments: hasura_ledger_payments_aggregate(\n      where: {\n        hasura_ledger: { status: { _eq: \"Open\" } }\n        status: { _eq: \"Failed\" }\n      }\n    ) {\n      aggregate {\n        count\n      }\n    }\n    upcomingRefunds: hasura_ledger_payments_aggregate(\n      where: {\n        hasura_ledger: { status: { _eq: \"Open\" } }\n        status: { _eq: \"UpcomingRefundDueToAdjustment\" }\n      }\n    ) {\n      aggregate {\n        count\n      }\n    }\n    failedRefunds: hasura_ledger_payments_aggregate(\n      where: { status: { _eq: \"RefundFailed\" } }\n    ) {\n      aggregate {\n        count\n      }\n    }\n  }\n"])));

var useItemCount = function useItemCount() {
  return useQuery(ITEM_COUNT);
};

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4, _templateObject5;

var MainNavigation = function MainNavigation(_ref) {
  var logo = _ref.logo,
      signOut = _ref.signOut;

  var _useItemCount = useItemCount(),
      data = _useItemCount.data,
      refetch = _useItemCount.refetch;

  var navigationContext$1 = useContext(navigationContext);
  var isOpen = navigationContext$1.isOpen,
      setIsOpen = navigationContext$1.setIsOpen;

  var handleOnClick = function handleOnClick() {
    return setIsOpen(!isOpen);
  };

  useEffect(function () {
    var id = setInterval(function () {
      refetch();
    }, 30 * 1000);
    return function () {
      return clearInterval(id);
    };
  }, [refetch]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(NavigationContainer, {
      isOpen: isOpen,
      children: [/*#__PURE__*/jsxs(LogoContainer, {
        children: [/*#__PURE__*/jsx("img", {
          src: logo,
          alt: "logo"
        }), /*#__PURE__*/jsx("div", {
          children: "[Admin system]"
        })]
      }), /*#__PURE__*/jsx(Navigation, {
        children: /*#__PURE__*/jsxs("ul", {
          children: [global.definitions.views.find(function (view) {
            return view.name === 'recentQuotes' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: RECENT,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Recent"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'tasks' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: TASKS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Tasks"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'createQuote' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: CREATE_QUOTE_SELECT_PRODUCT,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Create quote"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'quotes' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: QUOTES,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Quotes"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'policies' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: POLICIES,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Policies"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'upcomingRenewals' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: UPCOMING_RENEWALS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Upcoming renewals"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'customers' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: CUSTOMERS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Customers"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'vtr' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: "/",
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "VTR"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'ledgers' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsxs(StyledLink, {
              to: UPCOMING_REFUNDS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: ["Upcoming refunds", data && data.upcomingRefunds.aggregate.count > 0 && /*#__PURE__*/jsx(Badge, {
                children: data.upcomingRefunds.aggregate.count < 100 ? data.upcomingRefunds.aggregate.count : '99+'
              })]
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'ledgers' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsxs(StyledLink, {
              to: LEDGERS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: ["Failed payments", data && data.failedPayments.aggregate.count > 0 && /*#__PURE__*/jsx(Badge, {
                children: data.failedPayments.aggregate.count < 100 ? data.failedPayments.aggregate.count : '99+'
              })]
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'ledgers' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsxs(StyledLink, {
              to: FAILED_REFUNDS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: ["Failed refunds", data && data.failedRefunds.aggregate.count > 0 && /*#__PURE__*/jsx(Badge, {
                children: data.failedRefunds.aggregate.count < 100 ? data.failedRefunds.aggregate.count : '99+'
              })]
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'ledgers' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: MISSING_MANDATES,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Missing mandates"
            })
          }), global.definitions.views.find(function (view) {
            return view.name === 'payments' && view.showInMenu;
          }) && /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsx(StyledLink, {
              to: PAYMENTS,
              exact: true,
              activeStyle: {
                fontWeight: '700'
              },
              children: "Payments"
            })
          }), /*#__PURE__*/jsx("li", {
            children: /*#__PURE__*/jsxs(Button$3, {
              onClick: signOut,
              children: [/*#__PURE__*/jsx(Icon, {
                iconName: "faArrowRightFromBracket"
              }), " Sign out"]
            })
          })]
        })
      })]
    }), /*#__PURE__*/jsx(HamburgerMenu, {
      isOpen: isOpen,
      onClick: handleOnClick
    })]
  });
};
var NavigationContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 100;\n  width: 15rem;\n  min-height: 100vh;\n  background-color: #252525;\n  border-right: 2px solid #353d53;\n  color: #cccccc;\n  margin-right: 1rem;\n  transform: ", ";\n  transition: transform 0.3s ease-in-out;\n\n  @media (min-width: 75rem) {\n    display: block;\n    transform: inherit;\n  }\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'translateX(0)' : 'translateX(-100%)';
});
var LogoContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  font-size: 1.5rem;\n  margin-top: 1rem;\n\n  img {\n    width: auto;\n    height: auto;\n    max-width: 9rem;\n    max-height: 3.5rem;\n    margin-bottom: 0.5rem;\n  }\n"])));
var Navigation = styled.nav(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  margin-top: 2rem;\n\n  ul {\n    list-style: none;\n    margin-bottom: 1rem;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n\n    li {\n      display: flex;\n\n      &:last-child {\n        padding-left: 1rem;\n        padding-top: 2rem;\n      }\n    }\n  }\n"])));
var StyledLink = styled(NavLink)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: #ccc;\n  text-decoration: none;\n  flex: 1;\n  padding: 0.3rem 0;\n  padding-left: 1.2rem;\n  display: flex;\n  gap: 0.5rem;\n\n  &:hover {\n    background-color: #37373d;\n  }\n"])));
var Badge = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.4rem;\n  height: 1.4rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #fff;\n  background-color: #666;\n  border-radius: 50%;\n  line-height: 1;\n"])));

var e = [],
    t = [];

function n(n, r) {
  if (n && "undefined" != typeof document) {
    var a,
        s = !0 === r.prepend ? "prepend" : "append",
        d = !0 === r.singleTag,
        i = "string" == typeof r.container ? document.querySelector(r.container) : document.getElementsByTagName("head")[0];

    if (d) {
      var u = e.indexOf(i);
      -1 === u && (u = e.push(i) - 1, t[u] = {}), a = t[u] && t[u][s] ? t[u][s] : t[u][s] = c();
    } else a = c();

    65279 === n.charCodeAt(0) && (n = n.substring(1)), a.styleSheet ? a.styleSheet.cssText += n : a.appendChild(document.createTextNode(n));
  }

  function c() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), r.attributes) for (var t = Object.keys(r.attributes), n = 0; n < t.length; n++) e.setAttribute(t[n], r.attributes[t[n]]);
    var a = "prepend" === s ? "afterbegin" : "beforeend";
    return i.insertAdjacentElement(a, e), e;
  }
}

var css = ".react-datepicker-wrapper,\n.react-datepicker__input-container,\n.react-datepicker__input-container input {\n  display: block;\n  width: 100%;\n}\n\n.react-datepicker__input-container input {\n  font-size: 1.5rem;\n  padding: 0.5rem;\n}\n\n.react-datepicker__input-container input:read-only {\n  opacity: 0.5;\n}\n\n.react-datepicker__input-container input.default {\n  font-size: 1rem;\n  padding: 0 0.1875rem;\n  border-width: 1px;\n}\n\n.react-datepicker__input-container input.task-item {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #7b7d8c;\n  width: 5rem;\n  border: 0;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.react-datepicker__input-container input.alert {\n  color: #f34040;\n}\n";
n(css,{});

var _templateObject$1;
var SidePanel = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  width: ", ";\n  background-color: #fff;\n  border-left: 0.0625rem solid #dedede;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-shadow: rgb(0 0 0 / 40%) 0 0.25rem 1rem;\n  z-index: 100;\n  transition: 0.5s;\n\n  header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 0.0625rem solid #dedede;\n    padding: 0.3rem;\n\n    div {\n      cursor: pointer;\n    }\n  }\n\n  main {\n    padding: 0.5rem;\n  }\n"])), function (_ref) {
  var show = _ref.show;
  return show ? '25rem' : 0;
});

var RightPanel = function RightPanel() {
  var _useRightPanel = useRightPanel(),
      content = _useRightPanel.content,
      show = _useRightPanel.show,
      hidePanel = _useRightPanel.hidePanel;

  return /*#__PURE__*/jsxs(SidePanel, {
    show: show,
    children: [/*#__PURE__*/jsxs("header", {
      children: [/*#__PURE__*/jsx("h3", {
        children: content.header && content.header
      }), /*#__PURE__*/jsx(IconButton, {
        onClick: hidePanel,
        children: /*#__PURE__*/jsx(Icon, {
          iconName: "faTimes"
        })
      })]
    }), /*#__PURE__*/jsx("main", {
      children: content.body && content.body
    })]
  });
};

var _templateObject, _templateObject2, _templateObject3;
configureAmplify({
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  mandatorySignIn: true,
  endpointName: 'KrakenAPI',
  endpointUrl: process.env.REACT_APP_AWS_ENDPOINT_URL
});
registerLocale('sv', sv);
var matomoInstance = createInstance({
  urlBase: 'https://eirforsakring.matomo.cloud',
  siteId: process.env.REACT_APP_MATOMO_SITE_ID || 9999
});
var components = {
  Header: function Header() {
    return /*#__PURE__*/jsxs(LoginHeader, {
      children: [/*#__PURE__*/jsx("img", {
        src: "https://images.squarespace-cdn.com/content/v1/5f6084124b9cf634f3a57d02/1600164389802-4N72NHPC9SL0FUKD6IX9/eir-logo-2.png?format=1500w",
        alt: "Eir Admin"
      }), /*#__PURE__*/jsx("h1", {
        children: "Admin"
      })]
    });
  }
};

var App = function App(_ref) {
  var logo = _ref.logo;
  var httpLink = createHttpLink({
    uri: "".concat(process.env.REACT_APP_AWS_ENDPOINT_URL, "graphql/v1/graphql")
  });
  var authLink = setContext(function (_, _ref2) {
    var headers = _ref2.headers;
    var token = localStorage.getItem('authToken');
    return {
      headers: _objectSpread2(_objectSpread2({}, headers), {}, {
        authorization: token ? "Bearer ".concat(token) : ''
      })
    };
  });
  var errorLink = onError(function (_ref3) {
    var graphQLErrors = _ref3.graphQLErrors,
        networkError = _ref3.networkError,
        operation = _ref3.operation,
        forward = _ref3.forward;

    if (graphQLErrors) {
      var _iterator = _createForOfIteratorHelper(graphQLErrors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var err = _step.value;

          switch (err.extensions.code) {
            case 'invalid-headers':
            case 'invalid-jwt':
            case 'access-denied':
              return fromPromise(checkAuthState().catch(function (error) {
                return;
              })).flatMap(function () {
                var oldHeaders = operation.getContext().headers;
                var token = localStorage.getItem('authToken');
                operation.setContext({
                  headers: _objectSpread2(_objectSpread2({}, oldHeaders), {}, {
                    authorization: token ? "Bearer ".concat(token) : ''
                  })
                });
                return forward(operation);
              });

            default:
              return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (networkError) {
      console.log("Network error: ".concat(networkError));
    }
  });
  var links = ApolloLink.from([authLink, errorLink, httpLink]);
  var client = new ApolloClient({
    link: links,
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            hasura_ledger_payments: {
              merge: function merge() {
                var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var incoming = arguments.length > 1 ? arguments[1] : undefined;
                return [].concat(_toConsumableArray(existing), _toConsumableArray(incoming));
              }
            }
          }
        }
      }
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Helmet, {
      children: /*#__PURE__*/jsx("link", {
        rel: "stylesheet",
        type: "text/css",
        href: "https://d2l0gvltru79ov.cloudfront.net/css/eir-partners-fonts-roboto.css"
      })
    }), /*#__PURE__*/jsx(GlobalStyle, {}), /*#__PURE__*/jsx(Authenticator, {
      hideSignUp: true,
      components: components,
      children: function children(_ref4) {
        var signOut = _ref4.signOut;
            _ref4.user;
        return /*#__PURE__*/jsx(ApolloProvider, {
          client: client,
          children: /*#__PURE__*/jsx(MatomoProvider, {
            value: matomoInstance,
            children: /*#__PURE__*/jsx(OverlayProvider, {
              children: /*#__PURE__*/jsx(AlertProvider, {
                children: /*#__PURE__*/jsx(NotificationProvider, {
                  children: /*#__PURE__*/jsx(RightPanelProvider, {
                    children: /*#__PURE__*/jsx(NavigationState, {
                      children: /*#__PURE__*/jsxs(LedgerState, {
                        children: [/*#__PURE__*/jsxs(BrowserRouter, {
                          children: [/*#__PURE__*/jsxs(PageWrapper, {
                            children: [/*#__PURE__*/jsx(MainNavigation, {
                              logo: logo,
                              signOut: signOut
                            }), /*#__PURE__*/jsx(Main, {
                              children: /*#__PURE__*/jsx(RouterConfig, {})
                            })]
                          }), /*#__PURE__*/jsx(RightPanel, {})]
                        }), /*#__PURE__*/jsx(Alert, {}), /*#__PURE__*/jsx(Overlay, {}), /*#__PURE__*/jsx(Notifications, {})]
                      })
                    })
                  })
                })
              })
            })
          })
        });
      }
    })]
  });
};
var PageWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Main = styled.main(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: 0 2rem;\n\n  @media (min-width: 75rem) {\n    margin-left: 15rem;\n  }\n"])));
var LoginHeader = styled.header(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: center;\n  margin-top: 3rem;\n\n  img {\n    width: 6rem;\n    height: auto;\n  }\n"])));

export { App as AdminApp };
